/////////////////////////////////////////////////////////
// Configurations related to listing.                  //
// Main configuration here is the extended data config //
/////////////////////////////////////////////////////////

// Note: The listingFields come from listingFields asset nowadays by default.
//       To use this built-in configuration, you need to change the overwrite from configHelper.js
//       (E.g. use mergeDefaultTypesAndFieldsForDebugging func)

/**
 * Configuration options for listing fields (custom extended data fields):
 * - key:                           Unique key for the extended data field.
 * - scope (optional):              Scope of the extended data can be either 'public' or 'private'.
 *                                  Default value: 'public'.
 *                                  Note: listing doesn't support 'protected' scope atm.
 * - schemaType (optional):         Schema for this extended data field.
 *                                  This is relevant when rendering components and querying listings.
 *                                  Possible values: 'enum', 'multi-enum', 'text', 'long', 'boolean'.
 * - enumOptions (optional):        Options shown for 'enum' and 'multi-enum' extended data.
 *                                  These are used to render options for inputs and filters on
 *                                  EditListingPage, ListingPage, and SearchPage.
 * - listingTypeConfig (optional):  Relationship configuration against listing types.
 *   - limitToListingTypeIds:         Indicator whether this listing field is relevant to a limited set of listing types.
 *   - listingTypeIds:                An array of listing types, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToListingTypeIds is true.
 * - categoryConfig (optional):     Relationship configuration against categories.
 *   - limitToCategoryIds:            Indicator whether this listing field is relevant to a limited set of categories.
 *   - categoryIds:                   An array of categories, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToCategoryIds is true.
 * - filterConfig:                  Filter configuration for listings query.
 *    - indexForSearch (optional):    If set as true, it is assumed that the extended data key has
 *                                    search index in place. I.e. the key can be used to filter
 *                                    listing queries (then scope needs to be 'public').
 *                                    Note: Flex CLI can be used to set search index for the key:
 *                                    https://www.sharetribe.com/docs/references/extended-data/#search-schema
 *                                    Read more about filtering listings with public data keys from API Reference:
 *                                    https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
 *                                    Default value: false,
 *   - filterType:                    Sometimes a single schemaType can be rendered with different filter components.
 *                                    For 'enum' schema, filterType can be 'SelectSingleFilter' or 'SelectMultipleFilter'
 *   - label:                         Label for the filter, if the field can be used as query filter
 *   - searchMode (optional):         Search mode for indexed data with multi-enum schema.
 *                                    Possible values: 'has_all' or 'has_any'.
 *   - group:                         SearchPageWithMap has grouped filters. Possible values: 'primary' or 'secondary'.
 * - showConfig:                    Configuration for rendering listing. (How the field should be shown.)
 *   - label:                         Label for the saved data.
 *   - isDetail                       Can be used to hide detail row (of type enum, boolean, or long) from listing page.
 *                                    Default value: true,
 * - saveConfig:                    Configuration for adding and modifying extended data fields.
 *   - label:                         Label for the input field.
 *   - placeholderMessage (optional): Default message for user input.
 *   - isRequired (optional):         Is the field required for providers to fill
 *   - requiredMessage (optional):    Message for those fields, which are mandatory.
 */
export const listingFields = [
  // {
  //   "scope": "public",
  //   "label": "Gears",
  //   "key": "gears",
  //   "schemaType": "long",
  //   "numberConfig": {
  //     "minimum": 1,
  //     "maximum": 24
  //   },
  //   "filterConfig": {
  //     "indexForSearch": true,
  //     "group": "primary",
  //     "label": "Gears"
  //   }
  // }
  // {
  //   key: 'bikeType',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'city-bikes', label: 'City bikes' },
  //     { option: 'electric-bikes', label: 'Electric bikes' },
  //     { option: 'mountain-bikes', label: 'Mountain bikes' },
  //     { option: 'childrens-bikes', label: "Children's bikes" },
  //   ],
  //   categoryConfig: {
  //     limitToCategoryIds: true,
  //     categoryIds: ['cats'],
  //   },
  //   filterConfig: {
  //     indexForSearch: true,
  //     filterType: 'SelectMultipleFilter', //'SelectSingleFilter',
  //     label: 'Bike type',
  //     group: 'primary',
  //   },
  //   showConfig: {
  //     label: 'Bike type',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Bike type',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a bike type.',
  //   },
  // },
  // {
  //   key: 'tire',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: '29', label: '29' },
  //     { option: '28', label: '28' },
  //     { option: '27', label: '27' },
  //     { option: '26', label: '26' },
  //     { option: '24', label: '24' },
  //     { option: '20', label: '20' },
  //     { option: '18', label: '18' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Tire size',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Tire size',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Tire size',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a tire size.',
  //   },
  // },
  // {
  //   key: 'brand',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'cube', label: 'Cube' },
  //     { option: 'diamant', label: 'Diamant' },
  //     { option: 'ghost', label: 'GHOST' },
  //     { option: 'giant', label: 'Giant' },
  //     { option: 'kalkhoff', label: 'Kalkhoff' },
  //     { option: 'kona', label: 'Kona' },
  //     { option: 'otler', label: 'Otler' },
  //     { option: 'vermont', label: 'Vermont' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Brand',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Brand',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Brand',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a brand.',
  //   },
  // },
  // {
  //   key: 'accessories',
  //   scope: 'public',
  //   schemaType: 'multi-enum',
  //   enumOptions: [
  //     { option: 'bell', label: 'Bell' },
  //     { option: 'lights', label: 'Lights' },
  //     { option: 'lock', label: 'Lock' },
  //     { option: 'mudguard', label: 'Mudguard' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Accessories',
  //     searchMode: 'has_all',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Accessories',
  //   },
  //   saveConfig: {
  //     label: 'Accessories',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: false,
  //   },
  // },
  // // An example of how to use transaction type specific custom fields and private data.
  // {
  //   key: 'note',
  //   scope: 'public',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['product-selling'],
  //   },
  //   showConfig: {
  //     label: 'Extra notes',
  //   },
  //   saveConfig: {
  //     label: 'Extra notes',
  //     placeholderMessage: 'Some public extra note about this bike...',
  //   },
  // },
  // {
  //   key: 'privatenote',
  //   scope: 'private',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['daily-booking'],
  //   },
  //   saveConfig: {
  //     label: 'Private notes',
  //     placeholderMessage: 'Some private note about this bike...',
  //   },
  // },
];

const bikeBrands = [
  {
    name: '3T',
    id: '3t',
    subcategories: [],
  },
  {
    name: 'ALDO',
    id: 'aldo',
    subcategories: [],
  },
  {
    name: 'ALPINA',
    id: 'alpina',
    subcategories: [],
  },
  {
    name: 'ALTEC',
    id: 'altec',
    subcategories: [],
  },
  {
    name: 'ALTRA',
    id: 'altra',
    subcategories: [],
  },
  {
    name: 'APOLLO',
    id: 'apollo',
    subcategories: [],
  },
  {
    name: 'ARGON 18',
    id: 'argon-18',
    subcategories: [],
  },
  {
    name: 'ARGONAUT',
    id: 'argonaut',
    subcategories: [],
  },
  {
    name: 'ATLAS',
    id: 'atlas',
    subcategories: [],
  },
  {
    name: 'AURUM',
    id: 'aurum',
    subcategories: [],
  },
  {
    name: 'AVALON',
    id: 'avalon',
    subcategories: [],
  },
  {
    name: 'AVANTI',
    id: 'avanti',
    subcategories: [],
  },
  {
    name: 'AVANTIO',
    id: 'avantio',
    subcategories: [],
  },
  {
    name: 'AVON',
    id: 'avon',
    subcategories: [],
  },
  {
    name: 'AZOR',
    id: 'azor',
    subcategories: [],
  },
  {
    name: 'BARBIE',
    id: 'barbie',
    subcategories: [],
  },
  {
    name: 'BASSO',
    id: 'basso',
    subcategories: [],
  },
  {
    name: 'BASTION',
    id: 'bastion',
    subcategories: [],
  },
  {
    name: 'BATAVUS',
    id: 'batavus',
    subcategories: [],
  },
  {
    name: 'BATTAGLIN',
    id: 'battaglin',
    subcategories: [],
  },
  {
    name: 'BELLE',
    id: 'belle',
    subcategories: [],
  },
  {
    name: 'BERGAMONT',
    id: 'bergamont',
    subcategories: [],
  },
  {
    name: 'BH',
    id: 'bh',
    subcategories: [],
  },
  {
    name: 'BIANCHI',
    id: 'bianchi',
    subcategories: [],
  },
  {
    name: 'BIKKEL',
    id: 'bikkel',
    subcategories: [],
  },
  {
    name: 'BLUEY',
    id: 'bluey',
    subcategories: [],
  },
  {
    name: 'BMC',
    id: 'bmc',
    subcategories: [],
  },
  {
    name: 'BOARDMAN',
    id: 'boardman',
    subcategories: [],
  },
  {
    name: 'BOBIKE',
    id: 'bobike',
    subcategories: [],
  },
  {
    name: 'BOMBTRACK',
    id: 'bombtrack',
    subcategories: [],
  },
  {
    name: 'BOTTECCHIA',
    id: 'bottecchia',
    subcategories: [],
  },
  {
    name: 'BRINCKERS',
    id: 'brinckers',
    subcategories: [],
  },
  {
    name: 'BROMPTON',
    id: 'brompton',
    subcategories: [],
  },
  {
    name: 'BSA CYCLES',
    id: 'bsa-cycles',
    subcategories: [],
  },
  {
    name: 'BSP',
    id: 'bsp',
    subcategories: [],
  },
  {
    name: 'BT-WIN',
    id: 'bt-win',
    subcategories: [],
  },
  {
    name: 'CA GO BIKE',
    id: 'ca-go-bike',
    subcategories: [],
  },
  {
    name: 'CANNONDALE',
    id: 'cannondale',
    subcategories: [],
  },
  {
    name: 'CANYON',
    id: 'canyon',
    subcategories: [],
  },
  {
    name: 'CEEPO',
    id: 'ceepo',
    subcategories: [],
  },
  {
    name: 'CELL',
    id: 'cell',
    subcategories: [],
  },
  {
    name: 'CERVELO',
    id: 'cervelo',
    subcategories: [],
  },
  {
    name: 'CHAPTER 2',
    id: 'chapter-2',
    subcategories: [],
  },
  {
    name: 'CHARACTER',
    id: 'character',
    subcategories: [],
  },
  {
    name: 'CINELLI',
    id: 'cinelli',
    subcategories: [],
  },
  {
    name: 'CIPOLLINI',
    id: 'cipollini',
    subcategories: [],
  },
  {
    name: 'CLAUD BUTLER',
    id: 'claud-butler',
    subcategories: [],
  },
  {
    name: 'COLNAGO',
    id: 'colnago',
    subcategories: [],
  },
  {
    name: 'CONDOR',
    id: 'condor',
    subcategories: [],
  },
  {
    name: 'CONVOLUTION',
    id: 'convolution',
    subcategories: [],
  },
  {
    name: 'CORRATEC',
    id: 'corratec',
    subcategories: [],
  },
  {
    name: 'CORTINA',
    id: 'cortina',
    subcategories: [],
  },
  {
    name: 'COSMIC',
    id: 'cosmic',
    subcategories: [],
  },
  {
    name: 'COTIC',
    id: 'cotic',
    subcategories: [],
  },
  {
    name: 'CRADIAC',
    id: 'cradiac',
    subcategories: [],
  },
  {
    name: 'CRÈME',
    id: 'creme',
    subcategories: [],
  },
  {
    name: 'CRUZEE',
    id: 'cruzee',
    subcategories: [],
  },
  {
    name: 'CUBE',
    id: 'cube',
    subcategories: [],
  },
  {
    name: 'CUMBERLAND',
    id: 'cumberland',
    subcategories: [],
  },
  {
    name: 'DAHON',
    id: 'dahon',
    subcategories: [],
  },
  {
    name: 'DARE',
    id: 'dare',
    subcategories: [],
  },
  {
    name: 'DARTMOOR BIKES',
    id: 'dartmoor-bikes',
    subcategories: [],
  },
  {
    name: 'DAWES',
    id: 'dawes',
    subcategories: [],
  },
  {
    name: 'DE ROSA',
    id: 'de-rosa',
    subcategories: [],
  },
  {
    name: 'DIAMANT',
    id: 'diamant',
    subcategories: [],
  },
  {
    name: 'DIVERSE',
    id: 'diverse',
    subcategories: [],
  },
  {
    name: 'DMR',
    id: 'dmr',
    subcategories: [],
  },
  {
    name: 'DOLAN',
    id: 'dolan',
    subcategories: [],
  },
  {
    name: 'DOSNOVENTA',
    id: 'dosnoventa',
    subcategories: [],
  },
  {
    name: 'EDDY MERCKX',
    id: 'eddy-merckx',
    subcategories: [],
  },
  {
    name: 'ELEMENT',
    id: 'element',
    subcategories: [],
  },
  {
    name: 'EMOTORAD',
    id: 'emotorad',
    subcategories: [],
  },
  {
    name: 'ENIGMA',
    id: 'enigma',
    subcategories: [],
  },
  {
    name: 'ENVE',
    id: 'enve',
    subcategories: [],
  },
  {
    name: 'EVO',
    id: 'evo',
    subcategories: [],
  },
  {
    name: 'FACTOR',
    id: 'factor',
    subcategories: [],
  },
  {
    name: 'FAIRLIGHT',
    id: 'fairlight',
    subcategories: [],
  },
  {
    name: 'FALCON',
    id: 'falcon',
    subcategories: [],
  },
  {
    name: 'FALKENJAGD',
    id: 'falkenjagd',
    subcategories: [],
  },
  {
    name: 'FANTOM',
    id: 'fantom',
    subcategories: [],
  },
  {
    name: 'FARA CYCLING',
    id: 'fara-cycling',
    subcategories: [],
  },
  {
    name: 'FELT',
    id: 'felt',
    subcategories: [],
  },
  {
    name: 'FESTKA',
    id: 'festka',
    subcategories: [],
  },
  {
    name: 'FIFTYONE',
    id: 'fiftyone',
    subcategories: [],
  },
  {
    name: 'FIREFOX',
    id: 'firefox',
    subcategories: [],
  },
  {
    name: 'FIT BIKE CO',
    id: 'fit-bike-co',
    subcategories: [],
  },
  {
    name: 'FLYER',
    id: 'flyer',
    subcategories: [],
  },
  {
    name: 'FOCUS',
    id: 'focus',
    subcategories: [],
  },
  {
    name: 'FOMAS',
    id: 'fomas',
    subcategories: [],
  },
  {
    name: 'FONDRIEST',
    id: 'fondriest',
    subcategories: [],
  },
  {
    name: 'FROG',
    id: 'frog',
    subcategories: [],
  },
  {
    name: 'FUJI',
    id: 'fuji',
    subcategories: [],
  },
  {
    name: 'GAZELLE',
    id: 'gazelle',
    subcategories: [],
  },
  {
    name: 'GENESIS',
    id: 'genesis',
    subcategories: [],
  },
  {
    name: 'GHOST',
    id: 'ghost',
    subcategories: [],
  },
  {
    name: 'GIANT',
    id: 'giant',
    subcategories: [],
  },
  {
    name: 'GITANE',
    id: 'gitane',
    subcategories: [],
  },
  {
    name: 'GRANVILLE',
    id: 'granville',
    subcategories: [],
  },
  {
    name: 'GT',
    id: 'gt',
    subcategories: [],
  },
  {
    name: 'HAIBIKE',
    id: 'haibike',
    subcategories: [],
  },
  {
    name: 'HERCULES',
    id: 'hercules',
    subcategories: [],
  },
  {
    name: 'HERO CYCLES',
    id: 'hero-cycles',
    subcategories: [],
  },
  {
    name: 'HERO LECTRO',
    id: 'hero-lectro',
    subcategories: [],
  },
  {
    name: 'HOLLANDIA',
    id: 'hollandia',
    subcategories: [],
  },
  {
    name: 'HP',
    id: 'hp',
    subcategories: [],
  },
  {
    name: 'HUGE',
    id: 'huge',
    subcategories: [],
  },
  {
    name: 'J.LAVERACK',
    id: 'j-laverack',
    subcategories: [],
  },
  {
    name: 'JAMIS',
    id: 'jamis',
    subcategories: [],
  },
  {
    name: 'JAVA',
    id: 'java',
    subcategories: [],
  },
  {
    name: 'JD BUG',
    id: 'jd-bug',
    subcategories: [],
  },
  {
    name: 'JOHNNY LOCO',
    id: 'johnny-loco',
    subcategories: [],
  },
  {
    name: 'KALKHOFF',
    id: 'kalkhoff',
    subcategories: [],
  },
  {
    name: 'KINESIS',
    id: 'kinesis',
    subcategories: [],
  },
  {
    name: 'KOGA',
    id: 'koga',
    subcategories: [],
  },
  {
    name: 'KONA',
    id: 'kona',
    subcategories: [],
  },
  {
    name: 'KTM',
    id: 'ktm',
    subcategories: [],
  },
  {
    name: 'KU',
    id: 'ku',
    subcategories: [],
  },
  {
    name: 'LAMBRETTA',
    id: 'lambretta',
    subcategories: [],
  },
  {
    name: 'LAPIERRE',
    id: 'lapierre',
    subcategories: [],
  },
  {
    name: 'LA-SOVEREIGN',
    id: 'la-sovereign',
    subcategories: [],
  },
  {
    name: 'LAUF',
    id: 'lauf',
    subcategories: [],
  },
  {
    name: 'LEADER',
    id: 'leader',
    subcategories: [],
  },
  {
    name: 'LEITNER',
    id: 'leitner',
    subcategories: [],
  },
  {
    name: 'LIV',
    id: 'liv',
    subcategories: [],
  },
  {
    name: 'LOEKIE',
    id: 'loekie',
    subcategories: [],
  },
  {
    name: 'LOOK',
    id: 'look',
    subcategories: [],
  },
  {
    name: 'MACH CITY',
    id: 'mach-city',
    subcategories: [],
  },
  {
    name: 'MADD GEAR',
    id: 'madd-gear',
    subcategories: [],
  },
  {
    name: 'MALVERN STAR',
    id: 'malvern-star',
    subcategories: [],
  },
  {
    name: 'MARIN',
    id: 'marin',
    subcategories: [],
  },
  {
    name: 'MASON',
    id: 'mason',
    subcategories: [],
  },
  {
    name: 'MERIDA',
    id: 'merida',
    subcategories: [],
  },
  {
    name: 'MONGOOSE',
    id: 'mongoose',
    subcategories: [],
  },
  {
    name: 'MONTEGO',
    id: 'montego',
    subcategories: [],
  },
  {
    name: 'MONTRA',
    id: 'montra',
    subcategories: [],
  },
  {
    name: 'MOONRAKER',
    id: 'moonraker',
    subcategories: [],
  },
  {
    name: 'MOOTS',
    id: 'moots',
    subcategories: [],
  },
  {
    name: 'MUDDYFOX',
    id: 'muddyfox',
    subcategories: [],
  },
  {
    name: 'NORCO',
    id: 'norco',
    subcategories: [],
  },
  {
    name: 'NORTA',
    id: 'norta',
    subcategories: [],
  },
  {
    name: 'NS',
    id: 'ns',
    subcategories: [],
  },
  {
    name: 'NUZE',
    id: 'nuze',
    subcategories: [],
  },
  {
    name: 'OMO',
    id: 'omo',
    subcategories: [],
  },
  {
    name: 'OPEN',
    id: 'open',
    subcategories: [],
  },
  {
    name: 'ORBEA',
    id: 'orbea',
    subcategories: [],
  },
  {
    name: 'ORRO',
    id: 'orro',
    subcategories: [],
  },
  {
    name: 'OSTRICHOO',
    id: 'ostrichoo',
    subcategories: [],
  },
  {
    name: 'PACTO',
    id: 'pacto',
    subcategories: [],
  },
  {
    name: 'PARAPERA',
    id: 'parapera',
    subcategories: [],
  },
  {
    name: 'PARDUS',
    id: 'pardus',
    subcategories: [],
  },
  {
    name: 'PASHLEY',
    id: 'pashley',
    subcategories: [],
  },
  {
    name: 'PASSONI',
    id: 'passoni',
    subcategories: [],
  },
  {
    name: 'PEGASUS',
    id: 'pegasus',
    subcategories: [],
  },
  {
    name: 'PEUGEOT',
    id: 'peugeot',
    subcategories: [],
  },
  {
    name: 'PHEONIX',
    id: 'pheonix',
    subcategories: [],
  },
  {
    name: 'PINARELLO',
    id: 'pinarello',
    subcategories: [],
  },
  {
    name: 'PINNACLE',
    id: 'pinnacle',
    subcategories: [],
  },
  {
    name: 'PLANET X',
    id: 'planet-x',
    subcategories: [],
  },
  {
    name: 'POINTER',
    id: 'pointer',
    subcategories: [],
  },
  {
    name: 'POLYGON',
    id: 'polygon',
    subcategories: [],
  },
  {
    name: 'POPAI',
    id: 'popai',
    subcategories: [],
  },
  {
    name: 'POPAL',
    id: 'popal',
    subcategories: [],
  },
  {
    name: 'POSST',
    id: 'posst',
    subcategories: [],
  },
  {
    name: 'PUCH',
    id: 'puch',
    subcategories: [],
  },
  {
    name: 'PUKY',
    id: 'puky',
    subcategories: [],
  },
  {
    name: 'PURE',
    id: 'pure',
    subcategories: [],
  },
  {
    name: 'QUIC',
    id: 'quic',
    subcategories: [],
  },
  {
    name: 'QWIC',
    id: 'qwic',
    subcategories: [],
  },
  {
    name: 'RADON',
    id: 'radon',
    subcategories: [],
  },
  {
    name: 'RALEIGH',
    id: 'raleigh',
    subcategories: [],
  },
  {
    name: 'RASCAL',
    id: 'rascal',
    subcategories: [],
  },
  {
    name: 'REBEL KIDZ',
    id: 'rebel-kidz',
    subcategories: [],
  },
  {
    name: 'REID',
    id: 'reid',
    subcategories: [],
  },
  {
    name: 'REILLY',
    id: 'reilly',
    subcategories: [],
  },
  {
    name: 'RELIANCE',
    id: 'reliance',
    subcategories: [],
  },
  {
    name: 'RENNSTAHL',
    id: 'rennstahl',
    subcategories: [],
  },
  {
    name: 'RIBBLE',
    id: 'ribble',
    subcategories: [],
  },
  {
    name: 'RIDGEBACK',
    id: 'ridgeback',
    subcategories: [],
  },
  {
    name: 'RIDLEY',
    id: 'ridley',
    subcategories: [],
  },
  {
    name: 'RIESE AND MULLER',
    id: 'riese-and-muller',
    subcategories: [],
  },
  {
    name: 'ROCKFIRE',
    id: 'rockfire',
    subcategories: [],
  },
  {
    name: 'ROCKY MOUNTAIN',
    id: 'rocky-mountain',
    subcategories: [],
  },
  {
    name: 'RONDO',
    id: 'rondo',
    subcategories: [],
  },
  {
    name: 'ROSE',
    id: 'rose',
    subcategories: [],
  },
  {
    name: 'ROURKE',
    id: 'rourke',
    subcategories: [],
  },
  {
    name: 'SALSA',
    id: 'salsa',
    subcategories: [],
  },
  {
    name: 'SANTA CRUZ',
    id: 'santa-cruz',
    subcategories: [],
  },
  {
    name: 'SANTA FIXIE',
    id: 'santa-fixie',
    subcategories: [],
  },
  {
    name: 'SCHNELL',
    id: 'schnell',
    subcategories: [],
  },
  {
    name: 'SCHWINN',
    id: 'schwinn',
    subcategories: [],
  },
  {
    name: 'SCOR',
    id: 'scor',
    subcategories: [],
  },
  {
    name: 'SCOTT',
    id: 'scott',
    subcategories: [],
  },
  {
    name: 'SENSA',
    id: 'sensa',
    subcategories: [],
  },
  {
    name: 'SHOTGUN',
    id: 'shotgun',
    subcategories: [],
  },
  {
    name: 'SIMPLON',
    id: 'simplon',
    subcategories: [],
  },
  {
    name: 'SPARTA',
    id: 'sparta',
    subcategories: [],
  },
  {
    name: 'SPECIALIZED',
    id: 'specialized',
    subcategories: [],
  },
  {
    name: 'SPIRIT',
    id: 'spirit',
    subcategories: [],
  },
  {
    name: 'SPOON CUSTOMS',
    id: 'spoon-customs',
    subcategories: [],
  },
  {
    name: 'SQUISH',
    id: 'squish',
    subcategories: [],
  },
  {
    name: 'STANDERT',
    id: 'standert',
    subcategories: [],
  },
  {
    name: 'STELLA',
    id: 'stella',
    subcategories: [],
  },
  {
    name: 'STEVENS',
    id: 'stevens',
    subcategories: [],
  },
  {
    name: 'STUDIO',
    id: 'studio',
    subcategories: [],
  },
  {
    name: 'STURDY',
    id: 'sturdy',
    subcategories: [],
  },
  {
    name: 'SULLIVAN',
    id: 'sullivan',
    subcategories: [],
  },
  {
    name: 'SUNCROSS',
    id: 'suncross',
    subcategories: [],
  },
  {
    name: 'SURLY',
    id: 'surly',
    subcategories: [],
  },
  {
    name: 'S-WORKS',
    id: 's-works',
    subcategories: [],
  },
  {
    name: 'TERN',
    id: 'tern',
    subcategories: [],
  },
  {
    name: 'TIFOSI',
    id: 'tifosi',
    subcategories: [],
  },
  {
    name: 'TIME',
    id: 'time',
    subcategories: [],
  },
  {
    name: 'TOUT',
    id: 'tout',
    subcategories: [],
  },
  {
    name: 'TREK',
    id: 'trek',
    subcategories: [],
  },
  {
    name: 'TRIAD',
    id: 'triad',
    subcategories: [],
  },
  {
    name: 'TRIFOX',
    id: 'trifox',
    subcategories: [],
  },
  {
    name: 'TWITTER',
    id: 'twitter',
    subcategories: [],
  },
  {
    name: 'UNION',
    id: 'union',
    subcategories: [],
  },
  {
    name: 'UNIROX',
    id: 'unirox',
    subcategories: [],
  },
  {
    name: 'UNITED',
    id: 'united',
    subcategories: [],
  },
  {
    name: 'URBAN TERRAIN',
    id: 'urban-terrain',
    subcategories: [],
  },
  {
    name: 'VAN NICHOLAS',
    id: 'van-nicholas',
    subcategories: [],
  },
  {
    name: 'VANRYSEL',
    id: 'vanrysel',
    subcategories: [],
  },
  {
    name: 'VELOCE',
    id: 'veloce',
    subcategories: [],
  },
  {
    name: 'VIBE',
    id: 'vibe',
    subcategories: [],
  },
  {
    name: 'VICTORIA',
    id: 'victoria',
    subcategories: [],
  },
  {
    name: 'VIELO',
    id: 'vielo',
    subcategories: [],
  },
  {
    name: 'VOGUE',
    id: 'vogue',
    subcategories: [],
  },
  {
    name: 'WABI CYCLES',
    id: 'wabi-cycles',
    subcategories: [],
  },
  {
    name: 'WALTX',
    id: 'waltx',
    subcategories: [],
  },
  {
    name: 'WHYTE',
    id: 'whyte',
    subcategories: [],
  },
  {
    name: 'WILIER',
    id: 'wilier',
    subcategories: [],
  },
  {
    name: 'WINDSPACE',
    id: 'windspace',
    subcategories: [],
  },
  {
    name: 'XDS',
    id: 'xds',
    subcategories: [],
  },
  {
    name: 'YETI',
    id: 'yeti',
    subcategories: [],
  },
];

export const listingBrands = [
  {
    key: 'Helmets',
    enumOptions: [
      { option: '100_percent', label: '100 Percent' },
      { option: '7idp', label: '7idp' },
      { option: 'abus', label: 'Abus' },
      { option: 'alpina', label: 'Alpina' },
      { option: 'altura', label: 'Altura' },
      { option: 'assos', label: 'Assos' },
      { option: 'bbb', label: 'Bbb' },
      { option: 'bell', label: 'Bell' },
      { option: 'bern', label: 'Bern' },
      { option: 'bluegrass', label: 'Bluegrass' },
      { option: 'boardman', label: 'Boardman' },
      { option: 'bolle', label: 'Bolle' },
      { option: 'bontrager', label: 'Bontrager' },
      { option: 'briko', label: 'Briko' },
      { option: 'bt_win', label: 'Bt-win' },
      { option: 'cannondale', label: 'Cannondale' },
      { option: 'casco', label: 'Casco' },
      { option: 'catlike', label: 'Catlike' },
      { option: 'closca', label: 'Closca' },
      { option: 'coros', label: 'Coros' },
      { option: 'cratoni', label: 'Cratoni' },
      { option: 'cube', label: 'Cube' },
      { option: 'dare2b', label: 'Dare2b' },
      { option: 'dhb', label: 'Dhb' },
      { option: 'disney', label: 'Disney' },
      { option: 'dotout', label: 'Dotout' },
      { option: 'dunlop', label: 'Dunlop' },
      { option: 'ecohelmet', label: 'Ecohelmet' },
      { option: 'ekoi', label: 'Ekoi' },
      { option: 'electra', label: 'Electra' },
      { option: 'endura', label: 'Endura' },
      { option: 'evans', label: 'Evans' },
      { option: 'fila', label: 'Fila' },
      { option: 'firefox', label: 'Firefox' },
      { option: 'flr', label: 'Flr' },
      { option: 'fox', label: 'Fox' },
      { option: 'fox_racing_shox', label: 'Fox Racing Shox' },
      { option: 'funkier', label: 'Funkier' },
      { option: 'garneau', label: 'Garneau' },
      { option: 'giant', label: 'Giant' },
      { option: 'giro', label: 'Giro' },
      { option: 'gist', label: 'Gist' },
      { option: 'gvr', label: 'Gvr' },
      { option: 'halfords', label: 'Halfords' },
      { option: 'harsh_protective', label: 'Harsh Protective' },
      { option: 'hedkayse', label: 'Hedkayse' },
      { option: 'hercules', label: 'Hercules' },
      { option: 'hjc', label: 'Hjc' },
      { option: 'invert', label: 'Invert' },
      { option: 'ixs', label: 'Ixs' },
      { option: 'kali', label: 'Kali' },
      { option: 'kali_protectives', label: 'Kali Protectives' },
      { option: 'kask', label: 'Kask' },
      { option: 'kav_helmets', label: 'Kav Helmets' },
      { option: 'ked', label: 'Ked' },
      { option: 'las', label: 'Las' },
      { option: 'lazer', label: 'Lazer' },
      { option: 'lem_helmets', label: 'Lem Helmets' },
      { option: 'lezyne', label: 'Lezyne' },
      { option: 'limar', label: 'Limar' },
      { option: 'liv', label: 'Liv' },
      { option: 'livall', label: 'Livall' },
      { option: 'martone', label: 'Martone' },
      { option: 'mavic', label: 'Mavic' },
      { option: 'melon', label: 'Melon' },
      { option: 'merida', label: 'Merida' },
      { option: 'met', label: 'Met' },
      { option: 'mongoose', label: 'Mongoose' },
      { option: 'morpher', label: 'Morpher' },
      { option: 'moxi_skates', label: 'Moxi Skates' },
      { option: 'muddyfox', label: 'Muddyfox' },
      { option: 'm_wave', label: 'M-wave' },
      { option: 'no_fear', label: 'No Fear' },
      { option: 'nuckily', label: 'Nuckily' },
      { option: 'nutcase', label: 'Nutcase' },
      { option: 'oakley', label: 'Oakley' },
      { option: 'omo_bikes', label: 'Omo Bikes' },
      { option: 'overade', label: 'Overade' },
      { option: 'oxford', label: 'Oxford' },
      { option: 'pinnacle', label: 'Pinnacle' },
      { option: 'poc', label: 'Poc' },
      { option: 'pro_tec', label: 'Pro Tec' },
      { option: 'proviz', label: 'Proviz' },
      { option: 'prowell', label: 'Prowell' },
      { option: 'raleigh', label: 'Raleigh' },
      { option: 'rapha', label: 'Rapha' },
      { option: 'rudy_project', label: 'Rudy Project' },
      { option: 's_i_helmets', label: 'S I Helmets' },
      { option: 'safety_labs', label: 'Safety Labs' },
      { option: 'salice', label: 'Salice' },
      { option: 'schwinn', label: 'Schwinn' },
      { option: 'scott', label: 'Scott' },
      { option: 'sh_plus', label: 'Sh+' },
      { option: 'smith', label: 'Smith' },
      { option: 'smith_ignite', label: 'Smith Ignite' },
      { option: 'specialized', label: 'Specialized' },
      { option: 'sullivan', label: 'Sullivan' },
      { option: 'suomy', label: 'Suomy' },
      { option: 'sweet_protection', label: 'Sweet Protection' },
      { option: 't_t', label: 'T&t' },
      { option: 'team_obsidian', label: 'Team Obsidian' },
      { option: 'thousand', label: 'Thousand' },
      { option: 'trek', label: 'Trek' },
      { option: 'trespass', label: 'Trespass' },
      { option: 'trivio', label: 'Trivio' },
      { option: 'troy_lee_designs', label: 'Troy Lee Designs' },
      { option: 'urvex', label: 'Urvex' },
      { option: 'uvex', label: 'Uvex' },
      { option: 'vanrysel', label: 'Vanrysel' },
      { option: 'vittoria', label: 'Vittoria' },
      { option: 'xmr', label: 'Xmr' },
      { option: 'zakpro', label: 'Zakpro' },
    ],
  },
  {
    key: 'Cap',
    enumOptions: [
      { option: '100_percent', label: '100 Percent' },
      { option: 'actuo', label: 'Actuo' },
      { option: 'agu', label: 'Agu' },
      { option: 'airpop', label: 'Airpop' },
      { option: 'ale', label: 'Ale' },
      { option: 'altura', label: 'Altura' },
      { option: 'apis', label: 'Apis' },
      { option: 'assos', label: 'Assos' },
      { option: 'biehler', label: 'Biehler' },
      { option: 'bioracer', label: 'Bioracer' },
      { option: 'blb', label: 'Blb' },
      { option: 'castelli', label: 'Castelli' },
      { option: 'cinelli', label: 'Cinelli' },
      { option: 'condor', label: 'Condor' },
      { option: 'cube', label: 'Cube' },
      { option: 'giant', label: 'Giant' },
      { option: 'giordana', label: 'Giordana' },
      { option: 'gorewear', label: 'Gorewear' },
      { option: 'halo', label: 'Halo' },
      { option: 'maap', label: 'Maap' },
      { option: 'madison', label: 'Madison' },
      { option: 'nalini', label: 'Nalini' },
      { option: 'odi', label: 'Odi' },
      { option: 'park_tool', label: 'Park Tool' },
      { option: 'pearl_izumi', label: 'Pearl Izumi' },
      { option: 'prendas', label: 'Prendas' },
      { option: 'rapha', label: 'Rapha' },
      { option: 'respro', label: 'Respro' },
      { option: 'santini', label: 'Santini' },
      { option: 'scott', label: 'Scott' },
      { option: 'shimano', label: 'Shimano' },
      { option: 'sportful', label: 'Sportful' },
      { option: 'takachya', label: 'Takachya' },
      { option: 'trek', label: 'Trek' },
      { option: 'troy_lee_designs', label: 'Troy Lee Designs' },
      { option: 'van_rysel', label: 'Van Rysel' },
      { option: 'velocio', label: 'Velocio' },
      { option: 'viod_cycling', label: 'Viod Cycling' },
      { option: 'walz', label: 'Walz' },
    ],
  },
  {
    key: 'Sunglasses',
    enumOptions: [
      { option: '100_percent', label: '100 Percent' },
      { option: 'abus', label: 'Abus' },
      { option: 'adidas', label: 'Adidas' },
      { option: 'agu', label: 'Agu' },
      { option: 'alba_optics', label: 'Alba Optics' },
      { option: 'assos', label: 'Assos' },
      { option: 'bbb', label: 'Bbb' },
      { option: 'bliz', label: 'Bliz' },
      { option: 'bolle', label: 'Bolle' },
      { option: 'cafe_du_cycliste', label: 'Café Du Cycliste' },
      { option: 'casco', label: 'Casco' },
      { option: 'cratoni', label: 'Cratoni' },
      { option: 'dainese', label: 'Dainese' },
      { option: 'decathlon', label: 'Decathlon' },
      { option: 'dirtlej', label: 'Dirtlej' },
      { option: 'dragon', label: 'Dragon' },
      { option: 'dynafit', label: 'Dynafit' },
      { option: 'dynamic', label: 'Dynamic' },
      { option: 'endura', label: 'Endura' },
      { option: 'enlee', label: 'Enlee' },
      { option: 'ess', label: 'Ess' },
      { option: 'fox', label: 'Fox' },
      { option: 'giant', label: 'Giant' },
      { option: 'giro', label: 'Giro' },
      { option: 'goodr', label: 'Goodr' },
      { option: 'ixs', label: 'Ixs' },
      { option: 'julbo', label: 'Julbo' },
      { option: 'kali', label: 'Kali' },
      { option: 'koo', label: 'Koo' },
      { option: 'lenskart', label: 'Lenskart' },
      { option: 'madison', label: 'Madison' },
      { option: 'magicshine', label: 'Magicshine' },
      { option: 'nike', label: 'Nike' },
      { option: 'oakley', label: 'Oakley' },
      { option: 'pinnacle', label: 'Pinnacle' },
      { option: 'pit_viper', label: 'Pit Viper' },
      { option: 'poc', label: 'Poc' },
      { option: 'rapha', label: 'Rapha' },
      { option: 'react', label: 'React' },
      { option: 'rh_plus', label: 'Rh+' },
      { option: 'rockbros', label: 'Rockbros' },
      { option: 'roka', label: 'Roka' },
      { option: 'rudy_project', label: 'Rudy Project' },
      { option: 'salice', label: 'Salice' },
      { option: 'scicon', label: 'Scicon' },
      { option: 'scott', label: 'Scott' },
      { option: 'scvcn', label: 'Scvcn' },
      { option: 'shimano', label: 'Shimano' },
      { option: 'smith', label: 'Smith' },
      { option: 'spektrum', label: 'Spektrum' },
      { option: 'spiuk', label: 'Spiuk' },
      { option: 'sungod', label: 'Sungod' },
      { option: 'sweet_protection', label: 'Sweet Protection' },
      { option: 'swiss_eye', label: 'Swiss Eye' },
      { option: 'tifosi', label: 'Tifosi' },
      { option: 'uvex', label: 'Uvex' },
      { option: 'van_rysel', label: 'Van Rysel' },
      { option: 'victory_chimp', label: 'Victory Chimp' },
      { option: 'vinco', label: 'Vinco' },
      { option: 'zakpro', label: 'Zakpro' },
      { option: 'zone_3', label: 'Zone 3' },
    ],
  },
  {
    key: 'Helmets',
    enumOptions: [{ option: 'cube', label: 'Cube' }, { option: 'diamant', label: 'Diamant' }],
  },
  {
    key: 'Helmets',
    enumOptions: [{ option: 'cube', label: 'Cube' }, { option: 'diamant', label: 'Diamant' }],
  },
];

export const listingSubCategories = [
  {
    name: 'Base Layers',
    id: 'Base-Layers',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: '2XU',
        id: '2xu',
        subcategories: [],
      },
      {
        name: '7Mesh',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'Aclima',
        id: 'aclima',
        subcategories: [],
      },
      {
        name: 'Adicta Lab',
        id: 'adicta-lab',
        subcategories: [],
      },
      {
        name: 'Adidas',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'Albion',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'Ale',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'AlpineStars',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Angry Pablo',
        id: 'angry-pablo',
        subcategories: [],
      },
      {
        name: 'Artilect',
        id: 'artilect',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Bergans',
        id: 'bergans',
        subcategories: [],
      },
      {
        name: 'Berghaus',
        id: 'berghaus',
        subcategories: [],
      },
      {
        name: 'Bioracer',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'Black Sheep Cycling',
        id: 'black-sheep-cycling',
        subcategories: [],
      },
      {
        name: 'Café Du Cycliste',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'Campri',
        id: 'campri',
        subcategories: [],
      },
      {
        name: 'Castelli',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'Cateye',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'CCN',
        id: 'ccn',
        subcategories: [],
      },
      {
        name: 'CEP',
        id: 'cep',
        subcategories: [],
      },
      {
        name: 'Chapeau',
        id: 'chapeau',
        subcategories: [],
      },
      {
        name: 'Columbia',
        id: 'columbia',
        subcategories: [],
      },
      {
        name: 'Craft',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'Crazyidea',
        id: 'crazyidea',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Dæhlie',
        id: 'daehlie',
        subcategories: [],
      },
      {
        name: 'Dare2B',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'Devold',
        id: 'devold',
        subcategories: [],
      },
      {
        name: 'dhb',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'E9',
        id: 'e9',
        subcategories: [],
      },
      {
        name: 'Endura',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'Endurance',
        id: 'endurance',
        subcategories: [],
      },
      {
        name: 'Falke',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'FiveTen',
        id: 'fiveten',
        subcategories: [],
      },
      {
        name: 'Fjallraven',
        id: 'fjallraven',
        subcategories: [],
      },
      {
        name: 'Fohn',
        id: 'fohn',
        subcategories: [],
      },
      {
        name: 'G Form',
        id: 'g-form',
        subcategories: [],
      },
      {
        name: 'Giro',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'Gonso',
        id: 'gonso',
        subcategories: [],
      },
      {
        name: 'Gorewear',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'Helly Hansen',
        id: 'helly-hansen',
        subcategories: [],
      },
      {
        name: 'Kalf',
        id: 'kalf',
        subcategories: [],
      },
      {
        name: 'Karrimor',
        id: 'karrimor',
        subcategories: [],
      },
      {
        name: 'Leatt',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'MAAP',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'Maloja',
        id: 'maloja',
        subcategories: [],
      },
      {
        name: 'Mavic',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MB Wear',
        id: 'mb-wear',
        subcategories: [],
      },
      {
        name: 'Northwave',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'Nukeproof',
        id: 'nukeproof',
        subcategories: [],
      },
      {
        name: 'Oakley',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'Odlo',
        id: 'odlo',
        subcategories: [],
      },
      {
        name: "O'Neal",
        id: 'oneal',
        subcategories: [],
      },
      {
        name: 'Pas Normal Studios',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'Pedaled',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'Pinnacle',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'Puma',
        id: 'puma',
        subcategories: [],
      },
      {
        name: 'Rapha',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'Reebok',
        id: 'reebok',
        subcategories: [],
      },
      {
        name: 'Rule 28',
        id: 'rule-28',
        subcategories: [],
      },
      {
        name: 'Santini',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'Spatz',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'Sportful',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'Troy Lee Designs',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'Under Armor',
        id: 'under-armor',
        subcategories: [],
      },
      {
        name: 'Universal Colors',
        id: 'universal-colors',
        subcategories: [],
      },
      {
        name: 'Vaude',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'Wowow',
        id: 'wowow',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Bib Shorts',
    id: 'Bib-Shorts',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: '2XU',
        id: '2xu',
        subcategories: [],
      },
      {
        name: '7Mesh',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'Aclima',
        id: 'aclima',
        subcategories: [],
      },
      {
        name: 'Adicta Lab',
        id: 'adicta-lab',
        subcategories: [],
      },
      {
        name: 'Adidas',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Alba Optics',
        id: 'alba-optics',
        subcategories: [],
      },
      {
        name: 'Albion',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'Ale',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'Alpine Bikes',
        id: 'alpine-bikes',
        subcategories: [],
      },
      {
        name: 'Alpinestars',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Amplifi',
        id: 'amplifi',
        subcategories: [],
      },
      {
        name: 'Apace',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Baisky',
        id: 'baisky',
        subcategories: [],
      },
      {
        name: 'BBB Cycling',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'Bellwether',
        id: 'bellwether',
        subcategories: [],
      },
      {
        name: 'Biehler',
        id: 'biehler',
        subcategories: [],
      },
      {
        name: 'Bike Inside Cycling Wear',
        id: 'bike-inside-cycling-wear',
        subcategories: [],
      },
      {
        name: 'Biketags',
        id: 'biketags',
        subcategories: [],
      },
      {
        name: 'Bioracer',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'Black Sheep Cycling',
        id: 'black-sheep-cycling',
        subcategories: [],
      },
      {
        name: 'BMC',
        id: 'bmc',
        subcategories: [],
      },
      {
        name: 'Bombtrack Apparel',
        id: 'bombtrack-apparel',
        subcategories: [],
      },
      {
        name: 'Brompton',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'Café du Cycliste',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'Campagnolo',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'Cannondale',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'Castelli',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'Cervelo',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'Chapeau',
        id: 'chapeau',
        subcategories: [],
      },
      {
        name: 'Chiba',
        id: 'chiba',
        subcategories: [],
      },
      {
        name: 'Chrome Industries',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'Cinelli',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'Cinnamon Star',
        id: 'cinnamon-star',
        subcategories: [],
      },
      {
        name: 'Craft',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'Crankbrothers',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Cycling Monks',
        id: 'cycling-monks',
        subcategories: [],
      },
      {
        name: 'Cycloholic',
        id: 'cycloholic',
        subcategories: [],
      },
      {
        name: 'Cycology',
        id: 'cycology',
        subcategories: [],
      },
      {
        name: 'Dare2B',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'Decathlon',
        id: 'decathlon',
        subcategories: [],
      },
      {
        name: 'Devold',
        id: 'devold',
        subcategories: [],
      },
      {
        name: 'Dharco',
        id: 'dharco',
        subcategories: [],
      },
      {
        name: 'DHB',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'Dianese',
        id: 'dianese',
        subcategories: [],
      },
      {
        name: 'Dirt Love',
        id: 'dirt-love',
        subcategories: [],
      },
      {
        name: 'Dirtlej',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'Dotout',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'Dynafit',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'Effetto Mariposa',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'ENDLESS LOCAL',
        id: 'endless-local',
        subcategories: [],
      },
      {
        name: 'ENDURA',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'ENDURANCE',
        id: 'endurance',
        subcategories: [],
      },
      {
        name: 'ETNIES',
        id: 'etnies',
        subcategories: [],
      },
      {
        name: 'EVANS',
        id: 'evans',
        subcategories: [],
      },
      {
        name: 'EVOC BIKE',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'EXUSTAR',
        id: 'exustar',
        subcategories: [],
      },
      {
        name: 'FALKE',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'FASTHOUSE',
        id: 'fasthouse',
        subcategories: [],
      },
      {
        name: 'FIVETEN',
        id: 'fiveten',
        subcategories: [],
      },
      {
        name: 'FJALLRAVEN',
        id: 'fjallraven',
        subcategories: [],
      },
      {
        name: 'F-LITE',
        id: 'f-lite',
        subcategories: [],
      },
      {
        name: 'FOX RACING',
        id: 'fox-racing',
        subcategories: [],
      },
      {
        name: 'FUNKIER',
        id: 'funkier',
        subcategories: [],
      },
      {
        name: 'G FORM',
        id: 'g-form',
        subcategories: [],
      },
      {
        name: 'GAMBIT',
        id: 'gambit',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'GIRO',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'GOBIK',
        id: 'gobik',
        subcategories: [],
      },
      {
        name: 'GONSO',
        id: 'gonso',
        subcategories: [],
      },
      {
        name: 'GOREWEAR',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'GRIPGRAB',
        id: 'gripgrab',
        subcategories: [],
      },
      {
        name: 'HEINI',
        id: 'heini',
        subcategories: [],
      },
      {
        name: 'HIRU',
        id: 'hiru',
        subcategories: [],
      },
      {
        name: 'HSR',
        id: 'hsr',
        subcategories: [],
      },
      {
        name: 'HUUB',
        id: 'huub',
        subcategories: [],
      },
      {
        name: 'HUUB DESIGN',
        id: 'huub-design',
        subcategories: [],
      },
      {
        name: 'HYVE SPORTS',
        id: 'hyve-sports',
        subcategories: [],
      },
      {
        name: 'ION',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'ISADORE',
        id: 'isadore',
        subcategories: [],
      },
      {
        name: 'IXS',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'JACK WOLFSKIN',
        id: 'jack-wolfskin',
        subcategories: [],
      },
      {
        name: 'KALAS',
        id: 'kalas',
        subcategories: [],
      },
      {
        name: 'KARPOS',
        id: 'karpos',
        subcategories: [],
      },
      {
        name: 'KATUSHA',
        id: 'katusha',
        subcategories: [],
      },
      {
        name: 'KIDS RIDE SHOTGUN',
        id: 'kids-ride-shotgun',
        subcategories: [],
      },
      {
        name: 'LE COL',
        id: 'le-col',
        subcategories: [],
      },
      {
        name: 'LEATT',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'LIV APPAREL',
        id: 'liv-apparel',
        subcategories: [],
      },
      {
        name: 'LOFFLER',
        id: 'loffler',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'LOOSE RIDERS',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'LOUIS GARNEAU',
        id: 'louis-garneau',
        subcategories: [],
      },
      {
        name: 'MAAP',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'MAGURA',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'MALOJA',
        id: 'maloja',
        subcategories: [],
      },
      {
        name: 'MARTINI SPORTSWEAR',
        id: 'martini-sportswear',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MB WEAR',
        id: 'mb-wear',
        subcategories: [],
      },
      {
        name: 'MERIDA',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'MONS ROYALE',
        id: 'mons-royale',
        subcategories: [],
      },
      {
        name: 'MONTURA',
        id: 'montura',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'NUCKILY',
        id: 'nuckily',
        subcategories: [],
      },
      {
        name: 'NUKE PROOF',
        id: 'nuke-proof',
        subcategories: [],
      },
      {
        name: 'OAKLEY',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'ODLO',
        id: 'odlo',
        subcategories: [],
      },
      {
        name: 'ONCEUPONARIDE',
        id: 'onceuponaride',
        subcategories: [],
      },
      {
        name: "O'NEAL",
        id: 'oneal',
        subcategories: [],
      },
      {
        name: 'ORCA',
        id: 'orca',
        subcategories: [],
      },
      {
        name: 'PAS NORMAL STUDIOS',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'PATAGONIA',
        id: 'patagonia',
        subcategories: [],
      },
      {
        name: 'PEARL IZUMI',
        id: 'pearl-izumi',
        subcategories: [],
      },
      {
        name: 'PEDALED',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'PEDLA',
        id: 'pedla',
        subcategories: [],
      },
      {
        name: 'PICTURE ORGANIC CLOTHING',
        id: 'picture-organic-clothing',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'POLARIS',
        id: 'polaris',
        subcategories: [],
      },
      {
        name: 'PRONG HORN',
        id: 'prong-horn',
        subcategories: [],
      },
      {
        name: 'PROTECTIVE',
        id: 'protective',
        subcategories: [],
      },
      {
        name: 'Q36.5',
        id: 'q365',
        subcategories: [],
      },
      {
        name: 'RAB',
        id: 'rab',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'RAINLEGS',
        id: 'rainlegs',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'REEBOK',
        id: 'reebok',
        subcategories: [],
      },
      {
        name: 'RH+',
        id: 'rh',
        subcategories: [],
      },
      {
        name: 'RIDE CONCEPTS',
        id: 'ride-concepts',
        subcategories: [],
      },
      {
        name: 'RIDING CULTURE',
        id: 'riding-culture',
        subcategories: [],
      },
      {
        name: 'RTTSHIRTS',
        id: 'rttshirts',
        subcategories: [],
      },
      {
        name: 'SANTINI',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SOMBRIO',
        id: 'sombrio',
        subcategories: [],
      },
      {
        name: 'SPATZ',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SPIUK',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'SPOON',
        id: 'spoon',
        subcategories: [],
      },
      {
        name: 'SPORTFUL',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'SQ LAB',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'SQLAB',
        id: 'sqlab',
        subcategories: [],
      },
      {
        name: 'STONEMAN',
        id: 'stoneman',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TREK GIANT',
        id: 'trek-giant',
        subcategories: [],
      },
      {
        name: 'TRIPLE-EIGHT',
        id: 'triple-eight',
        subcategories: [],
      },
      {
        name: 'TROY LEE DESIGNS',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'TSG',
        id: 'tsg',
        subcategories: [],
      },
      {
        name: 'UNIVERSAL COLOURS',
        id: 'universal-colours',
        subcategories: [],
      },
      {
        name: 'VAN RYSEL',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'VAUDE',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'VELOCIO',
        id: 'velocio',
        subcategories: [],
      },
      {
        name: 'VOID CYCLING',
        id: 'void-cycling',
        subcategories: [],
      },
      {
        name: 'X-BIONIC',
        id: 'x-bionic',
        subcategories: [],
      },
      {
        name: 'ZIMTSTERN',
        id: 'zimtstern',
        subcategories: [],
      },
      {
        name: 'ZONE 3',
        id: 'zone-3',
        subcategories: [],
      },
      {
        name: 'RAVX',
        id: 'ravx',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Gillets',
    id: 'Gillets',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: '7Mesh',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'Aclima',
        id: 'aclima',
        subcategories: [],
      },
      {
        name: 'Adicta Lab',
        id: 'adicta-lab',
        subcategories: [],
      },
      {
        name: 'Adidas',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'Agu',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Alba Optics',
        id: 'alba-optics',
        subcategories: [],
      },
      {
        name: 'Albion',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'Ale',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'Alpine Bikes',
        id: 'alpine-bikes',
        subcategories: [],
      },
      {
        name: 'Alpinestars',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Amplifi',
        id: 'amplifi',
        subcategories: [],
      },
      {
        name: 'Apace',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Baisky',
        id: 'baisky',
        subcategories: [],
      },
      {
        name: 'BBB Cycling',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'Bellwether',
        id: 'bellwether',
        subcategories: [],
      },
      {
        name: 'Biehler',
        id: 'biehler',
        subcategories: [],
      },
      {
        name: 'Bike Inside Cycling Wear',
        id: 'bike-inside-cycling-wear',
        subcategories: [],
      },
      {
        name: 'Biketags',
        id: 'biketags',
        subcategories: [],
      },
      {
        name: 'Bioracer',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'Black Sheep Cycling',
        id: 'black-sheep-cycling',
        subcategories: [],
      },
      {
        name: 'Bombtrack Apparel',
        id: 'bombtrack-apparel',
        subcategories: [],
      },
      {
        name: 'Brompton',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'Café du Cycliste',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'Campagnolo',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'Cannondale',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'Castelli',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'Cervelo',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'Chapeau',
        id: 'chapeau',
        subcategories: [],
      },
      {
        name: 'Chiba',
        id: 'chiba',
        subcategories: [],
      },
      {
        name: 'Chrome Industries',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'Cinelli',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'Craft',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'Crankbrothers',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Cycling Monks',
        id: 'cycling-monks',
        subcategories: [],
      },
      {
        name: 'Cycloholic',
        id: 'cycloholic',
        subcategories: [],
      },
      {
        name: 'Cycology',
        id: 'cycology',
        subcategories: [],
      },
      {
        name: 'Dare2b',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'Decathlon',
        id: 'decathlon',
        subcategories: [],
      },
      {
        name: 'Devold',
        id: 'devold',
        subcategories: [],
      },
      {
        name: 'Dharco',
        id: 'dharco',
        subcategories: [],
      },
      {
        name: 'Dhb',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'Dianese',
        id: 'dianese',
        subcategories: [],
      },
      {
        name: 'Dirt Love',
        id: 'dirt-love',
        subcategories: [],
      },
      {
        name: 'Dirtlej',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'Dotout',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'Dynafit',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'Effetto Mariposa',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'Endless Local',
        id: 'endless-local',
        subcategories: [],
      },
      {
        name: 'Endura',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'Endurance',
        id: 'endurance',
        subcategories: [],
      },
      {
        name: 'Etnies',
        id: 'etnies',
        subcategories: [],
      },
      {
        name: 'Evoc Bike',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'Exustar',
        id: 'exustar',
        subcategories: [],
      },
      {
        name: 'Falke',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'Fasthouse',
        id: 'fasthouse',
        subcategories: [],
      },
      {
        name: 'Fiveten',
        id: 'fiveten',
        subcategories: [],
      },
      {
        name: 'Fox Racing',
        id: 'fox-racing',
        subcategories: [],
      },
      {
        name: 'Funkier',
        id: 'funkier',
        subcategories: [],
      },
      {
        name: 'G Form',
        id: 'g-form',
        subcategories: [],
      },
      {
        name: 'Gambit',
        id: 'gambit',
        subcategories: [],
      },
      {
        name: 'Giant',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'Giro',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'Gobik',
        id: 'gobik',
        subcategories: [],
      },
      {
        name: 'Gonso',
        id: 'gonso',
        subcategories: [],
      },
      {
        name: 'Gorewear',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'GripGrab',
        id: 'gripgrab',
        subcategories: [],
      },
      {
        name: 'Heini',
        id: 'heini',
        subcategories: [],
      },
      {
        name: 'Hiru',
        id: 'hiru',
        subcategories: [],
      },
      {
        name: 'HSR',
        id: 'hsr',
        subcategories: [],
      },
      {
        name: 'Huub Design',
        id: 'huub-design',
        subcategories: [],
      },
      {
        name: 'Hyve Sports',
        id: 'hyve-sports',
        subcategories: [],
      },
      {
        name: 'Ion',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'Isadore',
        id: 'isadore',
        subcategories: [],
      },
      {
        name: 'IXS',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'Jack Wolfskin',
        id: 'jack-wolfskin',
        subcategories: [],
      },
      {
        name: 'Kalas',
        id: 'kalas',
        subcategories: [],
      },
      {
        name: 'Karpos',
        id: 'karpos',
        subcategories: [],
      },
      {
        name: 'Katusha',
        id: 'katusha',
        subcategories: [],
      },
      {
        name: 'Kids Ride Shotgun',
        id: 'kids-ride-shotgun',
        subcategories: [],
      },
      {
        name: 'Le Col',
        id: 'le-col',
        subcategories: [],
      },
      {
        name: 'Leatt',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'Liv Apparel',
        id: 'liv-apparel',
        subcategories: [],
      },
      {
        name: 'Loffler',
        id: 'loffler',
        subcategories: [],
      },
      {
        name: 'Look',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'Loose Riders',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'Louis Garneau',
        id: 'louis-garneau',
        subcategories: [],
      },
      {
        name: 'Maap',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'Magura',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'Maloja',
        id: 'maloja',
        subcategories: [],
      },
      {
        name: 'Martini Sportswear',
        id: 'martini-sportswear',
        subcategories: [],
      },
      {
        name: 'Mavic',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MB Wear',
        id: 'mb-wear',
        subcategories: [],
      },
      {
        name: 'Merida',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'Mons Royale',
        id: 'mons-royale',
        subcategories: [],
      },
      {
        name: 'Montura',
        id: 'montura',
        subcategories: [],
      },
      {
        name: 'Muc-Off',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'Muddy Fox',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'Nalini',
        id: 'nalini',
        subcategories: [],
      },
      {
        name: 'Nineyard',
        id: 'nineyard',
        subcategories: [],
      },
      {
        name: 'Norrona',
        id: 'norrona',
        subcategories: [],
      },
      {
        name: 'Northwave',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'Nuckily',
        id: 'nuckily',
        subcategories: [],
      },
      {
        name: 'Nukeproof',
        id: 'nukeproof',
        subcategories: [],
      },
      {
        name: 'Oakley',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'Odlo',
        id: 'odlo',
        subcategories: [],
      },
      {
        name: 'Onceuponaride',
        id: 'onceuponaride',
        subcategories: [],
      },
      {
        name: "O'Neal",
        id: 'oneal',
        subcategories: [],
      },
      {
        name: 'Orca',
        id: 'orca',
        subcategories: [],
      },
      {
        name: 'Pas Normal Studios',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'Patagonia',
        id: 'patagonia',
        subcategories: [],
      },
      {
        name: 'Pearl Izumi',
        id: 'pearl-izumi',
        subcategories: [],
      },
      {
        name: 'Pedaled',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'Pedla',
        id: 'pedla',
        subcategories: [],
      },
      {
        name: 'Picture Organic Clothing',
        id: 'picture-organic-clothing',
        subcategories: [],
      },
      {
        name: 'Pinnacle',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'Polaris',
        id: 'polaris',
        subcategories: [],
      },
      {
        name: 'Prong Horn',
        id: 'prong-horn',
        subcategories: [],
      },
      {
        name: 'Protective',
        id: 'protective',
        subcategories: [],
      },
      {
        name: 'Q36.5',
        id: 'q365',
        subcategories: [],
      },
      {
        name: 'Rab',
        id: 'rab',
        subcategories: [],
      },
      {
        name: 'Race Face',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'Radon',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'Rapha',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RH+',
        id: 'rh',
        subcategories: [],
      },
      {
        name: 'Ride Concepts',
        id: 'ride-concepts',
        subcategories: [],
      },
      {
        name: 'Riding Culture',
        id: 'riding-culture',
        subcategories: [],
      },
      {
        name: 'RTTShirts',
        id: 'rttshirts',
        subcategories: [],
      },
      {
        name: 'Santini',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'Scott',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'Shimano',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'Sombrio',
        id: 'sombrio',
        subcategories: [],
      },
      {
        name: 'Spatz',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'Specialized',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'Spiuk',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'Sportful',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'SQ Lab',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'Stoneman',
        id: 'stoneman',
        subcategories: [],
      },
      {
        name: 'Trek',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'Triple Eight',
        id: 'triple-eight',
        subcategories: [],
      },
      {
        name: 'Troy Lee Designs',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'TSG',
        id: 'tsg',
        subcategories: [],
      },
      {
        name: 'Universal Colours',
        id: 'universal-colours',
        subcategories: [],
      },
      {
        name: 'Van Rysel',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'Vaude',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'Velocio',
        id: 'velocio',
        subcategories: [],
      },
      {
        name: 'Void Cycling',
        id: 'void-cycling',
        subcategories: [],
      },
      {
        name: 'X-Bionic',
        id: 'x-bionic',
        subcategories: [],
      },
      {
        name: 'Zimtstern',
        id: 'zimtstern',
        subcategories: [],
      },
      {
        name: 'Zone 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Gloves',
    id: 'Gloves',
    subcategories: [
      {
        name: 'ASSOS',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'NORTHWAVE',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'SANTINI',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPORTFUL',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'WOWOW',
        id: 'wowow',
        subcategories: [],
      },
      {
        name: '100 PERCENT',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: 'ENDURA',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'ALTURA',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'LIZARD SKINS',
        id: 'lizard-skins',
        subcategories: [],
      },
      {
        name: 'ALE',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'SEALSKINZ',
        id: 'sealskinz',
        subcategories: [],
      },
      {
        name: 'BLUEGRASS',
        id: 'bluegrass',
        subcategories: [],
      },
      {
        name: 'FOX',
        id: 'fox',
        subcategories: [],
      },
      {
        name: 'DHB',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'G FORM',
        id: 'g-form',
        subcategories: [],
      },
      {
        name: 'ROECKL',
        id: 'roeckl',
        subcategories: [],
      },
      {
        name: 'CHAPEAU',
        id: 'chapeau',
        subcategories: [],
      },
      {
        name: 'DEXSHELL',
        id: 'dexshell',
        subcategories: [],
      },
      {
        name: 'KALI',
        id: 'kali',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'CASTELLI',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'DYNAFIT',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'DEFEET',
        id: 'defeet',
        subcategories: [],
      },
      {
        name: 'KALAS',
        id: 'kalas',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'TROY LEE DESIGNS',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'CAFÉ DU CYCLISTE',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'FINGERSCROSSED',
        id: 'fingerscrossed',
        subcategories: [],
      },
      {
        name: 'GOREWEAR',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'PEDALED',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'RULE 28',
        id: 'rule-28',
        subcategories: [],
      },
      {
        name: 'SPATZ',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'UNIVERSAL COLOURS',
        id: 'universal-colours',
        subcategories: [],
      },
      {
        name: '7MESH',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'ACLIMA',
        id: 'aclima',
        subcategories: [],
      },
      {
        name: 'ADICTA LAB',
        id: 'adicta-lab',
        subcategories: [],
      },
      {
        name: 'ADIDAS',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'ALBA OPTICS',
        id: 'alba-optics',
        subcategories: [],
      },
      {
        name: 'ALBION',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'ALPINE BIKES',
        id: 'alpine-bikes',
        subcategories: [],
      },
      {
        name: 'ALPINESTARS',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'AMPLIFI',
        id: 'amplifi',
        subcategories: [],
      },
      {
        name: 'APACE',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'BAISKY',
        id: 'baisky',
        subcategories: [],
      },
      {
        name: 'BBB CYCLING',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'BELLWETHER',
        id: 'bellwether',
        subcategories: [],
      },
      {
        name: 'BIEHLER',
        id: 'biehler',
        subcategories: [],
      },
      {
        name: 'BIKE INSIDE CYCLING WEAR',
        id: 'bike-inside-cycling-wear',
        subcategories: [],
      },
      {
        name: 'BIKETAGS',
        id: 'biketags',
        subcategories: [],
      },
      {
        name: 'BIORACER',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'BOMBTRACK APPAREL',
        id: 'bombtrack-apparel',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CERVELO',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'CHIBA',
        id: 'chiba',
        subcategories: [],
      },
      {
        name: 'CHROME INDUSTRIES',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'CRAFT',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'CYCLING MONKS',
        id: 'cycling-monks',
        subcategories: [],
      },
      {
        name: 'CYCLOHOLIC',
        id: 'cycloholic',
        subcategories: [],
      },
      {
        name: 'CYCOLOGY',
        id: 'cycology',
        subcategories: [],
      },
      {
        name: 'DARE2B',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'DECATHLON',
        id: 'decathlon',
        subcategories: [],
      },
      {
        name: 'DEVOLD',
        id: 'devold',
        subcategories: [],
      },
      {
        name: 'DHARCO',
        id: 'dharco',
        subcategories: [],
      },
      {
        name: 'DIANESE',
        id: 'dianese',
        subcategories: [],
      },
      {
        name: 'DIRT LOVE',
        id: 'dirt-love',
        subcategories: [],
      },
      {
        name: 'DIRTLEJ',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'DOTOUT',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'EFFETTO MARIPOSA',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'ENDLESS LOCAL',
        id: 'endless-local',
        subcategories: [],
      },
      {
        name: 'ENDURANCE',
        id: 'endurance',
        subcategories: [],
      },
      {
        name: 'ETNIES',
        id: 'etnies',
        subcategories: [],
      },
      {
        name: 'EVOC BIKE',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'EXUSTAR',
        id: 'exustar',
        subcategories: [],
      },
      {
        name: 'FALKE',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'FASTHOUSE',
        id: 'fasthouse',
        subcategories: [],
      },
      {
        name: 'FIVETEN',
        id: 'fiveten',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Helmets',
    id: 'Helmets',
    subcategories: [
      {
        name: '100 Percent',
        id: '100_percent',
        subcategories: [],
      },
      {
        name: '7IDP',
        id: '7idp',
        subcategories: [],
      },
      {
        name: 'Abus',
        id: 'abus',
        subcategories: [],
      },
      {
        name: 'Alpina',
        id: 'alpina',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Bbb',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'Bell',
        id: 'bell',
        subcategories: [],
      },
      {
        name: 'Bern',
        id: 'bern',
        subcategories: [],
      },
      {
        name: 'Bluegrass',
        id: 'bluegrass',
        subcategories: [],
      },
      {
        name: 'Boardman',
        id: 'boardman',
        subcategories: [],
      },
      {
        name: 'Bolle',
        id: 'bolle',
        subcategories: [],
      },
      {
        name: 'Bontrager',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'Briko',
        id: 'briko',
        subcategories: [],
      },
      {
        name: 'Bt-Win',
        id: 'bt-win',
        subcategories: [],
      },
      {
        name: 'Cannondale',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'Casco',
        id: 'casco',
        subcategories: [],
      },
      {
        name: 'Catlike',
        id: 'catlike',
        subcategories: [],
      },
      {
        name: 'Closca',
        id: 'closca',
        subcategories: [],
      },
      {
        name: 'Coros',
        id: 'coros',
        subcategories: [],
      },
      {
        name: 'Cratoni',
        id: 'cratoni',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Dare2b',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'Dhb',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'Disney',
        id: 'disney',
        subcategories: [],
      },
      {
        name: 'Dotout',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'Dunlop',
        id: 'dunlop',
        subcategories: [],
      },
      {
        name: 'Ecohelmet',
        id: 'ecohelmet',
        subcategories: [],
      },
      {
        name: 'Ekoi',
        id: 'ekoi',
        subcategories: [],
      },
      {
        name: 'Electra',
        id: 'electra',
        subcategories: [],
      },
      {
        name: 'Endura',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'Evans',
        id: 'evans',
        subcategories: [],
      },
      {
        name: 'Fila',
        id: 'fila',
        subcategories: [],
      },
      {
        name: 'Firefox',
        id: 'firefox',
        subcategories: [],
      },
      {
        name: 'Flr',
        id: 'flr',
        subcategories: [],
      },
      {
        name: 'Fox',
        id: 'fox',
        subcategories: [],
      },
      {
        name: 'Fox Racing Shox',
        id: 'fox_racing_shox',
        subcategories: [],
      },
      {
        name: 'Funkier',
        id: 'funkier',
        subcategories: [],
      },
      {
        name: 'Garneau',
        id: 'garneau',
        subcategories: [],
      },
      {
        name: 'Giant',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'Giro',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'Gist',
        id: 'gist',
        subcategories: [],
      },
      {
        name: 'Gvr',
        id: 'gvr',
        subcategories: [],
      },
      {
        name: 'Halfords',
        id: 'halfords',
        subcategories: [],
      },
      {
        name: 'Harsh Protective',
        id: 'harsh_protective',
        subcategories: [],
      },
      {
        name: 'Hedkayse',
        id: 'hedkayse',
        subcategories: [],
      },
      {
        name: 'Hercules',
        id: 'hercules',
        subcategories: [],
      },
      {
        name: 'Hjc',
        id: 'hjc',
        subcategories: [],
      },
      {
        name: 'Invert',
        id: 'invert',
        subcategories: [],
      },
      {
        name: 'Ixs',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'Kali',
        id: 'kali',
        subcategories: [],
      },
      {
        name: 'Kali Protectives',
        id: 'kali_protectives',
        subcategories: [],
      },
      {
        name: 'Kask',
        id: 'kask',
        subcategories: [],
      },
      {
        name: 'Kav Helmets',
        id: 'kav_helmets',
        subcategories: [],
      },
      {
        name: 'KED',
        id: 'ked',
        subcategories: [],
      },
      {
        name: 'LAS',
        id: 'las',
        subcategories: [],
      },
      {
        name: 'LAZER',
        id: 'lazer',
        subcategories: [],
      },
      {
        name: 'LEM HELMETS',
        id: 'lem-helmets',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LIMAR',
        id: 'limar',
        subcategories: [],
      },
      {
        name: 'LIV',
        id: 'liv',
        subcategories: [],
      },
      {
        name: 'LIVALL',
        id: 'livall',
        subcategories: [],
      },
      {
        name: 'MARTONE',
        id: 'martone',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MELON',
        id: 'melon',
        subcategories: [],
      },
      {
        name: 'MERIDA',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'MET',
        id: 'met',
        subcategories: [],
      },
      {
        name: 'MONGOOSE',
        id: 'mongoose',
        subcategories: [],
      },
      {
        name: 'MORPHER',
        id: 'morpher',
        subcategories: [],
      },
      {
        name: 'MOXI SKATES',
        id: 'moxi-skates',
        subcategories: [],
      },
      {
        name: 'MUDDYFOX',
        id: 'muddyfox',
        subcategories: [],
      },
      {
        name: 'M-WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'NO FEAR',
        id: 'no-fear',
        subcategories: [],
      },
      {
        name: 'NUCKILY',
        id: 'nuckily',
        subcategories: [],
      },
      {
        name: 'NUTCASE',
        id: 'nutcase',
        subcategories: [],
      },
      {
        name: 'OAKLEY',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'OMO BIKES',
        id: 'omo-bikes',
        subcategories: [],
      },
      {
        name: 'OVERADE',
        id: 'overade',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'PRO TEC',
        id: 'pro-tec',
        subcategories: [],
      },
      {
        name: 'PROVIZ',
        id: 'proviz',
        subcategories: [],
      },
      {
        name: 'PROWELL',
        id: 'prowell',
        subcategories: [],
      },
      {
        name: 'RALEIGH',
        id: 'raleigh',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RUDY PROJECT',
        id: 'rudy-project',
        subcategories: [],
      },
      {
        name: 'S I HELMETS',
        id: 's-i-helmets',
        subcategories: [],
      },
      {
        name: 'SAFETY LABS',
        id: 'safety-labs',
        subcategories: [],
      },
      {
        name: 'SALICE',
        id: 'salice',
        subcategories: [],
      },
      {
        name: 'SCHWINN',
        id: 'schwinn',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SH+',
        id: 'sh+',
        subcategories: [],
      },
      {
        name: 'SMITH',
        id: 'smith',
        subcategories: [],
      },
      {
        name: 'SMITH IGNITE',
        id: 'smith-ignite',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SULLIVAN',
        id: 'sullivan',
        subcategories: [],
      },
      {
        name: 'SUOMY',
        id: 'suomy',
        subcategories: [],
      },
      {
        name: 'SWEET PROTECTION',
        id: 'sweet-protection',
        subcategories: [],
      },
      {
        name: 'T&T',
        id: 't&t',
        subcategories: [],
      },
      {
        name: 'TEAM OBSIDIAN',
        id: 'team-obsidian',
        subcategories: [],
      },
      {
        name: 'THOUSAND',
        id: 'thousand',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRESPASS',
        id: 'trespass',
        subcategories: [],
      },
      {
        name: 'TRIVIO',
        id: 'trivio',
        subcategories: [],
      },
      {
        name: 'TROY LEE DESIGNS',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'URVEX',
        id: 'urvex',
        subcategories: [],
      },
      {
        name: 'UVEX',
        id: 'uvex',
        subcategories: [],
      },
      {
        name: 'VANRYSEL',
        id: 'vanrysel',
        subcategories: [],
      },
      {
        name: 'VITTORIA',
        id: 'vittoria',
        subcategories: [],
      },
      {
        name: 'XMR',
        id: 'xmr',
        subcategories: [],
      },
      {
        name: 'ZAKPRO',
        id: 'zakpro',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Cap',
    id: 'Cap',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: 'Actuo',
        id: 'actuo',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Airpop',
        id: 'airpop',
        subcategories: [],
      },
      {
        name: 'Ale',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Apis',
        id: 'apis',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Biehler',
        id: 'biehler',
        subcategories: [],
      },
      {
        name: 'Bioracer',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'BLB',
        id: 'blb',
        subcategories: [],
      },
      {
        name: 'Castelli',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'Cinelli',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'Condor',
        id: 'condor',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Giant',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'Giordana',
        id: 'giordana',
        subcategories: [],
      },
      {
        name: 'Gorewear',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'Halo',
        id: 'halo',
        subcategories: [],
      },
      {
        name: 'MAAP',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'Madison',
        id: 'madison',
        subcategories: [],
      },
      {
        name: 'Nalini',
        id: 'nalini',
        subcategories: [],
      },
      {
        name: 'ODI',
        id: 'odi',
        subcategories: [],
      },
      {
        name: 'Park Tool',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'Pearl Izumi',
        id: 'pearl-izumi',
        subcategories: [],
      },
      {
        name: 'Prendas',
        id: 'prendas',
        subcategories: [],
      },
      {
        name: 'Rapha',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'Respro',
        id: 'respro',
        subcategories: [],
      },
      {
        name: 'Santini',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'Scott',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'Shimano',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'Sportful',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'Takachya',
        id: 'takachya',
        subcategories: [],
      },
      {
        name: 'Trek',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'Troy Lee Designs',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'Van Rysel',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'Velocio',
        id: 'velocio',
        subcategories: [],
      },
      {
        name: 'Viod Cycling',
        id: 'viod-cycling',
        subcategories: [],
      },
      {
        name: 'Walz',
        id: 'walz',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Jackets',
    id: 'Jackets',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: '7Mesh',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'Aclima',
        id: 'aclima',
        subcategories: [],
      },
      {
        name: 'Adicta Lab',
        id: 'adicta-lab',
        subcategories: [],
      },
      {
        name: 'Adidas',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'Agu',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Alba Optics',
        id: 'alba-optics',
        subcategories: [],
      },
      {
        name: 'Albion',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'Ale',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'Alpine Bikes',
        id: 'alpine-bikes',
        subcategories: [],
      },
      {
        name: 'Alpinestars',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Amplifi',
        id: 'amplifi',
        subcategories: [],
      },
      {
        name: 'Apace',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Baisky',
        id: 'baisky',
        subcategories: [],
      },
      {
        name: 'BBB Cycling',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'Bellwether',
        id: 'bellwether',
        subcategories: [],
      },
      {
        name: 'Biehler',
        id: 'biehler',
        subcategories: [],
      },
      {
        name: 'Bike Inside Cycling Wear',
        id: 'bike-inside-cycling-wear',
        subcategories: [],
      },
      {
        name: 'Biketags',
        id: 'biketags',
        subcategories: [],
      },
      {
        name: 'Bioracer',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'Black Sheep Cycling',
        id: 'black-sheep-cycling',
        subcategories: [],
      },
      {
        name: 'Bombtrack Apparel',
        id: 'bombtrack-apparel',
        subcategories: [],
      },
      {
        name: 'Brompton',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'Café du Cycliste',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'Campagnolo',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'Cannondale',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'Castelli',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'Cervelo',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'Chapeau',
        id: 'chapeau',
        subcategories: [],
      },
      {
        name: 'Chiba',
        id: 'chiba',
        subcategories: [],
      },
      {
        name: 'Chrome Industries',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'Cinelli',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'Craft',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'Crankbrothers',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Cycling Monks',
        id: 'cycling-monks',
        subcategories: [],
      },
      {
        name: 'Cycloholic',
        id: 'cycloholic',
        subcategories: [],
      },
      {
        name: 'Cycology',
        id: 'cycology',
        subcategories: [],
      },
      {
        name: 'Dare2b',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'Decathlon',
        id: 'decathlon',
        subcategories: [],
      },
      {
        name: 'Devold',
        id: 'devold',
        subcategories: [],
      },
      {
        name: 'Dharco',
        id: 'dharco',
        subcategories: [],
      },
      {
        name: 'Dhb',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'Dianese',
        id: 'dianese',
        subcategories: [],
      },
      {
        name: 'Dirt Love',
        id: 'dirt-love',
        subcategories: [],
      },
      {
        name: 'Dirtlej',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'Dotout',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'Dynafit',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'Effetto Mariposa',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'Endless Local',
        id: 'endless-local',
        subcategories: [],
      },
      {
        name: 'Endura',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'Endurance',
        id: 'endurance',
        subcategories: [],
      },
      {
        name: 'Etnies',
        id: 'etnies',
        subcategories: [],
      },
      {
        name: 'Evoc Bike',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'Exustar',
        id: 'exustar',
        subcategories: [],
      },
      {
        name: 'Falke',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'Fasthouse',
        id: 'fasthouse',
        subcategories: [],
      },
      {
        name: 'Fiveten',
        id: 'fiveten',
        subcategories: [],
      },
      {
        name: 'Fox Racing',
        id: 'fox-racing',
        subcategories: [],
      },
      {
        name: 'Funkier',
        id: 'funkier',
        subcategories: [],
      },
      {
        name: 'G Form',
        id: 'g-form',
        subcategories: [],
      },
      {
        name: 'Gambit',
        id: 'gambit',
        subcategories: [],
      },
      {
        name: 'Giant',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'Giro',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'Gobik',
        id: 'gobik',
        subcategories: [],
      },
      {
        name: 'Gonso',
        id: 'gonso',
        subcategories: [],
      },
      {
        name: 'Gorewear',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'GripGrab',
        id: 'gripgrab',
        subcategories: [],
      },
      {
        name: 'Heini',
        id: 'heini',
        subcategories: [],
      },
      {
        name: 'Hiru',
        id: 'hiru',
        subcategories: [],
      },
      {
        name: 'HSR',
        id: 'hsr',
        subcategories: [],
      },
      {
        name: 'Huub Design',
        id: 'huub-design',
        subcategories: [],
      },
      {
        name: 'Hyve Sports',
        id: 'hyve-sports',
        subcategories: [],
      },
      {
        name: 'Ion',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'Isadore',
        id: 'isadore',
        subcategories: [],
      },
      {
        name: 'IXS',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'Jack Wolfskin',
        id: 'jack-wolfskin',
        subcategories: [],
      },
      {
        name: 'Kalas',
        id: 'kalas',
        subcategories: [],
      },
      {
        name: 'Karpos',
        id: 'karpos',
        subcategories: [],
      },
      {
        name: 'Katusha',
        id: 'katusha',
        subcategories: [],
      },
      {
        name: 'Kids Ride Shotgun',
        id: 'kids-ride-shotgun',
        subcategories: [],
      },
      {
        name: 'Le Col',
        id: 'le-col',
        subcategories: [],
      },
      {
        name: 'Leatt',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'Liv Apparel',
        id: 'liv-apparel',
        subcategories: [],
      },
      {
        name: 'Loffler',
        id: 'loffler',
        subcategories: [],
      },
      {
        name: 'Look',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'Loose Riders',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'Louis Garneau',
        id: 'louis-garneau',
        subcategories: [],
      },
      {
        name: 'Maap',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'Magura',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'Maloja',
        id: 'maloja',
        subcategories: [],
      },
      {
        name: 'Martini Sportswear',
        id: 'martini-sportswear',
        subcategories: [],
      },
      {
        name: 'Mavic',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MB Wear',
        id: 'mb-wear',
        subcategories: [],
      },
      {
        name: 'Merida',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'Mons Royale',
        id: 'mons-royale',
        subcategories: [],
      },
      {
        name: 'Montura',
        id: 'montura',
        subcategories: [],
      },
      {
        name: 'Muc-Off',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'Muddy Fox',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'Nalini',
        id: 'nalini',
        subcategories: [],
      },
      {
        name: 'Nineyard',
        id: 'nineyard',
        subcategories: [],
      },
      {
        name: 'Norrona',
        id: 'norrona',
        subcategories: [],
      },
      {
        name: 'Northwave',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'Nuckily',
        id: 'nuckily',
        subcategories: [],
      },
      {
        name: 'Nukeproof',
        id: 'nukeproof',
        subcategories: [],
      },
      {
        name: 'Oakley',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'Odlo',
        id: 'odlo',
        subcategories: [],
      },
      {
        name: 'Onceuponaride',
        id: 'onceuponaride',
        subcategories: [],
      },
      {
        name: "O'Neal",
        id: 'oneal',
        subcategories: [],
      },
      {
        name: 'Orca',
        id: 'orca',
        subcategories: [],
      },
      {
        name: 'Pas Normal Studios',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'Patagonia',
        id: 'patagonia',
        subcategories: [],
      },
      {
        name: 'Pearl Izumi',
        id: 'pearl-izumi',
        subcategories: [],
      },
      {
        name: 'Pedaled',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'Pedla',
        id: 'pedla',
        subcategories: [],
      },
      {
        name: 'Picture Organic Clothing',
        id: 'picture-organic-clothing',
        subcategories: [],
      },
      {
        name: 'Pinnacle',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'Polaris',
        id: 'polaris',
        subcategories: [],
      },
      {
        name: 'Prong Horn',
        id: 'prong-horn',
        subcategories: [],
      },
      {
        name: 'Protective',
        id: 'protective',
        subcategories: [],
      },
      {
        name: 'Q36.5',
        id: 'q365',
        subcategories: [],
      },
      {
        name: 'Rab',
        id: 'rab',
        subcategories: [],
      },
      {
        name: 'Race Face',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'Radon',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'Rapha',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RH+',
        id: 'rh',
        subcategories: [],
      },
      {
        name: 'Ride Concepts',
        id: 'ride-concepts',
        subcategories: [],
      },
      {
        name: 'Riding Culture',
        id: 'riding-culture',
        subcategories: [],
      },
      {
        name: 'RTTShirts',
        id: 'rttshirts',
        subcategories: [],
      },
      {
        name: 'Santini',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'Scott',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'Shimano',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'Sombrio',
        id: 'sombrio',
        subcategories: [],
      },
      {
        name: 'Spatz',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'Specialized',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'Spiuk',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'Sportful',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'SQ Lab',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'Stoneman',
        id: 'stoneman',
        subcategories: [],
      },
      {
        name: 'Trek',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'Triple Eight',
        id: 'triple-eight',
        subcategories: [],
      },
      {
        name: 'Troy Lee Designs',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'TSG',
        id: 'tsg',
        subcategories: [],
      },
      {
        name: 'Universal Colours',
        id: 'universal-colours',
        subcategories: [],
      },
      {
        name: 'Van Rysel',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'Vaude',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'Velocio',
        id: 'velocio',
        subcategories: [],
      },
      {
        name: 'Void Cycling',
        id: 'void-cycling',
        subcategories: [],
      },
      {
        name: 'X-Bionic',
        id: 'x-bionic',
        subcategories: [],
      },
      {
        name: 'Zimtstern',
        id: 'zimtstern',
        subcategories: [],
      },
      {
        name: 'Zone 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Jerseys',
    id: 'Jerseys',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: '7Mesh',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'Aclima',
        id: 'aclima',
        subcategories: [],
      },
      {
        name: 'Adicta Lab',
        id: 'adicta-lab',
        subcategories: [],
      },
      {
        name: 'Adidas',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'Agu',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Alba Optics',
        id: 'alba-optics',
        subcategories: [],
      },
      {
        name: 'Albion',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'Ale',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'Alpine Bikes',
        id: 'alpine-bikes',
        subcategories: [],
      },
      {
        name: 'Alpinestars',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'Altura',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'Amplifi',
        id: 'amplifi',
        subcategories: [],
      },
      {
        name: 'Apace',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'Baisky',
        id: 'baisky',
        subcategories: [],
      },
      {
        name: 'BBB Cycling',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'Bellwether',
        id: 'bellwether',
        subcategories: [],
      },
      {
        name: 'Biehler',
        id: 'biehler',
        subcategories: [],
      },
      {
        name: 'Bike Inside Cycling Wear',
        id: 'bike-inside-cycling-wear',
        subcategories: [],
      },
      {
        name: 'Biketags',
        id: 'biketags',
        subcategories: [],
      },
      {
        name: 'Bioracer',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'Bombtrack Apparel',
        id: 'bombtrack-apparel',
        subcategories: [],
      },
      {
        name: 'Café Du Cycliste',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'Campagnolo',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'Cannondale',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'Castelli',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'Cervelo',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'Chapeau',
        id: 'chapeau',
        subcategories: [],
      },
      {
        name: 'Chiba',
        id: 'chiba',
        subcategories: [],
      },
      {
        name: 'Chrome Industries',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'Cinelli',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'Craft',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'Crankbrothers',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'Cube',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'Cycling Monks',
        id: 'cycling-monks',
        subcategories: [],
      },
      {
        name: 'Cycloholic',
        id: 'cycloholic',
        subcategories: [],
      },
      {
        name: 'Cycology',
        id: 'cycology',
        subcategories: [],
      },
      {
        name: 'Dare2B',
        id: 'dare2b',
        subcategories: [],
      },
      {
        name: 'Decathlon',
        id: 'decathlon',
        subcategories: [],
      },
      {
        name: 'Devold',
        id: 'devold',
        subcategories: [],
      },
      {
        name: 'Dharco',
        id: 'dharco',
        subcategories: [],
      },
      {
        name: 'dhb',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'Dianese',
        id: 'dianese',
        subcategories: [],
      },
      {
        name: 'Dirt Love',
        id: 'dirt-love',
        subcategories: [],
      },
      {
        name: 'Dirtlej',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'Dotout',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'Dynafit',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'Effetto Mariposa',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'Endless Local',
        id: 'endless-local',
        subcategories: [],
      },
      {
        name: 'Endura',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'Endurance',
        id: 'endurance',
        subcategories: [],
      },
      {
        name: 'Etnies',
        id: 'etnies',
        subcategories: [],
      },
      {
        name: 'Evoc Bike',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'Exustar',
        id: 'exustar',
        subcategories: [],
      },
      {
        name: 'Falke',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'Fasthouse',
        id: 'fasthouse',
        subcategories: [],
      },
      {
        name: 'FiveTen',
        id: 'fiveten',
        subcategories: [],
      },
      {
        name: 'Fox Racing',
        id: 'fox-racing',
        subcategories: [],
      },
      {
        name: 'Funkier',
        id: 'funkier',
        subcategories: [],
      },
      {
        name: 'G Form',
        id: 'g-form',
        subcategories: [],
      },
      {
        name: 'Gambit',
        id: 'gambit',
        subcategories: [],
      },
      {
        name: 'Giant',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'Giro',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'Gobik',
        id: 'gobik',
        subcategories: [],
      },
      {
        name: 'Gonso',
        id: 'gonso',
        subcategories: [],
      },
      {
        name: 'Gorewear',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'GripGrab',
        id: 'gripgrab',
        subcategories: [],
      },
      {
        name: 'Heini',
        id: 'heini',
        subcategories: [],
      },
      {
        name: 'Hiru',
        id: 'hiru',
        subcategories: [],
      },
      {
        name: 'HSR',
        id: 'hsr',
        subcategories: [],
      },
      {
        name: 'Huub Design',
        id: 'huub-design',
        subcategories: [],
      },
      {
        name: 'Hyve Sports',
        id: 'hyve-sports',
        subcategories: [],
      },
      {
        name: 'Ion',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'Isadore',
        id: 'isadore',
        subcategories: [],
      },
      {
        name: 'IXS',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'Jack Wolfskin',
        id: 'jack-wolfskin',
        subcategories: [],
      },
      {
        name: 'Kalas',
        id: 'kalas',
        subcategories: [],
      },
      {
        name: 'Karpos',
        id: 'karpos',
        subcategories: [],
      },
      {
        name: 'Katusha',
        id: 'katusha',
        subcategories: [],
      },
      {
        name: 'Kids Ride Shotgun',
        id: 'kids-ride-shotgun',
        subcategories: [],
      },
      {
        name: 'Le Col',
        id: 'le-col',
        subcategories: [],
      },
      {
        name: 'Leatt',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'Liv Apparel',
        id: 'liv-apparel',
        subcategories: [],
      },
      {
        name: 'Loffler',
        id: 'loffler',
        subcategories: [],
      },
      {
        name: 'Look',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'Loose Riders',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'Louis Garneau',
        id: 'louis-garneau',
        subcategories: [],
      },
      {
        name: 'MAAP',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'Magura',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'Maloja',
        id: 'maloja',
        subcategories: [],
      },
      {
        name: 'Martini Sportswear',
        id: 'martini-sportswear',
        subcategories: [],
      },
      {
        name: 'Mavic',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MB Wear',
        id: 'mb-wear',
        subcategories: [],
      },
      {
        name: 'Merida',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'Mons Royale',
        id: 'mons-royale',
        subcategories: [],
      },
      {
        name: 'Montura',
        id: 'montura',
        subcategories: [],
      },
      {
        name: 'Muc-Off',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'Muddy Fox',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'Nalini',
        id: 'nalini',
        subcategories: [],
      },
      {
        name: 'Nineyard',
        id: 'nineyard',
        subcategories: [],
      },
      {
        name: 'Norrona',
        id: 'norrona',
        subcategories: [],
      },
      {
        name: 'Northwave',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'Nuckily',
        id: 'nuckily',
        subcategories: [],
      },
      {
        name: 'Nuke Proof',
        id: 'nuke-proof',
        subcategories: [],
      },
      {
        name: 'Oakley',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'Odlo',
        id: 'odlo',
        subcategories: [],
      },
      {
        name: 'Onceuponaride',
        id: 'onceuponaride',
        subcategories: [],
      },
      {
        name: "O'Neal",
        id: 'oneal',
        subcategories: [],
      },
      {
        name: 'Orca',
        id: 'orca',
        subcategories: [],
      },
      {
        name: 'Pas Normal Studios',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'Patagonia',
        id: 'patagonia',
        subcategories: [],
      },
      {
        name: 'Pearl Izumi',
        id: 'pearl-izumi',
        subcategories: [],
      },
      {
        name: 'Pedaled',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'Pedla',
        id: 'pedla',
        subcategories: [],
      },
      {
        name: 'Picture Organic Clothing',
        id: 'picture-organic-clothing',
        subcategories: [],
      },
      {
        name: 'Pinnacle',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'Polaris',
        id: 'polaris',
        subcategories: [],
      },
      {
        name: 'Prong Horn',
        id: 'prong-horn',
        subcategories: [],
      },
      {
        name: 'Protective',
        id: 'protective',
        subcategories: [],
      },
      {
        name: 'Q36.5',
        id: 'q365',
        subcategories: [],
      },
      {
        name: 'RAB',
        id: 'rab',
        subcategories: [],
      },
      {
        name: 'Race Face',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'Radon',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'Rapha',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RH+',
        id: 'rh',
        subcategories: [],
      },
      {
        name: 'Ride Concepts',
        id: 'ride-concepts',
        subcategories: [],
      },
      {
        name: 'Riding Culture',
        id: 'riding-culture',
        subcategories: [],
      },
      {
        name: 'RTTSHIRTS',
        id: 'rttshirts',
        subcategories: [],
      },
      {
        name: 'Santini',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'Scott',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'Shimano',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'Sombrio',
        id: 'sombrio',
        subcategories: [],
      },
      {
        name: 'Spatz',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'Specialized',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'Spiuk',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'Sportful',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'SQ Lab',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'Stoneman',
        id: 'stoneman',
        subcategories: [],
      },
      {
        name: 'Trek',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'Triple-Eight',
        id: 'triple-eight',
        subcategories: [],
      },
      {
        name: 'Troy Lee Designs',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'TSG',
        id: 'tsg',
        subcategories: [],
      },
      {
        name: 'Van Rysel',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'Vaude',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'Velocio',
        id: 'velocio',
        subcategories: [],
      },
      {
        name: 'Void Cycling',
        id: 'void-cycling',
        subcategories: [],
      },
      {
        name: 'X-Bionic',
        id: 'x-bionic',
        subcategories: [],
      },
      {
        name: 'Zimtstern',
        id: 'zimtstern',
        subcategories: [],
      },
      {
        name: 'Zone 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Shoes',
    id: 'Shoes',
    subcategories: [
      {
        name: '45NRTH',
        id: '45nrth',
        subcategories: [],
      },
      {
        name: 'ADIDAS',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'BONT',
        id: 'bont',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'CAFÉ DU CYCLISTE',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CHROME',
        id: 'chrome',
        subcategories: [],
      },
      {
        name: 'CRANK BROTHERS',
        id: 'crank-brothers',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DHB',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'DIANESE',
        id: 'dianese',
        subcategories: [],
      },
      {
        name: 'DMT',
        id: 'dmt',
        subcategories: [],
      },
      {
        name: 'DYNAMIC',
        id: 'dynamic',
        subcategories: [],
      },
      {
        name: 'ENDURA',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'ETNIES',
        id: 'etnies',
        subcategories: [],
      },
      {
        name: 'FAVERO',
        id: 'favero',
        subcategories: [],
      },
      {
        name: 'FIRST',
        id: 'first',
        subcategories: [],
      },
      {
        name: 'FIVE',
        id: 'five',
        subcategories: [],
      },
      {
        name: 'FIVE TEN',
        id: 'five-ten',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'FLR',
        id: 'flr',
        subcategories: [],
      },
      {
        name: 'FOX',
        id: 'fox',
        subcategories: [],
      },
      {
        name: 'GAERNE',
        id: 'gaerne',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'GIRO',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'HASUS',
        id: 'hasus',
        subcategories: [],
      },
      {
        name: 'ION',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'LAKE',
        id: 'lake',
        subcategories: [],
      },
      {
        name: 'LEATT',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MUDDYFOX',
        id: 'muddyfox',
        subcategories: [],
      },
      {
        name: 'NATHAN',
        id: 'nathan',
        subcategories: [],
      },
      {
        name: 'NORTHWAVE',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'OAKLEY',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: "O'NEAL",
        id: 'oneal',
        subcategories: [],
      },
      {
        name: 'PAS NORMAL STUDIOS',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'PEARL',
        id: 'pearl',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'PROTECTIVE',
        id: 'protective',
        subcategories: [],
      },
      {
        name: 'QUOC',
        id: 'quoc',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RIDE',
        id: 'ride',
        subcategories: [],
      },
      {
        name: 'RIDE CONCEPTS',
        id: 'ride-concepts',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SIDI',
        id: 'sidi',
        subcategories: [],
      },
      {
        name: 'SKECHERS',
        id: 'skechers',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SPIUK',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'SQLAB',
        id: 'sqlab',
        subcategories: [],
      },
      {
        name: 'SUPLEST',
        id: 'suplest',
        subcategories: [],
      },
      {
        name: 'UYN',
        id: 'uyn',
        subcategories: [],
      },
      {
        name: 'VAUDE',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'VIBRAM FIVEFINGERS',
        id: 'vibram-fivefingers',
        subcategories: [],
      },
      {
        name: 'VITTORIA',
        id: 'vittoria',
        subcategories: [],
      },
      {
        name: 'WINSOLE',
        id: 'winsole',
        subcategories: [],
      },
      {
        name: 'XPEDO',
        id: 'xpedo',
        subcategories: [],
      },
      {
        name: 'ZONE 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Shoe Insoles',
    id: 'Shoe-Insoles',
    subcategories: [
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'CHROME INDUSTRIES',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'G8 PERFORMANCE',
        id: 'g8-performance',
        subcategories: [],
      },
      {
        name: 'LAKE',
        id: 'lake',
        subcategories: [],
      },
      {
        name: 'LOWA',
        id: 'lowa',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SIDAS',
        id: 'sidas',
        subcategories: [],
      },
      {
        name: 'SOLESTAR',
        id: 'solestar',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SQLAB',
        id: 'sqlab',
        subcategories: [],
      },
      {
        name: 'SUPERFEET',
        id: 'superfeet',
        subcategories: [],
      },
      {
        name: 'THERM-IC',
        id: 'therm-ic',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'WINSOLE',
        id: 'winsole',
        subcategories: [],
      },
      {
        name: 'WOOLPOWER',
        id: 'woolpower',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Skin Suits',
    id: 'Skin-Suits',
    subcategories: [
      {
        name: '2XU',
        id: '2xu',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'ALE',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'APACE',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'ASSOS',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'BIORACER',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'CASTELLI',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DHB',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'DIRTLEJ',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'ENDURA',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'HIRU',
        id: 'hiru',
        subcategories: [],
      },
      {
        name: 'LEATT',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'NALINI',
        id: 'nalini',
        subcategories: [],
      },
      {
        name: 'PAS NORMAL STUDIOS',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'RULE 28',
        id: 'rule-28',
        subcategories: [],
      },
      {
        name: 'SANTINI',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SPORTFUL',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'ZONE 3',
        id: 'zone-3',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Socks',
    id: 'Socks',
    subcategories: [
      {
        name: '100%',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: '7MESH',
        id: '7mesh',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'ALÉ',
        id: 'ale',
        subcategories: [],
      },
      {
        name: 'ALPINESTARS',
        id: 'alpinestars',
        subcategories: [],
      },
      {
        name: 'APACE',
        id: 'apace',
        subcategories: [],
      },
      {
        name: 'ASSOS',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'BIEHLER SPORTSWEAR',
        id: 'biehler-sportswear',
        subcategories: [],
      },
      {
        name: 'BIORACER',
        id: 'bioracer',
        subcategories: [],
      },
      {
        name: 'BLACK SHEEP CYCLING',
        id: 'black-sheep-cycling',
        subcategories: [],
      },
      {
        name: 'BOMBTRACK',
        id: 'bombtrack',
        subcategories: [],
      },
      {
        name: 'CASTELLI',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'CHROME INDUSTRIES',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'COMPRESSPORT',
        id: 'compressport',
        subcategories: [],
      },
      {
        name: 'CRAFT',
        id: 'craft',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DAINESE',
        id: 'dainese',
        subcategories: [],
      },
      {
        name: 'DEFEET',
        id: 'defeet',
        subcategories: [],
      },
      {
        name: 'DEXSHELL',
        id: 'dexshell',
        subcategories: [],
      },
      {
        name: 'DHB',
        id: 'dhb',
        subcategories: [],
      },
      {
        name: 'DIRTLEJ',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'DOTOUT',
        id: 'dotout',
        subcategories: [],
      },
      {
        name: 'DYNAFIT',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'ENDLESS LOCAL',
        id: 'endless-local',
        subcategories: [],
      },
      {
        name: 'ENDURA',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'EVOC BIKE',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'FALKE',
        id: 'falke',
        subcategories: [],
      },
      {
        name: 'FINGERSCROSSED',
        id: 'fingerscrossed',
        subcategories: [],
      },
      {
        name: 'FIVE TEN',
        id: 'five-ten',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'FOX RACING',
        id: 'fox-racing',
        subcategories: [],
      },
      {
        name: 'GAERNE',
        id: 'gaerne',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'GIRO',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'GOREWEAR',
        id: 'gorewear',
        subcategories: [],
      },
      {
        name: 'GRIPGRAB',
        id: 'gripgrab',
        subcategories: [],
      },
      {
        name: 'HIRU',
        id: 'hiru',
        subcategories: [],
      },
      {
        name: 'HUUB DESIGN',
        id: 'huub-design',
        subcategories: [],
      },
      {
        name: 'ICEBUG',
        id: 'icebug',
        subcategories: [],
      },
      {
        name: 'INCYLENCE',
        id: 'incylence',
        subcategories: [],
      },
      {
        name: 'ION',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'ISADORE',
        id: 'isadore',
        subcategories: [],
      },
      {
        name: 'IXS',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'JACK WOLFSKIN',
        id: 'jack-wolfskin',
        subcategories: [],
      },
      {
        name: 'KARPOS',
        id: 'karpos',
        subcategories: [],
      },
      {
        name: 'LE COL',
        id: 'le-col',
        subcategories: [],
      },
      {
        name: 'LEATT',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'LOOSE RIDERS',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'MAAP',
        id: 'maap',
        subcategories: [],
      },
      {
        name: 'MALOJA',
        id: 'maloja',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MONS ROYALE',
        id: 'mons-royale',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'NALINI',
        id: 'nalini',
        subcategories: [],
      },
      {
        name: 'NORTHWAVE',
        id: 'northwave',
        subcategories: [],
      },
      {
        name: 'OAKLEY',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'ODLO',
        id: 'odlo',
        subcategories: [],
      },
      {
        name: "O'NEAL",
        id: 'o-neal',
        subcategories: [],
      },
      {
        name: 'PAS NORMAL STUDIOS',
        id: 'pas-normal-studios',
        subcategories: [],
      },
      {
        name: 'PEARL IZUMI',
        id: 'pearl-izumi',
        subcategories: [],
      },
      {
        name: 'PEDALED',
        id: 'pedaled',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'PRONGHORN',
        id: 'pronghorn',
        subcategories: [],
      },
      {
        name: 'PROTECTIVE',
        id: 'protective',
        subcategories: [],
      },
      {
        name: 'Q36.5',
        id: 'q36-5',
        subcategories: [],
      },
      {
        name: 'QUOC',
        id: 'quoc',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RH+',
        id: 'rh-plus',
        subcategories: [],
      },
      {
        name: 'RIDE CONCEPTS',
        id: 'ride-concepts',
        subcategories: [],
      },
      {
        name: 'RULE 28',
        id: 'rule-28',
        subcategories: [],
      },
      {
        name: 'SANTINI',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SIDI',
        id: 'sidi',
        subcategories: [],
      },
      {
        name: 'SOMBRIO',
        id: 'sombrio',
        subcategories: [],
      },
      {
        name: 'SPATZ',
        id: 'spatz',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SPIUK',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'SPORCKS',
        id: 'sporcks',
        subcategories: [],
      },
      {
        name: 'SPORTFUL',
        id: 'sportful',
        subcategories: [],
      },
      {
        name: 'STANCE',
        id: 'stance',
        subcategories: [],
      },
      {
        name: 'SUPLEST',
        id: 'suplest',
        subcategories: [],
      },
      {
        name: 'SWEET PROTECTION',
        id: 'sweet-protection',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TROY LEE DESIGNS',
        id: 'troy-lee-designs',
        subcategories: [],
      },
      {
        name: 'UNIVERSAL COLOURS',
        id: 'universal-colours',
        subcategories: [],
      },
      {
        name: 'UYN',
        id: 'uyn',
        subcategories: [],
      },
      {
        name: 'VAUDE',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'VELOTOZE',
        id: 'velotoze',
        subcategories: [],
      },
      {
        name: 'VOID CYCLING',
        id: 'void-cycling',
        subcategories: [],
      },
      {
        name: 'X-SOCKS',
        id: 'x-socks',
        subcategories: [],
      },
      {
        name: 'ZIMTSTERN',
        id: 'zimtstern',
        subcategories: [],
      },
      {
        name: 'POP CYCLING',
        id: 'pop-cycling',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Sunglasses',
    id: 'Sunglasses',
    subcategories: [
      {
        name: '100 Percent',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: 'Abus',
        id: 'abus',
        subcategories: [],
      },
      {
        name: 'Adidas',
        id: 'adidas',
        subcategories: [],
      },
      {
        name: 'Agu',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'Alba Optics',
        id: 'alba-optics',
        subcategories: [],
      },
      {
        name: 'Assos',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'Attaquer',
        id: 'attaquer',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'Bliz',
        id: 'bliz',
        subcategories: [],
      },
      {
        name: 'Bolle',
        id: 'bolle',
        subcategories: [],
      },
      {
        name: 'Café Du Cycliste',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'Casco',
        id: 'casco',
        subcategories: [],
      },
      {
        name: 'Cratoni',
        id: 'cratoni',
        subcategories: [],
      },
      {
        name: 'Dainese',
        id: 'dainese',
        subcategories: [],
      },
      {
        name: 'Decathlon',
        id: 'decathlon',
        subcategories: [],
      },
      {
        name: 'Dirtlej',
        id: 'dirtlej',
        subcategories: [],
      },
      {
        name: 'Dragon',
        id: 'dragon',
        subcategories: [],
      },
      {
        name: 'Dynafit',
        id: 'dynafit',
        subcategories: [],
      },
      {
        name: 'Dynamic',
        id: 'dynamic',
        subcategories: [],
      },
      {
        name: 'Endura',
        id: 'endura',
        subcategories: [],
      },
      {
        name: 'Enlee',
        id: 'enlee',
        subcategories: [],
      },
      {
        name: 'Ess',
        id: 'ess',
        subcategories: [],
      },
      {
        name: 'Fox',
        id: 'fox',
        subcategories: [],
      },
      {
        name: 'Giant',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'Giro',
        id: 'giro',
        subcategories: [],
      },
      {
        name: 'Goodr',
        id: 'goodr',
        subcategories: [],
      },
      {
        name: 'IXS',
        id: 'ixs',
        subcategories: [],
      },
      {
        name: 'Julbo',
        id: 'julbo',
        subcategories: [],
      },
      {
        name: 'Kali',
        id: 'kali',
        subcategories: [],
      },
      {
        name: 'Koo',
        id: 'koo',
        subcategories: [],
      },
      {
        name: 'Lenskart',
        id: 'lenskart',
        subcategories: [],
      },
      {
        name: 'Madison',
        id: 'madison',
        subcategories: [],
      },
      {
        name: 'Magicshine',
        id: 'magicshine',
        subcategories: [],
      },
      {
        name: 'Nike',
        id: 'nike',
        subcategories: [],
      },
      {
        name: 'Oakley',
        id: 'oakley',
        subcategories: [],
      },
      {
        name: 'Pinnacle',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'Pit Viper',
        id: 'pit-viper',
        subcategories: [],
      },
      {
        name: 'Poc',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'Rapha',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'React',
        id: 'react',
        subcategories: [],
      },
      {
        name: 'Rh+',
        id: 'rh+',
        subcategories: [],
      },
      {
        name: 'Rockbros',
        id: 'rockbros',
        subcategories: [],
      },
      {
        name: 'Roka',
        id: 'roka',
        subcategories: [],
      },
      {
        name: 'Rudy Project',
        id: 'rudy-project',
        subcategories: [],
      },
      {
        name: 'Salice',
        id: 'salice',
        subcategories: [],
      },
      {
        name: 'Scicon',
        id: 'scicon',
        subcategories: [],
      },
      {
        name: 'Scott',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'Scvcn',
        id: 'scvcn',
        subcategories: [],
      },
      {
        name: 'Shimano',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'Smith',
        id: 'smith',
        subcategories: [],
      },
      {
        name: 'Spektrum',
        id: 'spektrum',
        subcategories: [],
      },
      {
        name: 'Spiuk',
        id: 'spiuk',
        subcategories: [],
      },
      {
        name: 'Sungod',
        id: 'sungod',
        subcategories: [],
      },
      {
        name: 'Sweet Protection',
        id: 'sweet-protection',
        subcategories: [],
      },
      {
        name: 'Swiss Eye',
        id: 'swiss-eye',
        subcategories: [],
      },
      {
        name: 'Tifosi',
        id: 'tifosi',
        subcategories: [],
      },
      {
        name: 'Uvex',
        id: 'uvex',
        subcategories: [],
      },
      {
        name: 'Van Rysel',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'Victory Chimp',
        id: 'victory-chimp',
        subcategories: [],
      },
      {
        name: 'Vinco',
        id: 'vinco',
        subcategories: [],
      },
      {
        name: 'Zakpro',
        id: 'zakpro',
        subcategories: [],
      },
      {
        name: 'Zone 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    subcategories: bikeBrands,
    name: 'Road Bikes',
    id: 'Road-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Gravel Bikes',
    id: 'Gravel-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Hybrid Bikes',
    id: 'Hybrid-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Mountain Bikes',
    id: 'Mountain-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Time Trial Bikes',
    id: 'Time-Trial-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Triathlon Bikes',
    id: 'Triathlon-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Cyclocross Bikes',
    id: 'Cyclocross-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Cross Country Bikes',
    id: 'Cross-Country-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Folding Bikes',
    id: 'Folding-Bikes',
  },
  {
    subcategories: bikeBrands,
    name: 'Road Framesets',
    id: 'Road-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Gravel Framesets',
    id: 'Gravel-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Hybrid Framesets',
    id: 'Hybrid-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Mountain Framesets',
    id: 'Mountain-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Time Trial Framesets',
    id: 'Time-Trial-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Triathlon Framesets',
    id: 'Triathlon-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Cyclocross Framesets',
    id: 'Cyclocross-Framesets',
  },
  {
    subcategories: bikeBrands,
    name: 'Cross Country Framesets',
    id: 'Cross-Country-Framesets',
  },
  {
    name: 'Bartapes',
    id: 'Bartapes',
    subcategories: [],
  },
  {
    name: 'Bells',
    id: 'Bells',
    subcategories: [
      {
        name: 'BASIL',
        id: 'basil',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BELL',
        id: 'bell',
        subcategories: [],
      },
      {
        name: 'BRAVE',
        id: 'brave',
        subcategories: [],
      },
      {
        name: 'CATEYE',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'CRANE',
        id: 'crane',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'KNOG',
        id: 'knog',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'M WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'PROFILE DESIGN',
        id: 'profile-design',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'VELO ORANGE',
        id: 'velo-orange',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZONE 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Bike Computers',
    id: 'Bike-Computers',
    subcategories: [
      {
        name: 'BRYTON',
        id: 'bryton',
        subcategories: [],
      },
      {
        name: 'CATEYE',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'CICLOSPORT',
        id: 'ciclosport',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'GARMIN',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HAMMERHEAD',
        id: 'hammerhead',
        subcategories: [],
      },
      {
        name: 'IGPS',
        id: 'igps',
        subcategories: [],
      },
      {
        name: 'MAGENE',
        id: 'magene',
        subcategories: [],
      },
      {
        name: 'MEILAN',
        id: 'meilan',
        subcategories: [],
      },
      {
        name: 'MIO NAVIGATION',
        id: 'mio-navigation',
        subcategories: [],
      },
      {
        name: 'POLAR',
        id: 'polar',
        subcategories: [],
      },
      {
        name: 'SIGMA',
        id: 'sigma',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Bike Bags',
    id: 'Bike-Bags',
    subcategories: [
      {
        name: 'ALBION',
        id: 'albion',
        subcategories: [],
      },
      {
        name: 'ALTURA',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'APIDURA',
        id: 'apidura',
        subcategories: [],
      },
      {
        name: 'B&W',
        id: 'b&w',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMELBAK',
        id: 'camelbak',
        subcategories: [],
      },
      {
        name: 'CASTELLI',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'EVOC',
        id: 'evoc',
        subcategories: [],
      },
      {
        name: 'FEEDBACK SPORTS',
        id: 'feedback-sports',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'HUMP',
        id: 'hump',
        subcategories: [],
      },
      {
        name: 'OCCAM',
        id: 'occam',
        subcategories: [],
      },
      {
        name: 'ORCA',
        id: 'orca',
        subcategories: [],
      },
      {
        name: 'ORTLIEB',
        id: 'ortlieb',
        subcategories: [],
      },
      {
        name: 'OSPREY',
        id: 'osprey',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'PATAGONIA',
        id: 'patagonia',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RESTRAP',
        id: 'restrap',
        subcategories: [],
      },
      {
        name: 'SCICON',
        id: 'scicon',
        subcategories: [],
      },
      {
        name: 'SHOKBOX',
        id: 'shokbox',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'ZONE 3',
        id: 'zone-3',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Bidons',
    id: 'Bidons',
    subcategories: [],
  },
  {
    name: 'Bottle Cages',
    id: 'Bottle-Cages',
    subcategories: [],
  },
  {
    name: 'Bike Care & Maintenance',
    id: 'Bike-Care-And-Maintenance',
    subcategories: [
      {
        name: 'ANDIDOT',
        id: 'andidot',
        subcategories: [],
      },
      {
        name: 'AQUA2GO',
        id: 'aqua2go',
        subcategories: [],
      },
      {
        name: 'AVID',
        id: 'avid',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIKEWORKX',
        id: 'bikeworkx',
        subcategories: [],
      },
      {
        name: 'BLEEDKIT',
        id: 'bleedkit',
        subcategories: [],
      },
      {
        name: 'BLUECHAIN',
        id: 'bluechain',
        subcategories: [],
      },
      {
        name: 'BROOKS ENGLAND',
        id: 'brooks-england',
        subcategories: [],
      },
      {
        name: 'BRUNOX',
        id: 'brunox',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'CYCLUS',
        id: 'cyclus',
        subcategories: [],
      },
      {
        name: 'CYCLUS TOOLS',
        id: 'cyclus-tools',
        subcategories: [],
      },
      {
        name: 'DR WACK',
        id: 'dr-wack',
        subcategories: [],
      },
      {
        name: 'DYNAMIC',
        id: 'dynamic',
        subcategories: [],
      },
      {
        name: 'EFFETTO MARIPOSA',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'FINISH LINE',
        id: 'finish-line',
        subcategories: [],
      },
      {
        name: 'FORMULA',
        id: 'formula',
        subcategories: [],
      },
      {
        name: 'GATES CARBON DRIVE',
        id: 'gates-carbon-drive',
        subcategories: [],
      },
      {
        name: 'HAYES',
        id: 'hayes',
        subcategories: [],
      },
      {
        name: 'HOLMENKOL',
        id: 'holmenkol',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'INNOBIKE',
        id: 'innobike',
        subcategories: [],
      },
      {
        name: 'JAGWIRE',
        id: 'jagwire',
        subcategories: [],
      },
      {
        name: 'JOES NO FLATS',
        id: 'joes-no-flats',
        subcategories: [],
      },
      {
        name: 'LIGHTWEIGHT',
        id: 'lightweight',
        subcategories: [],
      },
      {
        name: 'LIQUI MOLY',
        id: 'liqui-moly',
        subcategories: [],
      },
      {
        name: 'MAGURA',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'MAVIC PARTS',
        id: 'mavic-parts',
        subcategories: [],
      },
      {
        name: 'MOTOREX',
        id: 'motorex',
        subcategories: [],
      },
      {
        name: 'MOTUL',
        id: 'motul',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'PANZERGLASS',
        id: 'panzerglass',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PEATYS',
        id: 'peatys',
        subcategories: [],
      },
      {
        name: 'PEDROS',
        id: 'pedros',
        subcategories: [],
      },
      {
        name: 'PRIMUS',
        id: 'primus',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'ROHLOFF',
        id: 'rohloff',
        subcategories: [],
      },
      {
        name: 'RSP',
        id: 'rsp',
        subcategories: [],
      },
      {
        name: 'SCHWALBE',
        id: 'schwalbe',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SIGG',
        id: 'sigg',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SKS',
        id: 'sks',
        subcategories: [],
      },
      {
        name: 'SQUIRT LUBE',
        id: 'squirt-lube',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SWISSSTOP',
        id: 'swissstop',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TEKTRO',
        id: 'tektro',
        subcategories: [],
      },
      {
        name: 'TRICKSTUFF',
        id: 'trickstuff',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'VAR',
        id: 'var',
        subcategories: [],
      },
      {
        name: 'WD-40',
        id: 'wd-40',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'YAKIMA',
        id: 'yakima',
        subcategories: [],
      },
      {
        name: 'YETI CYCLES',
        id: 'yeti-cycles',
        subcategories: [],
      },
      {
        name: 'ZÉFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Bike Storage',
    id: 'Bike-Storage',
    subcategories: [
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BICYCLE GEAR',
        id: 'bicycle-gear',
        subcategories: [],
      },
      {
        name: 'CACTUS TONGUE',
        id: 'cactus-tongue',
        subcategories: [],
      },
      {
        name: 'CAFÉ DU CYCLISTE',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DELTA',
        id: 'delta',
        subcategories: [],
      },
      {
        name: 'FEEDBACK SPORTS',
        id: 'feedback-sports',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'HIPLOK',
        id: 'hiplok',
        subcategories: [],
      },
      {
        name: 'KROSS',
        id: 'kross',
        subcategories: [],
      },
      {
        name: 'ONGUARD',
        id: 'onguard',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'TERN',
        id: 'tern',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'VADOLIBERO',
        id: 'vadolibero',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Car Racks',
    id: 'Car-Racks',
    subcategories: [
      {
        name: 'BNB RACKS',
        id: 'bnb-racks',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BT-WIN',
        id: 'bt-win',
        subcategories: [],
      },
      {
        name: 'EVOC',
        id: 'evoc',
        subcategories: [],
      },
      {
        name: 'JACK',
        id: 'jack',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'PERUZZO',
        id: 'peruzzo',
        subcategories: [],
      },
      {
        name: 'SARIS',
        id: 'saris',
        subcategories: [],
      },
      {
        name: 'SEASUCKER',
        id: 'seasucker',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Cleats',
    id: 'Cleats',
    subcategories: [],
  },
  {
    name: 'Cleaners & Degreasers',
    id: 'Cleaners-and-Degreasers',
    subcategories: [],
  },
  {
    name: 'CO2 Inflators',
    id: 'CO2-Inflators',
    subcategories: [],
  },
  {
    name: 'Fenders',
    id: 'Fenders',
    subcategories: [
      {
        name: '100 PERCENT',
        id: '100-percent',
        subcategories: [],
      },
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'ASS SAVERS',
        id: 'ass-savers',
        subcategories: [],
      },
      {
        name: 'ASSOS',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BROOKS',
        id: 'brooks',
        subcategories: [],
      },
      {
        name: 'BURGTEC',
        id: 'burgtec',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'DIA COMPE',
        id: 'dia-compe',
        subcategories: [],
      },
      {
        name: 'DRIVER',
        id: 'driver',
        subcategories: [],
      },
      {
        name: 'FOX RACING SHOX',
        id: 'fox-racing-shox',
        subcategories: [],
      },
      {
        name: 'HEBIE',
        id: 'hebie',
        subcategories: [],
      },
      {
        name: 'KINESIS',
        id: 'kinesis',
        subcategories: [],
      },
      {
        name: 'LOOSE RIDERS',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'MARSH GUARD',
        id: 'marsh-guard',
        subcategories: [],
      },
      {
        name: 'MUD HUGGERS',
        id: 'mud-huggers',
        subcategories: [],
      },
      {
        name: 'MUS GUARD',
        id: 'mus-guard',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'RRP',
        id: 'rrp',
        subcategories: [],
      },
      {
        name: 'SKS',
        id: 'sks',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'UNLEAZHED',
        id: 'unleazhed',
        subcategories: [],
      },
      {
        name: 'VELO ORANGE',
        id: 'velo-orange',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Frame Bags',
    id: 'Frame-Bags',
    subcategories: [
      {
        name: 'ALTURA',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'BACKCOUNTRY RESEARCH',
        id: 'backcountry-research',
        subcategories: [],
      },
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BROOKS ENGLAND',
        id: 'brooks-england',
        subcategories: [],
      },
      {
        name: 'DUNLOP',
        id: 'dunlop',
        subcategories: [],
      },
      {
        name: 'EVOC',
        id: 'evoc',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LIZARD SKINS',
        id: 'lizard-skins',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'ORTLIEB',
        id: 'ortlieb',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'PEATYS PRODUCTS',
        id: 'peatys-products',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Trainers',
    id: 'Trainers',
    subcategories: [
      {
        name: 'DXC',
        id: 'dxc',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'FEEDBACK SPORTS',
        id: 'feedback-sports',
        subcategories: [],
      },
      {
        name: 'JET BLACK',
        id: 'jet-black',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'SAMSUNG',
        id: 'samsung',
        subcategories: [],
      },
      {
        name: 'SARIS',
        id: 'saris',
        subcategories: [],
      },
      {
        name: 'STAGES',
        id: 'stages',
        subcategories: [],
      },
      {
        name: 'TACX',
        id: 'tacx',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
      {
        name: 'ZYCLE',
        id: 'zycle',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Heart Rate Monitor',
    id: 'Heart-Rate-Monitor',
    subcategories: [
      {
        name: '4IIII',
        id: '4iiii',
        subcategories: [],
      },
      {
        name: 'CATEYE',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'COROS',
        id: 'coros',
        subcategories: [],
      },
      {
        name: 'GARMIN',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'HAMMERHEAD',
        id: 'hammerhead',
        subcategories: [],
      },
      {
        name: 'IGPS',
        id: 'igps',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'MAGENE',
        id: 'magene',
        subcategories: [],
      },
      {
        name: 'MEILAN',
        id: 'meilan',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Hydration Packs',
    id: 'Hydration-Packs',
    subcategories: [
      {
        name: 'ABUS',
        id: 'abus',
        subcategories: [],
      },
      {
        name: 'AEVOR',
        id: 'aevor',
        subcategories: [],
      },
      {
        name: 'AGU',
        id: 'agu',
        subcategories: [],
      },
      {
        name: 'AMPLIFI',
        id: 'amplifi',
        subcategories: [],
      },
      {
        name: 'ASSOS',
        id: 'assos',
        subcategories: [],
      },
      {
        name: 'BACH',
        id: 'bach',
        subcategories: [],
      },
      {
        name: 'BASIL',
        id: 'basil',
        subcategories: [],
      },
      {
        name: 'BIKEPARKA',
        id: 'bikeparka',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BROOKS ENGLAND',
        id: 'brooks-england',
        subcategories: [],
      },
      {
        name: 'CAMELBAK',
        id: 'camelbak',
        subcategories: [],
      },
      {
        name: 'CASTELLI',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'CHROME INDUSTRIES',
        id: 'chrome-industries',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'CYCLITE',
        id: 'cyclite',
        subcategories: [],
      },
      {
        name: 'DAKINE',
        id: 'dakine',
        subcategories: [],
      },
      {
        name: 'DEUTER',
        id: 'deuter',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'EVOC BIKE',
        id: 'evoc-bike',
        subcategories: [],
      },
      {
        name: 'EVOC SNOW',
        id: 'evoc-snow',
        subcategories: [],
      },
      {
        name: 'EXPED',
        id: 'exped',
        subcategories: [],
      },
      {
        name: 'FIDLOCK',
        id: 'fidlock',
        subcategories: [],
      },
      {
        name: 'FJALLRAVEN',
        id: 'fjallraven',
        subcategories: [],
      },
      {
        name: 'FOX RACING',
        id: 'fox-racing',
        subcategories: [],
      },
      {
        name: 'GREGORY',
        id: 'gregory',
        subcategories: [],
      },
      {
        name: 'HYDRAPAK',
        id: 'hydrapak',
        subcategories: [],
      },
      {
        name: 'ION',
        id: 'ion',
        subcategories: [],
      },
      {
        name: 'JACK WOLFSKIN',
        id: 'jack-wolfskin',
        subcategories: [],
      },
      {
        name: 'KLICKFIX',
        id: 'klickfix',
        subcategories: [],
      },
      {
        name: 'KOMPERDELL',
        id: 'komperdell',
        subcategories: [],
      },
      {
        name: 'LEATT',
        id: 'leatt',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LOOSE RIDERS',
        id: 'loose-riders',
        subcategories: [],
      },
      {
        name: 'NATHAN SPORTS',
        id: 'nathan-sports',
        subcategories: [],
      },
      {
        name: 'NORRONA',
        id: 'norrona',
        subcategories: [],
      },
      {
        name: 'OAK25',
        id: 'oak25',
        subcategories: [],
      },
      {
        name: 'ORTLIEB',
        id: 'ortlieb',
        subcategories: [],
      },
      {
        name: 'OSPREY',
        id: 'osprey',
        subcategories: [],
      },
      {
        name: 'PATAGONIA',
        id: 'patagonia',
        subcategories: [],
      },
      {
        name: 'PICTURE ORGANIC CLOTHING',
        id: 'picture-organic-clothing',
        subcategories: [],
      },
      {
        name: 'PLATYPUS',
        id: 'platypus',
        subcategories: [],
      },
      {
        name: 'POC',
        id: 'poc',
        subcategories: [],
      },
      {
        name: 'RAB',
        id: 'rab',
        subcategories: [],
      },
      {
        name: 'SAILFISH',
        id: 'sailfish',
        subcategories: [],
      },
      {
        name: 'SANTINI',
        id: 'santini',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SILVA',
        id: 'silva',
        subcategories: [],
      },
      {
        name: 'SOURCE',
        id: 'source',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TATONKA',
        id: 'tatonka',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'USWE',
        id: 'uswe',
        subcategories: [],
      },
      {
        name: 'VAUDE',
        id: 'vaude',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
      {
        name: 'ZONE3',
        id: 'zone3',
        subcategories: [],
      },
      {
        name: 'ZOOT',
        id: 'zoot',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Lights',
    id: 'Lights',
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'AXA',
        id: 'axa',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BRYTON',
        id: 'bryton',
        subcategories: [],
      },
      {
        name: 'BUCHEL',
        id: 'buchel',
        subcategories: [],
      },
      {
        name: 'BUSCH',
        id: 'busch',
        subcategories: [],
      },
      {
        name: 'CAMELION',
        id: 'camelion',
        subcategories: [],
      },
      {
        name: 'CATEYE',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'CLOSETHEGAP',
        id: 'closethegap',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'EXPOSURE',
        id: 'exposure',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'FIONIC',
        id: 'fionic',
        subcategories: [],
      },
      {
        name: 'GARMIN',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'HERRMANS',
        id: 'herrmans',
        subcategories: [],
      },
      {
        name: 'INFINI',
        id: 'infini',
        subcategories: [],
      },
      {
        name: 'KNOG',
        id: 'knog',
        subcategories: [],
      },
      {
        name: 'KOKUA',
        id: 'kokua',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LITEMOVE',
        id: 'litemove',
        subcategories: [],
      },
      {
        name: 'LIVALL',
        id: 'livall',
        subcategories: [],
      },
      {
        name: 'LUMOS',
        id: 'lumos',
        subcategories: [],
      },
      {
        name: 'LUPINE',
        id: 'lupine',
        subcategories: [],
      },
      {
        name: 'M WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'MERIDA',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'MONKEYLINK',
        id: 'monkeylink',
        subcategories: [],
      },
      {
        name: 'MOON',
        id: 'moon',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'NITERIDER',
        id: 'niterider',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'SERFAS',
        id: 'serfas',
        subcategories: [],
      },
      {
        name: 'SIGMA',
        id: 'sigma',
        subcategories: [],
      },
      {
        name: 'SKS',
        id: 'sks',
        subcategories: [],
      },
      {
        name: 'SON',
        id: 'son',
        subcategories: [],
      },
      {
        name: 'SP CONNECT',
        id: 'sp-connect',
        subcategories: [],
      },
      {
        name: 'SPANNINGA',
        id: 'spanninga',
        subcategories: [],
      },
      {
        name: 'SUPERNOVA',
        id: 'supernova',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'TOOO CYCLING',
        id: 'tooo-cycling',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TRELOCK',
        id: 'trelock',
        subcategories: [],
      },
      {
        name: 'TRIPLE EIGHT',
        id: 'triple-eight',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Locks',
    id: 'Locks',
    subcategories: [
      {
        name: 'ABUS',
        id: 'abus',
        subcategories: [],
      },
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'AXA',
        id: 'axa',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DELTA',
        id: 'delta',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'HIPLOK',
        id: 'hiplok',
        subcategories: [],
      },
      {
        name: 'KNOG',
        id: 'knog',
        subcategories: [],
      },
      {
        name: 'KRYPTONITE',
        id: 'kryptonite',
        subcategories: [],
      },
      {
        name: 'M WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'ONGUARD',
        id: 'onguard',
        subcategories: [],
      },
      {
        name: 'OTTOLOCK',
        id: 'ottolock',
        subcategories: [],
      },
      {
        name: 'OXFORD',
        id: 'oxford',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'PITLOCK',
        id: 'pitlock',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'SCHWINN',
        id: 'schwinn',
        subcategories: [],
      },
      {
        name: 'SERFAS',
        id: 'serfas',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TRELOCK',
        id: 'trelock',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Lubricants',
    id: 'Lubricants',
    subcategories: [
      {
        name: 'ANTIDOT',
        id: 'antidot',
        subcategories: [],
      },
      {
        name: 'BIKEWORX',
        id: 'bikeworx',
        subcategories: [],
      },
      {
        name: 'BLUECHAIN',
        id: 'bluechain',
        subcategories: [],
      },
      {
        name: 'BRUNOX',
        id: 'brunox',
        subcategories: [],
      },
      {
        name: 'CADEX',
        id: 'cadex',
        subcategories: [],
      },
      {
        name: 'CERAMICSPEED',
        id: 'ceramicspeed',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'CYCLUS TOOLS',
        id: 'cyclus-tools',
        subcategories: [],
      },
      {
        name: 'DR WACK',
        id: 'dr-wack',
        subcategories: [],
      },
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'DYNAMIC',
        id: 'dynamic',
        subcategories: [],
      },
      {
        name: 'EFFETTO MARIPOSA',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'ENDURO',
        id: 'enduro',
        subcategories: [],
      },
      {
        name: 'EXTRALITE',
        id: 'extralite',
        subcategories: [],
      },
      {
        name: 'FINISH LINE',
        id: 'finish-line',
        subcategories: [],
      },
      {
        name: 'FORMULA',
        id: 'formula',
        subcategories: [],
      },
      {
        name: 'FOX FACTORY',
        id: 'fox-factory',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HOLMENKOL',
        id: 'holmenskol',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'INNOBIKE',
        id: 'innobike',
        subcategories: [],
      },
      {
        name: 'JOES NO FLATS',
        id: 'joes-no-flats',
        subcategories: [],
      },
      {
        name: 'KIND SHOCK',
        id: 'kind-shock',
        subcategories: [],
      },
      {
        name: 'LIQUI MOLY',
        id: 'liqui-moly',
        subcategories: [],
      },
      {
        name: 'MAGURA',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'MAVIC PARTS',
        id: 'mavic-parts',
        subcategories: [],
      },
      {
        name: 'MOTOREX',
        id: 'motorex',
        subcategories: [],
      },
      {
        name: 'MOTUL',
        id: 'motul',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'PEATYS',
        id: 'peatys',
        subcategories: [],
      },
      {
        name: 'PEDROS',
        id: 'pedros',
        subcategories: [],
      },
      {
        name: 'PINION',
        id: 'pinion',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'ROHLOFF',
        id: 'rohloff',
        subcategories: [],
      },
      {
        name: 'RSP',
        id: 'rsp',
        subcategories: [],
      },
      {
        name: 'SCHWALBE',
        id: 'schwalbe',
        subcategories: [],
      },
      {
        name: 'SHIMANO PARTS',
        id: 'shimano-parts',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SQUIRT LUBE',
        id: 'squirt-lube',
        subcategories: [],
      },
      {
        name: 'SR SUNTOUR',
        id: 'sr-suntour',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'STANS NOTUBES',
        id: 'stans-notubes',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'VAR',
        id: 'var',
        subcategories: [],
      },
      {
        name: 'WD-40',
        id: 'wd-40',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH',
        id: 'wolf-tooth',
        subcategories: [],
      },
      {
        name: 'YETI CYCLES',
        id: 'yeti-cycles',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Mirrors',
    id: 'Mirrors',
    subcategories: [
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'CATEYE',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'PROLINE',
        id: 'proline',
        subcategories: [],
      },
      {
        name: 'SPORTOURER',
        id: 'sportourer',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Pedals',
    id: 'Pedals',
    subcategories: [],
  },
  {
    name: 'Phone Cases',
    id: 'Phone-Cases',
    subcategories: [
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'CAFÉ DU CYCLISTE',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Phone Mounts',
    id: 'Phone-Mounts',
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'BAR FLY',
        id: 'bar-fly',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BOSCH',
        id: 'bosch',
        subcategories: [],
      },
      {
        name: 'ERGOTEC',
        id: 'ergotec',
        subcategories: [],
      },
      {
        name: 'F3 CYCLING',
        id: 'f3-cycling',
        subcategories: [],
      },
      {
        name: 'FESCHD',
        id: 'feschd',
        subcategories: [],
      },
      {
        name: 'FIDLOCK',
        id: 'fidlock',
        subcategories: [],
      },
      {
        name: 'IBERA',
        id: 'ibera',
        subcategories: [],
      },
      {
        name: 'KALF',
        id: 'kalf',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'M WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'NC-17',
        id: 'nc-17',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'QUAD LOCK',
        id: 'quad-lock',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'SERFAS',
        id: 'serfas',
        subcategories: [],
      },
      {
        name: 'SHAPEHEART',
        id: 'shapeheart',
        subcategories: [],
      },
      {
        name: 'SKS',
        id: 'sks',
        subcategories: [],
      },
      {
        name: 'SP CONNECT',
        id: 'sp-connect',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Pumps',
    id: 'Pumps',
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'AIRBORNE',
        id: 'airborne',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BLUECHAIN',
        id: 'bluechain',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BOSCH',
        id: 'bosch',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CITEC',
        id: 'citec',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DIVERSE',
        id: 'diverse',
        subcategories: [],
      },
      {
        name: 'DYNAPLUG',
        id: 'dynaplug',
        subcategories: [],
      },
      {
        name: 'EUFAB',
        id: 'eufab',
        subcategories: [],
      },
      {
        name: 'FOX FACTORY',
        id: 'fox-factory',
        subcategories: [],
      },
      {
        name: 'FUMPA PUMPS',
        id: 'fumpa-pumps',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'JOES NO FLATS',
        id: 'joes-no-flats',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LIFELINE',
        id: 'lifeline',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MICHELIN',
        id: 'michelin',
        subcategories: [],
      },
      {
        name: 'MILKIT',
        id: 'milk',
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'NOW8',
        id: 'now8',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PEATYS',
        id: 'peatys',
        subcategories: [],
      },
      {
        name: 'PEDROS',
        id: 'pedros',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'PROCRAFT',
        id: 'procraft',
        subcategories: [],
      },
      {
        name: 'PROFILE DESIGN',
        id: 'profile-design',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'RST',
        id: 'rst',
        subcategories: [],
      },
      {
        name: 'SCHWALBE',
        id: 'schwalbe',
        subcategories: [],
      },
      {
        name: 'SERFAS',
        id: 'serfas',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SKS',
        id: 'sks',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'STANS NOTUBES',
        id: 'stans-notubes',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'XLAB',
        id: 'xlab',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Puncture Repairs',
    id: 'Puncture-Repairs',
    subcategories: [
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BLUECHAIN',
        id: 'bluechain',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'JOES NO FLATS',
        id: 'joes-no-flats',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'MILKIT',
        id: 'milkit',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PEATYS',
        id: 'peatys',
        subcategories: [],
      },
      {
        name: 'PIRELLI',
        id: 'pirelli',
        subcategories: [],
      },
      {
        name: 'REVOLOOP',
        id: 'revoloop',
        subcategories: [],
      },
      {
        name: 'SCHWALBE',
        id: 'schwalbe',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TUBOLITO',
        id: 'tubolito',
        subcategories: [],
      },
      {
        name: 'VAR',
        id: 'var',
        subcategories: [],
      },
      {
        name: 'VITTORIA',
        id: 'vittoria',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Racks',
    id: 'Racks',
    subcategories: [
      {
        name: 'AEROE',
        id: 'aeroe',
        subcategories: [],
      },
      {
        name: 'ALTURA',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'ARNO',
        id: 'arno',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BERGAMONT',
        id: 'bergamont',
        subcategories: [],
      },
      {
        name: 'BIKEPARKA',
        id: 'bikeparka',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'EVOC BIKES',
        id: 'evoc-bikes',
        subcategories: [],
      },
      {
        name: 'JACK',
        id: 'jack',
        subcategories: [],
      },
      {
        name: 'ORTLIEB',
        id: 'ortlieb',
        subcategories: [],
      },
      {
        name: 'RESTRAP',
        id: 'restrap',
        subcategories: [],
      },
      {
        name: 'RIXEN & KAUL',
        id: 'rixen-kaul',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'TERN',
        id: 'tern',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TORTEC',
        id: 'tortec',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'YAKIMA',
        id: 'yakima',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Rollers',
    id: 'Rollers',
    subcategories: [
      {
        name: 'ASHWA PRO',
        id: 'ashwa-pro',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'MINOURA',
        id: 'minoura',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Saddle Frame Bags',
    id: 'Saddle Frame bags',
    subcategories: [
      {
        name: 'ANGRY PABLO',
        id: 'angry-pablo',
        subcategories: [],
      },
      {
        name: 'APIDURA',
        id: 'apidura',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BROOKS ENGLAND',
        id: 'brooks-england',
        subcategories: [],
      },
      {
        name: 'CAFÉ DU CYCLISTE',
        id: 'cafe-du-cycliste',
        subcategories: [],
      },
      {
        name: 'CASTELLI',
        id: 'castelli',
        subcategories: [],
      },
      {
        name: 'EVOC',
        id: 'evoc',
        subcategories: [],
      },
      {
        name: 'FIDLOCK',
        id: 'fidlock',
        subcategories: [],
      },
      {
        name: 'FINGERSCROSSED',
        id: 'fingerscrossed',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LIZARD SKINS',
        id: 'lizard-skins',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'ORTLIEB',
        id: 'ortlieb',
        subcategories: [],
      },
      {
        name: 'OSPREY',
        id: 'osprey',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'RAPHA',
        id: 'rapha',
        subcategories: [],
      },
      {
        name: 'RESTRAP',
        id: 'restrap',
        subcategories: [],
      },
      {
        name: 'SERFAS',
        id: 'serfas',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SKIN GROWS BACK',
        id: 'skin-grows-back',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'TERN',
        id: 'tern',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Sensors',
    id: 'Sensors',
    subcategories: [],
  },
  {
    name: 'Stands',
    id: 'Stands',
    subcategories: [
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'BLUECHAIN',
        id: 'bluechain',
        subcategories: [],
      },
      {
        name: 'BMC',
        id: 'bmc',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'Cannondale',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'CYCLOC',
        id: 'cycloc',
        subcategories: [],
      },
      {
        name: 'CYCLUS TOOLS',
        id: 'cyclus-tools',
        subcategories: [],
      },
      {
        name: 'EARLY RIDER',
        id: 'early-rider',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'FEEDBACK SPORTS',
        id: 'feedback-sports',
        subcategories: [],
      },
      {
        name: 'FINGERSCROSSED',
        id: 'fingerscrossed',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HEBIE',
        id: 'hebie',
        subcategories: [],
      },
      {
        name: 'HIPLOK',
        id: 'hiplok',
        subcategories: [],
      },
      {
        name: 'HORNIT',
        id: 'hornit',
        subcategories: [],
      },
      {
        name: 'KUBIKES',
        id: 'kubikes',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'PARAX',
        id: 'parax',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PLETSCHER',
        id: 'pletscher',
        subcategories: [],
      },
      {
        name: 'PROCRAFT',
        id: 'procraft',
        subcategories: [],
      },
      {
        name: 'PUKY',
        id: 'puky',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'STABILUS',
        id: 'stabilus',
        subcategories: [],
      },
      {
        name: 'SURLY PARTS',
        id: 'surly-parts',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'THULE',
        id: 'thule',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'UNIOR TOOLS',
        id: 'unior-tools',
        subcategories: [],
      },
      {
        name: 'WEBER',
        id: 'weber',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Accessories',
    id: 'Accessories',
    subcategories: [
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BEDIFOL',
        id: 'bedifol',
        subcategories: [],
      },
      {
        name: 'BIKE AHEAD COMPOSITES',
        id: 'bike-ahead-composites',
        subcategories: [],
      },
      {
        name: 'BMC',
        id: 'bmc',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CATEYE',
        id: 'cateye',
        subcategories: [],
      },
      {
        name: 'CICLOSPORT',
        id: 'ciclosport',
        subcategories: [],
      },
      {
        name: 'CLOSETHEGAP',
        id: 'closethegap',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'EXTRALITE',
        id: 'extralite',
        subcategories: [],
      },
      {
        name: 'FALK',
        id: 'falk',
        subcategories: [],
      },
      {
        name: 'FOCUS',
        id: 'focus',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GARMIN',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HAMMERHEAD',
        id: 'hammerhead',
        subcategories: [],
      },
      {
        name: 'INPEAK',
        id: 'inpeak',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'K-EDGE',
        id: 'k-edge',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LIVALL',
        id: 'livall',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MIO NAVIGATION',
        id: 'mio-navigation',
        subcategories: [],
      },
      {
        name: 'MOUNTY SPECIAL',
        id: 'mounty-special',
        subcategories: [],
      },
      {
        name: 'NC-17',
        id: 'nc-17',
        subcategories: [],
      },
      {
        name: 'O-SYNCE',
        id: 'o-synce',
        subcategories: [],
      },
      {
        name: 'PANZERGLASS',
        id: 'panzerglass',
        subcategories: [],
      },
      {
        name: 'POLAR',
        id: 'polar',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'PROBLEM SOLVERS',
        id: 'problem-solvers',
        subcategories: [],
      },
      {
        name: 'QUARQ',
        id: 'quarq',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SHOKZ',
        id: 'shokz',
        subcategories: [],
      },
      {
        name: 'SIGMA SPORT',
        id: 'sigma-sport',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SP CONNECT',
        id: 'sp-connect',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'STAGES CYCLING',
        id: 'stages-cycling',
        subcategories: [],
      },
      {
        name: 'SUUNTO',
        id: 'suunto',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
      {
        name: 'XLAB',
        id: 'xlab',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Tools',
    id: 'Tools',
    subcategories: [
      {
        name: 'ABBEY BIKE TOOLS',
        id: 'abbey-bike-tools',
        subcategories: [],
      },
      {
        name: 'AIRBORNE',
        id: 'airborne',
        subcategories: [],
      },
      {
        name: 'ALTURA',
        id: 'altura',
        subcategories: [],
      },
      {
        name: 'AVID',
        id: 'avid',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BGS TECHNIC',
        id: 'bgs-technic',
        subcategories: [],
      },
      {
        name: 'BIKE HAND',
        id: 'bike-hand',
        subcategories: [],
      },
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'BLACKBURN',
        id: 'blackburn',
        subcategories: [],
      },
      {
        name: 'BLEED KIT',
        id: 'bleed-kit',
        subcategories: [],
      },
      {
        name: 'BOSCH',
        id: 'bosch',
        subcategories: [],
      },
      {
        name: 'BROOKS',
        id: 'brooks',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CEMA',
        id: 'cema',
        subcategories: [],
      },
      {
        name: 'CHALLENGE',
        id: 'challenge',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'CUSHCORE',
        id: 'cushcore',
        subcategories: [],
      },
      {
        name: 'CYCLUS',
        id: 'cyclus',
        subcategories: [],
      },
      {
        name: 'DYNAMIC',
        id: 'dynamic',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'EUFAB',
        id: 'eufab',
        subcategories: [],
      },
      {
        name: 'FEEDBACK SPORTS',
        id: 'feedback-sports',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'FIDLOCK',
        id: 'fidlock',
        subcategories: [],
      },
      {
        name: 'FINISH LINE',
        id: 'finish-line',
        subcategories: [],
      },
      {
        name: 'FIXPLUS',
        id: 'fixplus',
        subcategories: [],
      },
      {
        name: 'FORMULA',
        id: 'formula',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GRANITE DESIGN',
        id: 'granite-design',
        subcategories: [],
      },
      {
        name: 'HAYES',
        id: 'hayes',
        subcategories: [],
      },
      {
        name: 'HIPLOK',
        id: 'hiplok',
        subcategories: [],
      },
      {
        name: 'JAGWIRE',
        id: 'jagwire',
        subcategories: [],
      },
      {
        name: 'JUICE LUBES',
        id: 'juice-lubes',
        subcategories: [],
      },
      {
        name: 'KATANA',
        id: 'katana',
        subcategories: [],
      },
      {
        name: 'KMC',
        id: 'kmc',
        subcategories: [],
      },
      {
        name: 'KNOG',
        id: 'knog',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LOCTITE',
        id: 'loctite',
        subcategories: [],
      },
      {
        name: 'MAGURA',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'MANITOU',
        id: 'manitou',
        subcategories: [],
      },
      {
        name: 'MILKIT',
        id: 'milk-it',
        subcategories: [],
      },
      {
        name: 'MOQUAI',
        id: 'moquai',
        subcategories: [],
      },
      {
        name: 'MORGAN BLUE',
        id: 'morgan-blue',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'NUTON',
        id: 'nuton',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PEATYS PRODUCTS',
        id: 'peatys-products',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'QUAXAR',
        id: 'quaxar',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'ROHLOFF',
        id: 'rohloff',
        subcategories: [],
      },
      {
        name: 'ROVAL',
        id: 'roval',
        subcategories: [],
      },
      {
        name: 'RRP',
        id: 'rrp',
        subcategories: [],
      },
      {
        name: 'RST',
        id: 'rst',
        subcategories: [],
      },
      {
        name: 'SCHWALBE',
        id: 'schwalbe',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SIGMA',
        id: 'sigma',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'SUPER B',
        id: 'super-b',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'TACX',
        id: 'tacx',
        subcategories: [],
      },
      {
        name: 'TOPEAK',
        id: 'topeak',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'UNIOR TOOLS',
        id: 'unior-tools',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'WEKEM',
        id: 'wekem',
        subcategories: [],
      },
      {
        name: 'WERA',
        id: 'wera',
        subcategories: [],
      },
      {
        name: 'WIPPERMANN CONNEX',
        id: 'wippermann-connex',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
  },
  {
    name: 'Watches',
    id: 'Watches',
    subcategories: [
      {
        name: 'COROS',
        id: 'coros',
        subcategories: [],
      },
      {
        name: 'DIGITSOLE',
        id: 'digitsole',
        subcategories: [],
      },
      {
        name: 'GARMIN',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'POLAR',
        id: 'polar',
        subcategories: [],
      },
      {
        name: 'SUUNTO',
        id: 'suunto',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
    ],
  },
  {
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'ARUNDEL',
        id: 'arundel',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROOKS',
        id: 'brooks',
        subcategories: [],
      },
      {
        name: 'BTP',
        id: 'btp',
        subcategories: [],
      },
      {
        name: 'BURGH',
        id: 'burgh',
        subcategories: [],
      },
      {
        name: 'CADEX',
        id: 'cadex',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CICLOVATION',
        id: 'ciclovation',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DEDA',
        id: 'deda',
        subcategories: [],
      },
      {
        name: 'DXC',
        id: 'dxc',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'ESI GRIPS',
        id: 'esi-grips',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'GUEE',
        id: 'guee',
        subcategories: [],
      },
      {
        name: 'JAGWIRE',
        id: 'jagwire',
        subcategories: [],
      },
      {
        name: 'KINESIS',
        id: 'kinesis',
        subcategories: [],
      },
      {
        name: 'LIV',
        id: 'liv',
        subcategories: [],
      },
      {
        name: 'LIZARD SKINS',
        id: 'lizard-skins',
        subcategories: [],
      },
      {
        name: 'M PART',
        id: 'm-part',
        subcategories: [],
      },
      {
        name: 'MERIDA',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'NATURAL FIT',
        id: 'natural-fit',
        subcategories: [],
      },
      {
        name: 'PHYSIOLOGY',
        id: 'physiology',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'PRO BIKE GEAR',
        id: 'pro-bike-gear',
        subcategories: [],
      },
      {
        name: 'PROFILE DESIGN',
        id: 'profile-design',
        subcategories: [],
      },
      {
        name: 'PROLOGO',
        id: 'prologo',
        subcategories: [],
      },
      {
        name: 'PROLOGUE',
        id: 'prologue',
        subcategories: [],
      },
      {
        name: 'QUAXAR',
        id: 'quaxar',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'SELLE ITALIA',
        id: 'selle-italia',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SMANIE',
        id: 'smanie',
        subcategories: [],
      },
      {
        name: 'SQ LAB',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUPACAZ',
        id: 'supacaz',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'VELOX',
        id: 'velox',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Bartape',
    id: 'Bartape',
  },
  {
    subcategories: [],
    name: 'Brake Cables',
    id: 'Brake-Cables',
  },
  {
    subcategories: [],
    name: 'Brake Pads',
    id: 'Brake-Pads',
  },
  {
    subcategories: [],
    name: 'Brake Calipers',
    id: 'Brake-Calipers',
  },
  {
    subcategories: [
      {
        name: 'ALLIGATOR',
        id: 'alligator',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'C-BEAR',
        id: 'c-bear',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'FRAEZEN',
        id: 'fraezen',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'LT-W00',
        id: 'lt-w00',
        subcategories: [],
      },
      {
        name: 'MICROSHIFT',
        id: 'microshift',
        subcategories: [],
      },
      {
        name: 'QUAXAR',
        id: 'quaxar',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'SENSAH EMPIRE',
        id: 'sensah-empire',
        subcategories: [],
      },
      {
        name: 'SHAKES',
        id: 'shakes',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'TEKTRO',
        id: 'tektro',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
    ],
    name: 'Shifter & Brake Levers',
    id: 'Shifter-And-Brake-Levers',
  },
  {
    subcategories: [],
    name: 'Brake Rotors',
    id: 'Brake-Rotors',
  },
  {
    subcategories: [
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'BBB CYCLING',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'BLACK BEARING',
        id: 'black-bearing',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'C-BEAR',
        id: 'c-bear',
        subcategories: [],
      },
      {
        name: 'CEMA',
        id: 'cema',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'BBB CYCLING',
        id: 'bbb-cycling',
        subcategories: [],
      },
      {
        name: 'BLACK BEARING',
        id: 'black-bearing',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'C-BEAR',
        id: 'c-bear',
        subcategories: [],
      },
      {
        name: 'CEMA',
        id: 'cema',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'CLEAN MOTION',
        id: 'clean-motion',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENDURO',
        id: 'enduro',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'ETURNITY',
        id: 'eternity',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'MAHLE',
        id: 'mahle',
        subcategories: [],
      },
      {
        name: 'MICHE',
        id: 'miche',
        subcategories: [],
      },
      {
        name: 'MOQUAI',
        id: 'moquai',
        subcategories: [],
      },
      {
        name: 'NOVA RIDE',
        id: 'nova-ride',
        subcategories: [],
      },
      {
        name: 'PRACTICE WORKS',
        id: 'practice-works',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'PRIME CYCLING',
        id: 'prime-cycling',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RHINODILLAS',
        id: 'rhinodillas',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SEIDO',
        id: 'seido',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'TANGESEIKI',
        id: 'tangeseiki',
        subcategories: [],
      },
      {
        name: 'THM',
        id: 'thm',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRICKSTUFF',
        id: 'trickstuff',
        subcategories: [],
      },
      {
        name: 'TRIPEAK',
        id: 'tripeak',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'VELO ORANGE',
        id: 'velo-orange',
        subcategories: [],
      },
      {
        name: 'VP COMPONENTS',
        id: 'vp-components',
        subcategories: [],
      },
      {
        name: 'WHEELS MANUFACTURING',
        id: 'wheels-manufacturing',
        subcategories: [],
      },
      {
        name: 'WHITE INDUSTRIES',
        id: 'white-industries',
        subcategories: [],
      },
    ],
    name: 'Bottom Brackets',
    id: 'Bottom-Brackets',
  },
  {
    subcategories: [
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GARBARUK',
        id: 'garbaruk',
        subcategories: [],
      },
      {
        name: 'HALO',
        id: 'halo',
        subcategories: [],
      },
      {
        name: 'HEBIE',
        id: 'hebie',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'KMC',
        id: 'kmc',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MICHE',
        id: 'miche',
        subcategories: [],
      },
      {
        name: 'MICROSHIFT',
        id: 'microshift',
        subcategories: [],
      },
      {
        name: 'NOW8',
        id: 'now8',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SENSAH',
        id: 'sensah',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUGINO',
        id: 'sugino',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'TIFOSI',
        id: 'tifosi',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
    ],
    name: 'Cassette & Firewheel',
    id: 'Cassettes-And-Firewheel',
  },
  {
    subcategories: [
      {
        name: '3T',
        id: '3t',
        subcategories: [],
      },
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'ALUGEAR',
        id: 'alugear',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BLACKSPIRE',
        id: 'blackspire',
        subcategories: [],
      },
      {
        name: 'BURGTEC',
        id: 'burgtec',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CARBON-TI',
        id: 'carbon-ti',
        subcategories: [],
      },
      {
        name: 'CHROMAG',
        id: 'chromag',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'EXTRALITE',
        id: 'extralite',
        subcategories: [],
      },
      {
        name: 'FRAEZEN',
        id: 'fraezen',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'FUNN',
        id: 'funn',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'LOXEAL',
        id: 'loxeal',
        subcategories: [],
      },
      {
        name: 'MICHAEL',
        id: 'michael',
        subcategories: [],
      },
      {
        name: 'MRP',
        id: 'mrp',
        subcategories: [],
      },
      {
        name: 'O.SYMETRIC',
        id: 'osymetric',
        subcategories: [],
      },
      {
        name: 'PINION',
        id: 'pinion',
        subcategories: [],
      },
      {
        name: 'PRACTICE WORKS',
        id: 'practice-works',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RENTHAL',
        id: 'renthal',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'STRONGLIGHT',
        id: 'stronglight',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'TA SPECIALISTS',
        id: 'ta-specialists',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'WIPPERMANN',
        id: 'wippermann',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
    ],
    name: 'Chainrings',
    id: 'Chainrings',
  },
  {
    subcategories: [
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'DXC',
        id: 'dxc',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'KMC',
        id: 'kmc',
        subcategories: [],
      },
      {
        name: 'MICHAEL',
        id: 'michael',
        subcategories: [],
      },
      {
        name: 'M-WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'VENTURA',
        id: 'ventura',
        subcategories: [],
      },
      {
        name: 'WIPPERMAN CONNEX',
        id: 'wipperman-connex',
        subcategories: [],
      },
      {
        name: 'YBN',
        id: 'ybn',
        subcategories: [],
      },
    ],
    name: 'Chains',
    id: 'Chains',
  },
  {
    subcategories: [
      {
        name: '3T',
        id: '3t',
        subcategories: [],
      },
      {
        name: '4IIII',
        id: '4iiii',
        subcategories: [],
      },
      {
        name: 'ALUGEAR',
        id: 'alugear',
        subcategories: [],
      },
      {
        name: 'BIKE SHIELD',
        id: 'bike-shield',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'DYEDBRO',
        id: 'dyedbro',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GARBARUK',
        id: 'garbaruk',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'INPEAK',
        id: 'inpeak',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'MICHE',
        id: 'miche',
        subcategories: [],
      },
      {
        name: 'MICROSHIFT',
        id: 'microshift',
        subcategories: [],
      },
      {
        name: 'M-WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'PRACTICE WORKS',
        id: 'practice-works',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'QUARQ',
        id: 'quarq',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'STAGES',
        id: 'stages',
        subcategories: [],
      },
      {
        name: 'SUNRACE',
        id: 'sunrace',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYSTEM EX',
        id: 'system-ex',
        subcategories: [],
      },
      {
        name: 'THM',
        id: 'thm',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'WHITE INDUSTRIES',
        id: 'white-industries',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Cranksets',
    id: 'Cranksets',
  },
  {
    subcategories: [
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'LT-WOO',
        id: 'lt-woo',
        subcategories: [],
      },
      {
        name: 'MICROSHIFT',
        id: 'microshift',
        subcategories: [],
      },
      {
        name: 'SENSAH EMPIRE',
        id: 'sensah-empire',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
    ],
    name: 'Derailleurs',
    id: 'Derailleurs',
  },
  {
    subcategories: [
      {
        name: '3T',
        id: '3t',
        subcategories: [],
      },
      {
        name: 'ALDO',
        id: 'aldo',
        subcategories: [],
      },
      {
        name: 'ALPINA',
        id: 'alpina',
        subcategories: [],
      },
      {
        name: 'ALTEC',
        id: 'altec',
        subcategories: [],
      },
      {
        name: 'ALTRA',
        id: 'altra',
        subcategories: [],
      },
      {
        name: 'APOLLO',
        id: 'apollo',
        subcategories: [],
      },
      {
        name: 'ARGON 18',
        id: 'argon-18',
        subcategories: [],
      },
      {
        name: 'ARGONAUT',
        id: 'argonaut',
        subcategories: [],
      },
      {
        name: 'ATLAS',
        id: 'atlas',
        subcategories: [],
      },
      {
        name: 'AURUM',
        id: 'aurum',
        subcategories: [],
      },
      {
        name: 'AVALON',
        id: 'avalon',
        subcategories: [],
      },
      {
        name: 'AVANTI',
        id: 'avanti',
        subcategories: [],
      },
      {
        name: 'AVANTIO',
        id: 'avantio',
        subcategories: [],
      },
      {
        name: 'AVON',
        id: 'avon',
        subcategories: [],
      },
      {
        name: 'AZOR',
        id: 'azor',
        subcategories: [],
      },
      {
        name: 'BARBIE',
        id: 'barbie',
        subcategories: [],
      },
      {
        name: 'BASSO',
        id: 'basso',
        subcategories: [],
      },
      {
        name: 'BASTION',
        id: 'bastion',
        subcategories: [],
      },
      {
        name: 'BATAVUS',
        id: 'batavus',
        subcategories: [],
      },
      {
        name: 'BATTAGLIN',
        id: 'battaglin',
        subcategories: [],
      },
      {
        name: 'BELLE',
        id: 'belle',
        subcategories: [],
      },
      {
        name: 'BERGAMONT',
        id: 'bergamont',
        subcategories: [],
      },
      {
        name: 'BH',
        id: 'bh',
        subcategories: [],
      },
      {
        name: 'BIANCHI',
        id: 'bianchi',
        subcategories: [],
      },
      {
        name: 'BIKKEL',
        id: 'bikkel',
        subcategories: [],
      },
      {
        name: 'BLUEY',
        id: 'bluey',
        subcategories: [],
      },
      {
        name: 'BMC',
        id: 'bmc',
        subcategories: [],
      },
      {
        name: 'BOARDMAN',
        id: 'boardman',
        subcategories: [],
      },
      {
        name: 'BOBIKE',
        id: 'bobike',
        subcategories: [],
      },
      {
        name: 'BOMBTRACK',
        id: 'bombtrack',
        subcategories: [],
      },
      {
        name: 'BOTTECCHIA',
        id: 'bottecchia',
        subcategories: [],
      },
      {
        name: 'BRINCKERS',
        id: 'brinckers',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BSA CYCLES',
        id: 'bsa-cycles',
        subcategories: [],
      },
      {
        name: 'BSP',
        id: 'bsp',
        subcategories: [],
      },
      {
        name: 'BT-WIN',
        id: 'bt-win',
        subcategories: [],
      },
      {
        name: 'CA GO BIKE',
        id: 'ca-go-bike',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CANYON',
        id: 'canyon',
        subcategories: [],
      },
      {
        name: 'CEEPO',
        id: 'ceepo',
        subcategories: [],
      },
      {
        name: 'CELL',
        id: 'cell',
        subcategories: [],
      },
      {
        name: 'CERVELO',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'CHAPTER 2',
        id: 'chapter-2',
        subcategories: [],
      },
      {
        name: 'CHARACTER',
        id: 'character',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'CIPOLLINI',
        id: 'cipollini',
        subcategories: [],
      },
      {
        name: 'CLAUD BUTLER',
        id: 'claud-butler',
        subcategories: [],
      },
      {
        name: 'COLNAGO',
        id: 'colnago',
        subcategories: [],
      },
      {
        name: 'CONDOR',
        id: 'condor',
        subcategories: [],
      },
      {
        name: 'CONVOLUTION',
        id: 'convolution',
        subcategories: [],
      },
      {
        name: 'CORRATEC',
        id: 'corratec',
        subcategories: [],
      },
      {
        name: 'CORTINA',
        id: 'cortina',
        subcategories: [],
      },
      {
        name: 'COSMIC',
        id: 'cosmic',
        subcategories: [],
      },
      {
        name: 'COTIC',
        id: 'cotic',
        subcategories: [],
      },
      {
        name: 'CRADIAC',
        id: 'cradiac',
        subcategories: [],
      },
      {
        name: 'CRÈME',
        id: 'creme',
        subcategories: [],
      },
      {
        name: 'CRUZEE',
        id: 'cruzee',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'CUMBERLAND',
        id: 'cumberland',
        subcategories: [],
      },
      {
        name: 'DAHON',
        id: 'dahon',
        subcategories: [],
      },
      {
        name: 'DARE',
        id: 'dare',
        subcategories: [],
      },
      {
        name: 'DARTMOOR BIKES',
        id: 'dartmoor-bikes',
        subcategories: [],
      },
      {
        name: 'DAWES',
        id: 'dawes',
        subcategories: [],
      },
      {
        name: 'DE ROSA',
        id: 'de-rosa',
        subcategories: [],
      },
      {
        name: 'DIAMANT',
        id: 'diamant',
        subcategories: [],
      },
      {
        name: 'DIVERSE',
        id: 'diverse',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'DOLAN',
        id: 'dolan',
        subcategories: [],
      },
      {
        name: 'DOSNOVENTA',
        id: 'dosnoventa',
        subcategories: [],
      },
      {
        name: 'EDDY MERCKX',
        id: 'eddy-merckx',
        subcategories: [],
      },
      {
        name: 'ELEMENT',
        id: 'element',
        subcategories: [],
      },
      {
        name: 'EMOTORAD',
        id: 'emotorad',
        subcategories: [],
      },
      {
        name: 'ENIGMA',
        id: 'enigma',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'EVO',
        id: 'evo',
        subcategories: [],
      },
      {
        name: 'FACTOR',
        id: 'factor',
        subcategories: [],
      },
      {
        name: 'FAIRLIGHT',
        id: 'fairlight',
        subcategories: [],
      },
      {
        name: 'FALCON',
        id: 'falcon',
        subcategories: [],
      },
      {
        name: 'FALKENJAGD',
        id: 'falkenjagd',
        subcategories: [],
      },
      {
        name: 'FANTOM',
        id: 'fantom',
        subcategories: [],
      },
      {
        name: 'FARA CYCLING',
        id: 'fara-cycling',
        subcategories: [],
      },
      {
        name: 'FELT',
        id: 'felt',
        subcategories: [],
      },
      {
        name: 'FESTKA',
        id: 'festka',
        subcategories: [],
      },
      {
        name: 'FIFTYONE',
        id: 'fiftyone',
        subcategories: [],
      },
      {
        name: 'FIREFOX',
        id: 'firefox',
        subcategories: [],
      },
      {
        name: 'FIT BIKE CO',
        id: 'fit-bike-co',
        subcategories: [],
      },
      {
        name: 'FLYER',
        id: 'flyer',
        subcategories: [],
      },
      {
        name: 'FOCUS',
        id: 'focus',
        subcategories: [],
      },
      {
        name: 'FOMAS',
        id: 'fomas',
        subcategories: [],
      },
      {
        name: 'FONDRIEST',
        id: 'fondriest',
        subcategories: [],
      },
      {
        name: 'FROG',
        id: 'frog',
        subcategories: [],
      },
      {
        name: 'FUJI',
        id: 'fuji',
        subcategories: [],
      },
      {
        name: 'GAZELLE',
        id: 'gazelle',
        subcategories: [],
      },
      {
        name: 'GENESIS',
        id: 'genesis',
        subcategories: [],
      },
      {
        name: 'GHOST',
        id: 'ghost',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'GITANE',
        id: 'gitane',
        subcategories: [],
      },
      {
        name: 'GRANVILLE',
        id: 'granville',
        subcategories: [],
      },
      {
        name: 'GT',
        id: 'gt',
        subcategories: [],
      },
      {
        name: 'HAIBIKE',
        id: 'haibike',
        subcategories: [],
      },
      {
        name: 'HERCULES',
        id: 'hercules',
        subcategories: [],
      },
      {
        name: 'HERO CYCLES',
        id: 'hero-cycles',
        subcategories: [],
      },
      {
        name: 'HERO LECTRO',
        id: 'hero-lectro',
        subcategories: [],
      },
      {
        name: 'HOLLANDIA',
        id: 'hollandia',
        subcategories: [],
      },
      {
        name: 'HP',
        id: 'hp',
        subcategories: [],
      },
      {
        name: 'HUGE',
        id: 'huge',
        subcategories: [],
      },
      {
        name: 'J.LAVERACK',
        id: 'jlaverack',
        subcategories: [],
      },
      {
        name: 'JAMIS',
        id: 'jamis',
        subcategories: [],
      },
      {
        name: 'JAVA',
        id: 'java',
        subcategories: [],
      },
      {
        name: 'JD BUG',
        id: 'jd-bug',
        subcategories: [],
      },
      {
        name: 'JOHNNY LOCO',
        id: 'johnny-loco',
        subcategories: [],
      },
      {
        name: 'KALKHOFF',
        id: 'kalkhoff',
        subcategories: [],
      },
      {
        name: 'KINESIS',
        id: 'kinesis',
        subcategories: [],
      },
      {
        name: 'KOGA',
        id: 'koga',
        subcategories: [],
      },
      {
        name: 'KONA',
        id: 'kona',
        subcategories: [],
      },
      {
        name: 'KTM',
        id: 'ktm',
        subcategories: [],
      },
      {
        name: 'KU',
        id: 'ku',
        subcategories: [],
      },
      {
        name: 'LAMBRETTA',
        id: 'lambretta',
        subcategories: [],
      },
      {
        name: 'LAPIERRE',
        id: 'lapierre',
        subcategories: [],
      },
      {
        name: 'LA-SOVEREIGN',
        id: 'la-sovereign',
        subcategories: [],
      },
      {
        name: 'LAUF',
        id: 'lauf',
        subcategories: [],
      },
      {
        name: 'LEADER',
        id: 'leader',
        subcategories: [],
      },
      {
        name: 'LEITNER',
        id: 'leitner',
        subcategories: [],
      },
      {
        name: 'LIV',
        id: 'liv',
        subcategories: [],
      },
      {
        name: 'LOEKIE',
        id: 'loekie',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'MACH CITY',
        id: 'mach-city',
        subcategories: [],
      },
      {
        name: 'MADD GEAR',
        id: 'madd-gear',
        subcategories: [],
      },
      {
        name: 'MALVERN STAR',
        id: 'malvern-star',
        subcategories: [],
      },
      {
        name: 'MARIN',
        id: 'marin',
        subcategories: [],
      },
      {
        name: 'MASON',
        id: 'mason',
        subcategories: [],
      },
      {
        name: 'MERIDA',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'MONGOOSE',
        id: 'mongoose',
        subcategories: [],
      },
      {
        name: 'MONTEGO',
        id: 'montego',
        subcategories: [],
      },
      {
        name: 'MONTRA',
        id: 'montra',
        subcategories: [],
      },
      {
        name: 'MOONRAKER',
        id: 'moonraker',
        subcategories: [],
      },
      {
        name: 'MOOTS',
        id: 'moots',
        subcategories: [],
      },
      {
        name: 'MUDDYFOX',
        id: 'muddyfox',
        subcategories: [],
      },
      {
        name: 'NORCO',
        id: 'norco',
        subcategories: [],
      },
      {
        name: 'NORTA',
        id: 'norta',
        subcategories: [],
      },
      {
        name: 'NS',
        id: 'ns',
        subcategories: [],
      },
      {
        name: 'NUZE',
        id: 'nuze',
        subcategories: [],
      },
      {
        name: 'OMO',
        id: 'omo',
        subcategories: [],
      },
      {
        name: 'OPEN',
        id: 'open',
        subcategories: [],
      },
      {
        name: 'ORBEA',
        id: 'orbea',
        subcategories: [],
      },
      {
        name: 'ORRO',
        id: 'orro',
        subcategories: [],
      },
      {
        name: 'OSTRICHOO',
        id: 'ostrichoo',
        subcategories: [],
      },
      {
        name: 'PACTO',
        id: 'pacto',
        subcategories: [],
      },
      {
        name: 'PARAPERA',
        id: 'parapera',
        subcategories: [],
      },
      {
        name: 'PARDUS',
        id: 'pardus',
        subcategories: [],
      },
      {
        name: 'PASHLEY',
        id: 'pashley',
        subcategories: [],
      },
      {
        name: 'PASSONI',
        id: 'passoni',
        subcategories: [],
      },
      {
        name: 'PEGASUS',
        id: 'pegasus',
        subcategories: [],
      },
      {
        name: 'PEUGEOT',
        id: 'peugeot',
        subcategories: [],
      },
      {
        name: 'PHEONIX',
        id: 'pheonix',
        subcategories: [],
      },
      {
        name: 'PINARELLO',
        id: 'pinarello',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'PLANET X',
        id: 'planet-x',
        subcategories: [],
      },
      {
        name: 'POINTER',
        id: 'pointer',
        subcategories: [],
      },
      {
        name: 'POLYGON',
        id: 'polygon',
        subcategories: [],
      },
      {
        name: 'POPAI',
        id: 'popai',
        subcategories: [],
      },
      {
        name: 'POPAL',
        id: 'popal',
        subcategories: [],
      },
      {
        name: 'POSST',
        id: 'posst',
        subcategories: [],
      },
      {
        name: 'PUCH',
        id: 'puch',
        subcategories: [],
      },
      {
        name: 'PUKY',
        id: 'puky',
        subcategories: [],
      },
      {
        name: 'PURE',
        id: 'pure',
        subcategories: [],
      },
      {
        name: 'QUIC',
        id: 'quic',
        subcategories: [],
      },
      {
        name: 'QWIC',
        id: 'qwic',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'RALEIGH',
        id: 'raleigh',
        subcategories: [],
      },
      {
        name: 'RASCAL',
        id: 'rascal',
        subcategories: [],
      },
      {
        name: 'REBEL KIDZ',
        id: 'rebel-kidz',
        subcategories: [],
      },
      {
        name: 'REID',
        id: 'reid',
        subcategories: [],
      },
      {
        name: 'REILLY',
        id: 'reilly',
        subcategories: [],
      },
      {
        name: 'RELIANCE',
        id: 'reliance',
        subcategories: [],
      },
      {
        name: 'RENNSTAHL',
        id: 'rennstahl',
        subcategories: [],
      },
      {
        name: 'RIBBLE',
        id: 'ribble',
        subcategories: [],
      },
      {
        name: 'RIDGEBACK',
        id: 'ridgeback',
        subcategories: [],
      },
      {
        name: 'RIDLEY',
        id: 'ridley',
        subcategories: [],
      },
      {
        name: 'RIESE AND MULLER',
        id: 'riese-and-muller',
        subcategories: [],
      },
      {
        name: 'ROCKFIRE',
        id: 'rockfire',
        subcategories: [],
      },
      {
        name: 'ROCKY MOUNTAIN',
        id: 'rocky-mountain',
        subcategories: [],
      },
      {
        name: 'RONDO',
        id: 'rondo',
        subcategories: [],
      },
      {
        name: 'ROSE',
        id: 'rose',
        subcategories: [],
      },
      {
        name: 'ROURKE',
        id: 'rourke',
        subcategories: [],
      },
      {
        name: 'SALSA',
        id: 'salsa',
        subcategories: [],
      },
      {
        name: 'SANTA CRUZ',
        id: 'santa-cruz',
        subcategories: [],
      },
      {
        name: 'SANTA FIXIE',
        id: 'santa-fixie',
        subcategories: [],
      },
      {
        name: 'SCHNELL',
        id: 'schnell',
        subcategories: [],
      },
      {
        name: 'SCHWINN',
        id: 'schwinn',
        subcategories: [],
      },
      {
        name: 'SCOR',
        id: 'scor',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SENSA',
        id: 'sensa',
        subcategories: [],
      },
      {
        name: 'SHOTGUN',
        id: 'shotgun',
        subcategories: [],
      },
      {
        name: 'SIMPLON',
        id: 'simplon',
        subcategories: [],
      },
      {
        name: 'SPARTA',
        id: 'sparta',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SPIRIT',
        id: 'spirit',
        subcategories: [],
      },
      {
        name: 'SPOON CUSTOMS',
        id: 'spoon-customs',
        subcategories: [],
      },
      {
        name: 'SQUISH',
        id: 'squish',
        subcategories: [],
      },
      {
        name: 'STANDERT',
        id: 'standert',
        subcategories: [],
      },
      {
        name: 'STELLA',
        id: 'stella',
        subcategories: [],
      },
      {
        name: 'STEVENS',
        id: 'stevens',
        subcategories: [],
      },
      {
        name: 'STUDIO',
        id: 'studio',
        subcategories: [],
      },
      {
        name: 'STURDY',
        id: 'sturdy',
        subcategories: [],
      },
      {
        name: 'SULLIVAN',
        id: 'sullivan',
        subcategories: [],
      },
      {
        name: 'SUNCROSS',
        id: 'suncross',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'S-WORKS',
        id: 's-works',
        subcategories: [],
      },
      {
        name: 'TERN',
        id: 'tern',
        subcategories: [],
      },
      {
        name: 'TIFOSI',
        id: 'tifosi',
        subcategories: [],
      },
      {
        name: 'TIME',
        id: 'time',
        subcategories: [],
      },
      {
        name: 'TOUT',
        id: 'tout',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRIAD',
        id: 'triad',
        subcategories: [],
      },
      {
        name: 'TRIFOX',
        id: 'trifox',
        subcategories: [],
      },
      {
        name: 'TWITTER',
        id: 'twitter',
        subcategories: [],
      },
      {
        name: 'UNION',
        id: 'union',
        subcategories: [],
      },
      {
        name: 'UNIROX',
        id: 'unirox',
        subcategories: [],
      },
      {
        name: 'UNITED',
        id: 'united',
        subcategories: [],
      },
      {
        name: 'URBAN TERRAIN',
        id: 'urban-terrain',
        subcategories: [],
      },
      {
        name: 'VAN NICHOLAS',
        id: 'van-nicholas',
        subcategories: [],
      },
      {
        name: 'VAN RYSEL',
        id: 'van-rysel',
        subcategories: [],
      },
      {
        name: 'VELOCE',
        id: 'veloce',
        subcategories: [],
      },
      {
        name: 'VIBE',
        id: 'vibe',
        subcategories: [],
      },
      {
        name: 'VICTORIA',
        id: 'victoria',
        subcategories: [],
      },
      {
        name: 'VIELO',
        id: 'vielo',
        subcategories: [],
      },
      {
        name: 'VOGUE',
        id: 'vogue',
        subcategories: [],
      },
      {
        name: 'WABI CYCLES',
        id: 'wabi-cycles',
        subcategories: [],
      },
      {
        name: 'WALTX',
        id: 'waltx',
        subcategories: [],
      },
      {
        name: 'WHYTE',
        id: 'whyte',
        subcategories: [],
      },
      {
        name: 'WILIER',
        id: 'wilier',
        subcategories: [],
      },
      {
        name: 'WINDSPACE',
        id: 'windspace',
        subcategories: [],
      },
      {
        name: 'XDS',
        id: 'xds',
        subcategories: [],
      },
      {
        name: 'YETI',
        id: 'yeti',
        subcategories: [],
      },
    ],
    name: 'Derailleur Hanger',
    id: 'Derailleur-Hanger',
  },
  {
    subcategories: [
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'CORIMA',
        id: 'corima',
        subcategories: [],
      },
      {
        name: 'ELITE',
        id: 'elite',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'ICE TOOLZ',
        id: 'ice-toolz',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'VELO ORANGE',
        id: 'velo-orange',
        subcategories: [],
      },
    ],
    name: 'Drivetrain Small Parts',
    id: 'Drivetrain-Small-Parts',
  },
  {
    subcategories: [
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'DEDA',
        id: 'deda',
        subcategories: [],
      },
      {
        name: 'DIVERSE',
        id: 'diverse',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'K-EDGE',
        id: 'k-edge',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'PROBLEM',
        id: 'problem',
        subcategories: [],
      },
      {
        name: 'PROFILE',
        id: 'profile',
        subcategories: [],
      },
      {
        name: 'SCOTT',
        id: 'scott',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Electronic Shifting Parts',
    id: 'Electronic-Shifting-Parts',
  },
  {
    subcategories: [
      {
        name: 'BGS TECHNIC',
        id: 'bgs-technic',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'COLUMBUS',
        id: 'columbus',
        subcategories: [],
      },
      {
        name: 'CULT',
        id: 'cult',
        subcategories: [],
      },
      {
        name: 'DEDA',
        id: 'deda',
        subcategories: [],
      },
      {
        name: 'DT',
        id: 'dt',
        subcategories: [],
      },
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'DVO',
        id: 'dvo',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'FORMULA',
        id: 'formula',
        subcategories: [],
      },
      {
        name: 'FOX',
        id: 'fox',
        subcategories: [],
      },
      {
        name: 'FOX RACING SHOX',
        id: 'fox-racing-shox',
        subcategories: [],
      },
      {
        name: 'INTEND',
        id: 'intend',
        subcategories: [],
      },
      {
        name: 'KATANA',
        id: 'katana',
        subcategories: [],
      },
      {
        name: 'M PART',
        id: 'm-part',
        subcategories: [],
      },
      {
        name: 'MANITOU',
        id: 'manitou',
        subcategories: [],
      },
      {
        name: 'MARZOCCHI',
        id: 'marzocchi',
        subcategories: [],
      },
      {
        name: 'MISSION',
        id: 'mission',
        subcategories: [],
      },
      {
        name: 'MOQUAI',
        id: 'moquai',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'ODYSSEY',
        id: 'odyssey',
        subcategories: [],
      },
      {
        name: 'OHLINS',
        id: 'ohlins',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'RST',
        id: 'rst',
        subcategories: [],
      },
      {
        name: 'SALSA',
        id: 'salsa',
        subcategories: [],
      },
      {
        name: 'SEIDO',
        id: 'seido',
        subcategories: [],
      },
      {
        name: 'SIMPLON',
        id: 'simplon',
        subcategories: [],
      },
      {
        name: 'SKF',
        id: 'skf',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SR',
        id: 'sr',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUNTOUR',
        id: 'suntour',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZOOM',
        id: 'zoom',
        subcategories: [],
      },
    ],
    name: 'Fork',
    id: 'Fork',
  },
  {
    subcategories: [],
    name: 'Gear Cables',
    id: 'Gear-Cables',
  },
  {
    subcategories: [],
    name: 'Gear Levers',
    id: 'Gear-Levers',
  },
  {
    subcategories: [
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROOKS',
        id: 'brooks',
        subcategories: [],
      },
      {
        name: 'CICLOVATION',
        id: 'ciclovation',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'COEFFICIENT',
        id: 'coefficient',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'EBON',
        id: 'ebon',
        subcategories: [],
      },
      {
        name: 'ERGOTEC',
        id: 'ergotec',
        subcategories: [],
      },
      {
        name: 'ESI GRIPS',
        id: 'esi-grips',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'MERIDA',
        id: 'merida',
        subcategories: [],
      },
      {
        name: 'PRO BIKE GEAR',
        id: 'pro-bike-gear',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'SALSA',
        id: 'salsa',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SUPACAZ',
        id: 'supacaz',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'WTB',
        id: 'wtb',
        subcategories: [],
      },
    ],
    name: 'Grips',
    id: 'Grips',
  },
  {
    // subcategories: [
    //   {
    //     name: 'CENTAUR',
    //     id: 'centaur',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'POTENZA',
    //     id: 'potenza',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'CHORUS',
    //     id: 'chorus',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'CHORUS H11 DISC',
    //     id: 'chorus-h11-disc',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'CHORUS EPS',
    //     id: 'chorus-eps',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'RECORD H11',
    //     id: 'record-h11',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'RECORD EPS 11 SPD',
    //     id: 'record-eps-11-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'RECORD 12 SPD',
    //     id: 'record-12-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'SUPER RECORD EPS 11 SPD',
    //     id: 'super-record-eps-11-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'SUPER RECORD 12 SPD',
    //     id: 'super-record-12-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'CUES',
    //     id: 'cues',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'TOURNEY',
    //     id: 'tourney',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'ALTUS',
    //     id: 'altus',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'ALIVIO',
    //     id: 'alivio',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'DEORE',
    //     id: 'deore',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'SLX',
    //     id: 'slx',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'XT',
    //     id: 'xt',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'XTR',
    //     id: 'xtr',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'CLARIS',
    //     id: 'claris',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'SORA',
    //     id: 'sora',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'TIAGRA',
    //     id: 'tiagra',
    //     subcategories: [],
    //   },
    //   {
    //     name: '105',
    //     id: '105',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'ULTEGRA',
    //     id: 'ultegra',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'DURA ACE',
    //     id: 'dura-ace',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'GRX 400',
    //     id: 'grx-400',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'GRX 600',
    //     id: 'grx-600',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'GRX 800',
    //     id: 'grx-800',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'SX EAGLE',
    //     id: 'sx-eagle',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'NX EAGLE',
    //     id: 'nx-eagle',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'GX EAGLE AXS',
    //     id: 'gx-eagle-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'X01 EAGLE AXS',
    //     id: 'x01-eagle-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'XX1 EAGLE AXS',
    //     id: 'xx1-eagle-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'APEX',
    //     id: 'apex',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'RIVAS ETAP AXS',
    //     id: 'rivas-etap-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'FORCE ETAP AXS',
    //     id: 'force-etap-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'RED ETAP AXS',
    //     id: 'red-etap-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'XPLR AXS',
    //     id: 'xplr-axs',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'ERX 12 SPD',
    //     id: 'erx-12-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'ERX ROAD 12 SPD',
    //     id: 'erx-road-12-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'GRT 12 SPD',
    //     id: 'grt-12-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'R7 10 SPD',
    //     id: 'r7-10-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'RP 11 SPD',
    //     id: 'rp-11-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'ERX ER9 12 SPD',
    //     id: 'erx-er9-12-spd',
    //     subcategories: [],
    //   },
    //   {
    //     name: 'GR9 11 SPD',
    //     id: 'gr9-11-spd',
    //     subcategories: [],
    //   },
    // ],
    subcategories: [
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [
          {
            name: 'CENTAUR',
            id: 'centaur',
            subcategories: [],
          },
          {
            name: 'POTENZA',
            id: 'potenza',
            subcategories: [],
          },
          {
            name: 'CHORUS',
            id: 'chorus',
            subcategories: [],
          },
          {
            name: 'CHORUS H11 DISC',
            id: 'chorus-h11-disc',
            subcategories: [],
          },
          {
            name: 'CHORUS EPS',
            id: 'chorus-eps',
            subcategories: [],
          },
          {
            name: 'RECORD H11',
            id: 'record-h11',
            subcategories: [],
          },
          {
            name: 'RECORD EPS 11 SPD',
            id: 'record-eps-11-spd',
            subcategories: [],
          },
          {
            name: 'RECORD 12 SPD',
            id: 'record-12-spd',
            subcategories: [],
          },
          {
            name: 'SUPER RECORD EPS 11 SPD',
            id: 'super-record-eps-11-spd',
            subcategories: [],
          },
          {
            name: 'SUPER RECORD 12 SPD',
            id: 'super-record-12-spd',
            subcategories: [],
          },
        ],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [
          {
            name: 'CUES',
            id: 'cues',
            subcategories: [],
          },
          {
            name: 'TOURNEY',
            id: 'tourney',
            subcategories: [],
          },
          {
            name: 'ALTUS',
            id: 'altus',
            subcategories: [],
          },
          {
            name: 'ALIVIO',
            id: 'alivio',
            subcategories: [],
          },
          {
            name: 'DEORE',
            id: 'deore',
            subcategories: [],
          },
          {
            name: 'SLX',
            id: 'slx',
            subcategories: [],
          },
          {
            name: 'XT',
            id: 'xt',
            subcategories: [],
          },
          {
            name: 'XTR',
            id: 'xtr',
            subcategories: [],
          },
          {
            name: 'CLARIS',
            id: 'claris',
            subcategories: [],
          },
          {
            name: 'SORA',
            id: 'sora',
            subcategories: [],
          },
          {
            name: 'TIAGRA',
            id: 'tiagra',
            subcategories: [],
          },
          {
            name: '105',
            id: '105',
            subcategories: [],
          },
          {
            name: 'ULTEGRA',
            id: 'ultegra',
            subcategories: [],
          },
          {
            name: 'DURA ACE',
            id: 'dura-ace',
            subcategories: [],
          },
          {
            name: 'GRX 400',
            id: 'grx-400',
            subcategories: [],
          },
          {
            name: 'GRX 600',
            id: 'grx-600',
            subcategories: [],
          },
          {
            name: 'GRX 800',
            id: 'grx-800',
            subcategories: [],
          },
        ],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [
          {
            name: 'SX EAGLE',
            id: 'sx-eagle',
            subcategories: [],
          },
          {
            name: 'NX EAGLE',
            id: 'nx-eagle',
            subcategories: [],
          },
          {
            name: 'GX EAGLE AXS',
            id: 'gx-eagle-axs',
            subcategories: [],
          },
          {
            name: 'X01 EAGLE AXS',
            id: 'x01-eagle-axs',
            subcategories: [],
          },
          {
            name: 'XX1 EAGLE AXS',
            id: 'xx1-eagle-axs',
            subcategories: [],
          },
          {
            name: 'APEX',
            id: 'apex',
            subcategories: [],
          },
          {
            name: 'RIVAS ETAP AXS',
            id: 'rivas-etap-axs',
            subcategories: [],
          },
          {
            name: 'FORCE ETAP AXS',
            id: 'force-etap-axs',
            subcategories: [],
          },
          {
            name: 'RED ETAP AXS',
            id: 'red-etap-axs',
            subcategories: [],
          },
          {
            name: 'XPLR AXS',
            id: 'xplr-axs',
            subcategories: [],
          },
        ],
      },
      {
        name: 'SENSAH EMPIRE',
        id: 'sensah_empire',
        subcategories: [
          {
            name: 'ERX 12 SPD',
            id: 'erx-12-spd',
            subcategories: [],
          },
          {
            name: 'ERX ROAD 12 SPD',
            id: 'erx-road-12-spd',
            subcategories: [],
          },
        ],
      },
      {
        name: 'LTWOO',
        id: 'ltwoo',
        subcategories: [
          {
            name: 'GRT 12 SPD',
            id: 'grt-12-spd',
            subcategories: [],
          },
          {
            name: 'R7 10 SPD',
            id: 'r7-10-spd',
            subcategories: [],
          },
          {
            name: 'RP 11 SPD',
            id: 'rp-11-spd',
            subcategories: [],
          },
          {
            name: 'ERX ER9 12 SPD',
            id: 'erx-er9-12-spd',
            subcategories: [],
          },
          {
            name: 'GR9 11 SPD',
            id: 'gr9-11-spd',
            subcategories: [],
          },
        ],
      },
    ],
    name: 'Groupset',
    id: 'Groupset-Model',
  },
  {
    subcategories: [
      {
        name: '3T',
        id: '3t',
        subcategories: [],
      },
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'ALIENATION',
        id: 'alienation',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BEAST COMPONENTS',
        id: 'beast-components',
        subcategories: [],
      },
      {
        name: 'BLB EQUIPMENT',
        id: 'blb-equipment',
        subcategories: [],
      },
      {
        name: 'BMC',
        id: 'bmc',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BURGTEC',
        id: 'burgtec',
        subcategories: [],
      },
      {
        name: 'CADEX',
        id: 'cadex',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CERVELO',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'CHAPTER2',
        id: 'chapter2',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'CLIF',
        id: 'clif',
        subcategories: [],
      },
      {
        name: 'COEFFICIENT',
        id: 'coefficient',
        subcategories: [],
      },
      {
        name: 'COLNAGO',
        id: 'colnago',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DARIMO',
        id: 'darimo',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'DXC',
        id: 'dxc',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'ERGOTEC',
        id: 'ergotec',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'EXTRALIFE',
        id: 'extralife',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'JONES',
        id: 'jones',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'LIGHTWEIGHT',
        id: 'lightweight',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'MOST',
        id: 'most',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'PER',
        id: 'per',
        subcategories: [],
      },
      {
        name: 'PINARELLO',
        id: 'pinarello',
        subcategories: [],
      },
      {
        name: 'PRIME CYCLING',
        id: 'prime-cycling',
        subcategories: [],
      },
      {
        name: 'PRO BIKE GEAR',
        id: 'pro-bike-gear',
        subcategories: [],
      },
      {
        name: 'PROFILE DESIGN',
        id: 'profile-design',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'REDSHIFT SPORTS',
        id: 'redshift-sports',
        subcategories: [],
      },
      {
        name: 'RENTHAL',
        id: 'renthal',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROVAL',
        id: 'roval',
        subcategories: [],
      },
      {
        name: 'SCHMOLKE',
        id: 'schmolke',
        subcategories: [],
      },
      {
        name: 'SDG',
        id: 'sdg',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SQ LAB',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'SYSTEM EX',
        id: 'system-ex',
        subcategories: [],
      },
      {
        name: 'THM',
        id: 'thm',
        subcategories: [],
      },
      {
        name: 'THOMSON',
        id: 'thomson',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'VAN NICHOLAS',
        id: 'van-nicholas',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Handlebars',
    id: 'Handlebars',
  },
  {
    subcategories: [
      {
        name: '3T',
        id: '3t',
        subcategories: [],
      },
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CICLOVATION',
        id: 'ciclovation',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'DARIMO',
        id: 'darimo',
        subcategories: [],
      },
      {
        name: 'DEDA',
        id: 'deda',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'K-EDGE',
        id: 'k-edge',
        subcategories: [],
      },
      {
        name: 'PRO BIKE GEAR',
        id: 'pro-bike-gear',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'VELO ORANGE',
        id: 'velo-orange',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Handlebar Spares',
    id: 'Handlebar-Spares',
  },
  {
    subcategories: [
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIKE HAND',
        id: 'bike-hand',
        subcategories: [],
      },
      {
        name: 'BLACK BEARING',
        id: 'black-bearing',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CEMA',
        id: 'cema',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'CHAPTER2',
        id: 'chapter2',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'COLNAGO',
        id: 'colnago',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'CORIMA',
        id: 'corima',
        subcategories: [],
      },
      {
        name: 'CYCLUS',
        id: 'cyclus',
        subcategories: [],
      },
      {
        name: 'DIA COMPE',
        id: 'dia-compe',
        subcategories: [],
      },
      {
        name: 'ENDURO',
        id: 'enduro',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'EXTRALITE',
        id: 'extralite',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'ICE TOOLZ',
        id: 'ice-toolz',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'MPART',
        id: 'mpart',
        subcategories: [],
      },
      {
        name: 'NTN',
        id: 'ntn',
        subcategories: [],
      },
      {
        name: 'PARL TOOL',
        id: 'parl-tool',
        subcategories: [],
      },
      {
        name: 'PINARELLO',
        id: 'pinarello',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'PRO BIKE GEAR',
        id: 'pro-bike-gear',
        subcategories: [],
      },
      {
        name: 'PROBLEM SOLVERS',
        id: 'problem-solvers',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'STANS NOTUBES',
        id: 'stans-notubes',
        subcategories: [],
      },
      {
        name: 'STRONGLIGHT',
        id: 'stronglight',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TANGESEIKI',
        id: 'tangeseiki',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRIPEAK',
        id: 'tripeak',
        subcategories: [],
      },
      {
        name: 'VAN NICHOLAS',
        id: 'van-nicholas',
        subcategories: [],
      },
      {
        name: 'VP COMPONENTS',
        id: 'vp-components',
        subcategories: [],
      },
      {
        name: 'WHEEL MFG',
        id: 'wheel-mfg',
        subcategories: [],
      },
      {
        name: 'WHITE INDUSTRIED',
        id: 'white-industried',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Headset & Bearings',
    id: 'Headset-And-Bearings',
  },
  {
    subcategories: [
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'C-BEAR',
        id: 'c-bear',
        subcategories: [],
      },
      {
        name: 'CEMA',
        id: 'cema',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'KOGEL',
        id: 'kogel',
        subcategories: [],
      },
      {
        name: 'LOXEAL',
        id: 'loxeal',
        subcategories: [],
      },
      {
        name: 'MOQUAI',
        id: 'moquai',
        subcategories: [],
      },
      {
        name: 'M-WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'NOVA RIDE',
        id: 'nova-ride',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPLIT SECOND',
        id: 'split-second',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'TRIPEAK',
        id: 'tripeak',
        subcategories: [],
      },
    ],
    name: 'OSPW',
    id: 'OSPW',
  },
  {
    subcategories: [],
    name: 'Oversized Pulleys',
    id: 'Oversized-Pulleys',
  },
  {
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BURGTEC',
        id: 'burgtec',
        subcategories: [],
      },
      {
        name: 'CHROMAG',
        id: 'chromag',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'ERGOTEC',
        id: 'ergotec',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'EXUSTAR',
        id: 'exustar',
        subcategories: [],
      },
      {
        name: 'FAVERO',
        id: 'favero',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'FUNN',
        id: 'funn',
        subcategories: [],
      },
      {
        name: 'GARMIN ',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'LIFELINE',
        id: 'lifeline',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'LOXEAL',
        id: 'loxeal',
        subcategories: [],
      },
      {
        name: 'M PART',
        id: 'm-part',
        subcategories: [],
      },
      {
        name: 'MAGPED',
        id: 'magped',
        subcategories: [],
      },
      {
        name: 'MKS',
        id: 'mks',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'NC-17',
        id: 'nc-17',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'NOW8',
        id: 'now8',
        subcategories: [],
      },
      {
        name: 'NUKEPROOF',
        id: 'nukeproof',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'POCKET PEDALS',
        id: 'pocket-pedals',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'RALEIGH',
        id: 'raleigh',
        subcategories: [],
      },
      {
        name: 'RENTHAL',
        id: 'renthal',
        subcategories: [],
      },
      {
        name: 'RESTRAP',
        id: 'restrap',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'SCADA',
        id: 'scada',
        subcategories: [],
      },
      {
        name: 'SDG',
        id: 'sdg',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SILCA',
        id: 'silca',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SUPACAZ',
        id: 'supacaz',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'SYSTEM EX',
        id: 'system-ex',
        subcategories: [],
      },
      {
        name: 'TATZE',
        id: 'tatze',
        subcategories: [],
      },
      {
        name: 'TIME',
        id: 'time',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'VP COMPONENTS',
        id: 'vp-components',
        subcategories: [],
      },
      {
        name: 'WAHOO',
        id: 'wahoo',
        subcategories: [],
      },
      {
        name: 'WELL GO',
        id: 'well-go',
        subcategories: [],
      },
      {
        name: 'XPEDO',
        id: 'xpedo',
        subcategories: [],
      },
      {
        name: 'ZEFAL',
        id: 'zefal',
        subcategories: [],
      },
    ],
    name: 'Pedals',
    id: 'Pedals',
  },
  {
    subcategories: [],
    name: 'Power Meters',
    id: 'Power-Meters',
  },
  {
    subcategories: [],
    name: 'Saddles',
    id: 'Saddles',
  },
  {
    subcategories: [
      {
        name: '3T',
        id: '3t',
        subcategories: [],
      },
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'ALIENATION',
        id: 'alienation',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BEAST COMPONENTS',
        id: 'beast-components',
        subcategories: [],
      },
      {
        name: 'BLB EQUIPMENT',
        id: 'blb-equipment',
        subcategories: [],
      },
      {
        name: 'BMC',
        id: 'bmc',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BURGTEC',
        id: 'burgtec',
        subcategories: [],
      },
      {
        name: 'CADEX',
        id: 'cadex',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CERVELO',
        id: 'cervelo',
        subcategories: [],
      },
      {
        name: 'CHAPTER2',
        id: 'chapter2',
        subcategories: [],
      },
      {
        name: 'CINELLI',
        id: 'cinelli',
        subcategories: [],
      },
      {
        name: 'CLIF',
        id: 'clif',
        subcategories: [],
      },
      {
        name: 'COEFFICIENT',
        id: 'coefficient',
        subcategories: [],
      },
      {
        name: 'COLNAGO',
        id: 'colnago',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DARIMO',
        id: 'darimo',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'DXC',
        id: 'dxc',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'ERGOTEC',
        id: 'ergotec',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'EXTRALIFE',
        id: 'extralife',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'JONES',
        id: 'jones',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'LIGHTWEIGHT',
        id: 'lightweight',
        subcategories: [],
      },
      {
        name: 'LOOK',
        id: 'look',
        subcategories: [],
      },
      {
        name: 'MOST',
        id: 'most',
        subcategories: [],
      },
      {
        name: 'MUDDY FOX',
        id: 'muddy-fox',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'PER',
        id: 'per',
        subcategories: [],
      },
      {
        name: 'PINARELLO',
        id: 'pinarello',
        subcategories: [],
      },
      {
        name: 'PRIME CYCLING',
        id: 'prime-cycling',
        subcategories: [],
      },
      {
        name: 'PRO BIKE GEAR',
        id: 'pro-bike-gear',
        subcategories: [],
      },
      {
        name: 'PROFILE DESIGN',
        id: 'profile-design',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'REDSHIFT SPORTS',
        id: 'redshift-sports',
        subcategories: [],
      },
      {
        name: 'RENTHAL',
        id: 'renthal',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROVAL',
        id: 'roval',
        subcategories: [],
      },
      {
        name: 'SCHMOLKE',
        id: 'schmolke',
        subcategories: [],
      },
      {
        name: 'SDG',
        id: 'sdg',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SQ LAB',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'SWORD',
        id: 'sword',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'SYSTEM EX',
        id: 'system-ex',
        subcategories: [],
      },
      {
        name: 'THM',
        id: 'thm',
        subcategories: [],
      },
      {
        name: 'THOMSON',
        id: 'thomson',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'TRUVATIVE',
        id: 'truvative',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'VAN NICHOLAS',
        id: 'van-nicholas',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Stems',
    id: 'Stems',
  },
  {
    subcategories: [
      {
        name: '45NRTH',
        id: '45nrth',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CADEX',
        id: 'cadex',
        subcategories: [],
      },
      {
        name: 'CHALLENGE',
        id: 'challenge',
        subcategories: [],
      },
      {
        name: 'CONTINENTAL',
        id: 'continental',
        subcategories: [],
      },
      {
        name: 'CUSHCORE',
        id: 'cushcore',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'ECLIPSE',
        id: 'eclipse',
        subcategories: [],
      },
      {
        name: 'EFFETTO MARIPOSA',
        id: 'effetto-mariposa',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'GOODYEAR',
        id: 'goodyear',
        subcategories: [],
      },
      {
        name: 'HUTCHINSON',
        id: 'hutchinson',
        subcategories: [],
      },
      {
        name: 'KENDA',
        id: 'kenda',
        subcategories: [],
      },
      {
        name: 'LEZYNE',
        id: 'lezyne',
        subcategories: [],
      },
      {
        name: 'LIFELINE',
        id: 'lifeline',
        subcategories: [],
      },
      {
        name: 'MAXXIS',
        id: 'maxxis',
        subcategories: [],
      },
      {
        name: 'MICHELIN',
        id: 'michelin',
        subcategories: [],
      },
      {
        name: 'MUC-OFF',
        id: 'muc-off',
        subcategories: [],
      },
      {
        name: 'NUTRAK',
        id: 'nutrak',
        subcategories: [],
      },
      {
        name: 'PANARACER',
        id: 'panaracer',
        subcategories: [],
      },
      {
        name: 'PARK',
        id: 'park',
        subcategories: [],
      },
      {
        name: 'PEATYS PRODUCTS',
        id: 'peatys-products',
        subcategories: [],
      },
      {
        name: 'PINNACLE',
        id: 'pinnacle',
        subcategories: [],
      },
      {
        name: 'PIRELLI',
        id: 'pirelli',
        subcategories: [],
      },
      {
        name: 'RALEIGH',
        id: 'raleigh',
        subcategories: [],
      },
      {
        name: 'SCHWALBE',
        id: 'schwalbe',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'STANS NO TUBES',
        id: 'stans-no-tubes',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'TERAVAIL',
        id: 'teravail',
        subcategories: [],
      },
      {
        name: 'TUBOLITO',
        id: 'tubolito',
        subcategories: [],
      },
      {
        name: 'TUFO',
        id: 'tufo',
        subcategories: [],
      },
      {
        name: 'ULTRA DYNAMICO',
        id: 'ultra-dynamico',
        subcategories: [],
      },
      {
        name: 'VELOFLEX',
        id: 'veloflex',
        subcategories: [],
      },
      {
        name: 'VITTORIA',
        id: 'vittoria',
        subcategories: [],
      },
      {
        name: 'VREDESTEIN',
        id: 'vredestein',
        subcategories: [],
      },
      {
        name: 'WTB',
        id: 'wtb',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Tyres',
    id: 'Tyres',
  },
  {
    subcategories: [
      {
        name: 'B&W',
        id: 'b-w',
        subcategories: [],
      },
      {
        name: 'BEAST COMPONENTS',
        id: 'beast-components',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CEMA',
        id: 'cema',
        subcategories: [],
      },
      {
        name: 'CITEC',
        id: 'citec',
        subcategories: [],
      },
      {
        name: 'CORIMA',
        id: 'corima',
        subcategories: [],
      },
      {
        name: 'CRANK BROTHERS',
        id: 'crank-brothers',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'EVOC',
        id: 'evoc',
        subcategories: [],
      },
      {
        name: 'FAST FORWARD',
        id: 'fast-forward',
        subcategories: [],
      },
      {
        name: 'FFWD',
        id: 'ffwd',
        subcategories: [],
      },
      {
        name: 'FOX RACING SHOX',
        id: 'fox-racing-shox',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'FULCRUM',
        id: 'fulcrum',
        subcategories: [],
      },
      {
        name: 'GARMIN',
        id: 'garmin',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'GRANITES',
        id: 'granites',
        subcategories: [],
      },
      {
        name: 'HALO',
        id: 'halo',
        subcategories: [],
      },
      {
        name: 'HED',
        id: 'hed',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'LIGHTWEIGHT',
        id: 'lightweight',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MICHE',
        id: 'miche',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'PRINCETON CARBONWORKS',
        id: 'princeton-carbonworks',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RESERVE',
        id: 'reserve',
        subcategories: [],
      },
      {
        name: 'ROVAL',
        id: 'roval',
        subcategories: [],
      },
      {
        name: 'SCHMOLKE',
        id: 'schmolke',
        subcategories: [],
      },
      {
        name: 'SHIMANO ',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'TOKEN',
        id: 'token',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'WINDSPACE',
        id: 'windspace',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Wheels',
    id: 'Wheels',
  },
  {
    subcategories: [],
    name: 'Wheelsets',
    id: 'Wheelsets',
  },
  {
    subcategories: [
      {
        name: 'ACROS',
        id: 'acros',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'CADEX',
        id: 'cadex',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'C-BEAR',
        id: 'c-bear',
        subcategories: [],
      },
      {
        name: 'CERAMIC SPEED',
        id: 'ceramic-speed',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'DIVERSE',
        id: 'diverse',
        subcategories: [],
      },
      {
        name: 'DT',
        id: 'dt',
        subcategories: [],
      },
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'DVO SUSPENSION',
        id: 'dvo-suspension',
        subcategories: [],
      },
      {
        name: 'ENDURO',
        id: 'enduro',
        subcategories: [],
      },
      {
        name: 'FOX FACTORY',
        id: 'fox-factory',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'FULCRUM',
        id: 'fulcrum',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'OHLINS',
        id: 'ohlins',
        subcategories: [],
      },
      {
        name: 'PRAXIS',
        id: 'praxis',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'ROCKY MOUNTAIN',
        id: 'rocky-mountain',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SIMPLON',
        id: 'simplon',
        subcategories: [],
      },
      {
        name: 'SKF',
        id: 'skf',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SR SUNTOUR',
        id: 'sr-suntour',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'STANS NO TUBES',
        id: 'stans-no-tubes',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'WHEELS MANUFACTURING',
        id: 'wheels-manufacturing',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Bearings',
    id: 'Bearings',
  },
  {
    subcategories: [
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BOYD CYCLING',
        id: 'boyd-cycling',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CARBON-TI',
        id: 'carbon-ti',
        subcategories: [],
      },
      {
        name: 'CHRIS KING',
        id: 'chris-king',
        subcategories: [],
      },
      {
        name: 'CORIMA',
        id: 'corima',
        subcategories: [],
      },
      {
        name: 'CYCLE TOOLS',
        id: 'cycle-tools',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'DT  SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'DXC',
        id: 'dxc',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'FSA',
        id: 'fsa',
        subcategories: [],
      },
      {
        name: 'FULCRUM',
        id: 'fulcrum',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MICHAEL',
        id: 'michael',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'NOVATEC',
        id: 'novatec',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PAUL COMPONENT',
        id: 'paul-component',
        subcategories: [],
      },
      {
        name: 'PEATYS PRODUCTS',
        id: 'peatys-products',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'RADON',
        id: 'radon',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'ROHLOFF',
        id: 'rohloff',
        subcategories: [],
      },
      {
        name: 'ROTOR',
        id: 'rotor',
        subcategories: [],
      },
      {
        name: 'SALT',
        id: 'salt',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SHUTTER PRECISION',
        id: 'shutter-precision',
        subcategories: [],
      },
      {
        name: 'SON',
        id: 'son',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'UNIOR ',
        id: 'unior',
        subcategories: [],
      },
      {
        name: 'VEL',
        id: 'vel',
        subcategories: [],
      },
      {
        name: 'VISION',
        id: 'vision',
        subcategories: [],
      },
      {
        name: 'WHITE INDUSTRIED',
        id: 'white-industried',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Hubs',
    id: 'Hubs',
  },
  {
    subcategories: [
      {
        name: 'BOMBTRACK CYCLING',
        id: 'bombtrack-cycling',
        subcategories: [],
      },
      {
        name: 'BOYD CYCLING',
        id: 'boyd-cycling',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CHRIS',
        id: 'chris',
        subcategories: [],
      },
      {
        name: 'DARTMOOR',
        id: 'dartmoor',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'DT',
        id: 'dt',
        subcategories: [],
      },
      {
        name: 'EXTRALITE',
        id: 'extralite',
        subcategories: [],
      },
      {
        name: 'FULCRUM',
        id: 'fulcrum',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'NOVATEC',
        id: 'novatec',
        subcategories: [],
      },
      {
        name: 'NOW',
        id: 'now',
        subcategories: [],
      },
      {
        name: 'PAUL',
        id: 'paul',
        subcategories: [],
      },
      {
        name: 'PROBLEM',
        id: 'problem',
        subcategories: [],
      },
      {
        name: 'RACE',
        id: 'race',
        subcategories: [],
      },
      {
        name: 'REVERSE',
        id: 'reverse',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROHLOFF',
        id: 'rohloff',
        subcategories: [],
      },
      {
        name: 'SCOPE',
        id: 'scope',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SHUTTER',
        id: 'shutter',
        subcategories: [],
      },
      {
        name: 'SON',
        id: 'son',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: "STAN'S",
        id: 'stans',
        subcategories: [],
      },
      {
        name: 'SUNRINGLÉ',
        id: 'sunringlé',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'TUNE',
        id: 'tune',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Hub Adaptors',
    id: 'Hub-Adaptors',
  },
  {
    subcategories: [
      {
        name: 'BEAST COMPONENTS',
        id: 'beast-components',
        subcategories: [],
      },
      {
        name: 'BOR GERMANY',
        id: 'bor-germany',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CHROMAG',
        id: 'chromag',
        subcategories: [],
      },
      {
        name: 'CRANKBROTHERS',
        id: 'crankbrothers',
        subcategories: [],
      },
      {
        name: 'DARTMOOR PARTS',
        id: 'dartmoor-parts',
        subcategories: [],
      },
      {
        name: 'DIVERSE',
        id: 'diverse',
        subcategories: [],
      },
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'DUKE RACING WHEELS',
        id: 'duke-racing-wheels',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'HALO',
        id: 'halo',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'MAVIC',
        id: 'mavic',
        subcategories: [],
      },
      {
        name: 'MCFK',
        id: 'mcfk',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'NS BIKES',
        id: 'ns-bikes',
        subcategories: [],
      },
      {
        name: 'RACE FACE',
        id: 'race-face',
        subcategories: [],
      },
      {
        name: 'REVERSE COMPONENTS',
        id: 'reverse-components',
        subcategories: [],
      },
      {
        name: 'RYDE',
        id: 'ryde',
        subcategories: [],
      },
      {
        name: 'SCHMOLKE CARBON',
        id: 'schmolke-carbon',
        subcategories: [],
      },
      {
        name: 'SPANK',
        id: 'spank',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'STANS NO TUBES',
        id: 'stans-no-tubes',
        subcategories: [],
      },
      {
        name: 'SURLY',
        id: 'surly',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'WTB',
        id: 'wtb',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Rims',
    id: 'Rims',
  },
  {
    subcategories: [
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'NEWMEN',
        id: 'newmen',
        subcategories: [],
      },
      {
        name: 'PILLAR RACING SPOKE',
        id: 'pillar-racing-spoke',
        subcategories: [],
      },
      {
        name: 'SAPIM',
        id: 'sapim',
        subcategories: [],
      },
    ],
    name: 'Spokes & Nipples',
    id: 'Spokes-And-Nipples',
  },
  {
    subcategories: [
      {
        name: 'ABSOLUTE BLACK',
        id: 'absolute-black',
        subcategories: [],
      },
      {
        name: 'ALLIGATOR',
        id: 'alligator',
        subcategories: [],
      },
      {
        name: 'AMP',
        id: 'amp',
        subcategories: [],
      },
      {
        name: 'ASHIMA',
        id: 'ashima',
        subcategories: [],
      },
      {
        name: 'AVID',
        id: 'avid',
        subcategories: [],
      },
      {
        name: 'AZTEC',
        id: 'aztec',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIRZMAN',
        id: 'birzman',
        subcategories: [],
      },
      {
        name: 'BLEEDKIT',
        id: 'bleedkit',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'CAMPAGNOLO',
        id: 'campagnolo',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'DIA COMPE',
        id: 'dia-compe',
        subcategories: [],
      },
      {
        name: 'DYNAMIC',
        id: 'dynamic',
        subcategories: [],
      },
      {
        name: 'FEW',
        id: 'few',
        subcategories: [],
      },
      {
        name: 'FIBRAX',
        id: 'fibrax',
        subcategories: [],
      },
      {
        name: 'FINISH LINE',
        id: 'finish-line',
        subcategories: [],
      },
      {
        name: 'HAYES',
        id: 'hayes',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'JAGWIRE',
        id: 'jagwire',
        subcategories: [],
      },
      {
        name: 'JUICE LUBES',
        id: 'juice-lubes',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'KOOL STOP',
        id: 'kool-stop',
        subcategories: [],
      },
      {
        name: 'MAGURA',
        id: 'magura',
        subcategories: [],
      },
      {
        name: 'MICROSHIFT',
        id: 'microshift',
        subcategories: [],
      },
      {
        name: 'OAK COMPONENTS',
        id: 'oak-components',
        subcategories: [],
      },
      {
        name: 'PARK TOOL',
        id: 'park-tool',
        subcategories: [],
      },
      {
        name: 'PRIME CYCLING',
        id: 'prime-cycling',
        subcategories: [],
      },
      {
        name: 'RALEIGH',
        id: 'raleigh',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SRAM',
        id: 'sram',
        subcategories: [],
      },
      {
        name: 'SWISSSTOP',
        id: 'swissstop',
        subcategories: [],
      },
      {
        name: 'TEKTRO',
        id: 'tektro',
        subcategories: [],
      },
      {
        name: 'TRP',
        id: 'trp',
        subcategories: [],
      },
      {
        name: 'VAR',
        id: 'var',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
    ],
    name: 'Brakes',
    id: 'Brakes',
  },
  {
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'BASIL',
        id: 'basil',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BERK COMPOSITES',
        id: 'berk-composites',
        subcategories: [],
      },
      {
        name: 'BIKEYOKE',
        id: 'bikeyoke',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BROOKS',
        id: 'brooks',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'CHROMAG',
        id: 'chromag',
        subcategories: [],
      },
      {
        name: 'CUBE',
        id: 'cube',
        subcategories: [],
      },
      {
        name: 'DMR',
        id: 'dmr',
        subcategories: [],
      },
      {
        name: 'ERGON',
        id: 'ergon',
        subcategories: [],
      },
      {
        name: 'FIZIK',
        id: 'fizik',
        subcategories: [],
      },
      {
        name: 'GIANT',
        id: 'giant',
        subcategories: [],
      },
      {
        name: 'ISM',
        id: 'ism',
        subcategories: [],
      },
      {
        name: 'LIV',
        id: 'liv',
        subcategories: [],
      },
      {
        name: 'M WAVE',
        id: 'm-wave',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'PROCRAFT',
        id: 'procraft',
        subcategories: [],
      },
      {
        name: 'PROFILE DESIGN',
        id: 'profile-design',
        subcategories: [],
      },
      {
        name: 'PROLOGO',
        id: 'prologo',
        subcategories: [],
      },
      {
        name: 'REFORM',
        id: 'reform',
        subcategories: [],
      },
      {
        name: 'SCHMOLKE CARBON',
        id: 'schmolke-carbon',
        subcategories: [],
      },
      {
        name: 'SDG',
        id: 'sdg',
        subcategories: [],
      },
      {
        name: 'SELLE ITALIA',
        id: 'selle-italia',
        subcategories: [],
      },
      {
        name: 'SELLE ROYAL',
        id: 'selle-royal',
        subcategories: [],
      },
      {
        name: 'SELLE SAN MARCO',
        id: 'selle-san-marco',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SQ LAB',
        id: 'sq-lab',
        subcategories: [],
      },
      {
        name: 'TERRY',
        id: 'terry',
        subcategories: [],
      },
      {
        name: 'VENTURE',
        id: 'venture',
        subcategories: [],
      },
      {
        name: 'WTB',
        id: 'wtb',
        subcategories: [],
      },
    ],
    name: 'Saddle',
    id: 'Saddle',
  },
  {
    subcategories: [
      {
        name: 'ACID',
        id: 'acid',
        subcategories: [],
      },
      {
        name: 'AIRWINGS',
        id: 'airwings',
        subcategories: [],
      },
      {
        name: 'BBB',
        id: 'bbb',
        subcategories: [],
      },
      {
        name: 'BIKEYOKE',
        id: 'bikeyoke',
        subcategories: [],
      },
      {
        name: 'BLB EQUIPMENT',
        id: 'blb-equipment',
        subcategories: [],
      },
      {
        name: 'BONTRAGER',
        id: 'bontrager',
        subcategories: [],
      },
      {
        name: 'BOSCH',
        id: 'bosch',
        subcategories: [],
      },
      {
        name: 'BROMPTON',
        id: 'brompton',
        subcategories: [],
      },
      {
        name: 'BURGTEC',
        id: 'burgtec',
        subcategories: [],
      },
      {
        name: 'CANE CREEK',
        id: 'cane-creek',
        subcategories: [],
      },
      {
        name: 'CANNONDALE',
        id: 'cannondale',
        subcategories: [],
      },
      {
        name: 'COLNAGO',
        id: 'colnago',
        subcategories: [],
      },
      {
        name: 'CONTROLTECH',
        id: 'controltech',
        subcategories: [],
      },
      {
        name: 'CRANK BROTHERS',
        id: 'crank-brothers',
        subcategories: [],
      },
      {
        name: 'DARIMO',
        id: 'darimo',
        subcategories: [],
      },
      {
        name: 'DEDA ELEMENTI',
        id: 'deda-elementi',
        subcategories: [],
      },
      {
        name: 'DT SWISS',
        id: 'dt-swiss',
        subcategories: [],
      },
      {
        name: 'EASTON',
        id: 'easton',
        subcategories: [],
      },
      {
        name: 'ENVE',
        id: 'enve',
        subcategories: [],
      },
      {
        name: 'ERGOTEC',
        id: 'ergotec',
        subcategories: [],
      },
      {
        name: 'ETHIRTEEN',
        id: 'ethirteen',
        subcategories: [],
      },
      {
        name: 'FOX',
        id: 'fox',
        subcategories: [],
      },
      {
        name: 'FOX FACTORY',
        id: 'fox-factory',
        subcategories: [],
      },
      {
        name: 'FOX RACING SHOX',
        id: 'fox-racing-shox',
        subcategories: [],
      },
      {
        name: 'HOPE',
        id: 'hope',
        subcategories: [],
      },
      {
        name: 'JAGWIRE',
        id: 'jagwire',
        subcategories: [],
      },
      {
        name: 'KCNC',
        id: 'kcnc',
        subcategories: [],
      },
      {
        name: 'KIND SHOCK',
        id: 'kind-shock',
        subcategories: [],
      },
      {
        name: 'M PART',
        id: 'm-part',
        subcategories: [],
      },
      {
        name: 'OAK COMPONENTS',
        id: 'oak-components',
        subcategories: [],
      },
      {
        name: 'PNW COMPONENTS',
        id: 'pnw-components',
        subcategories: [],
      },
      {
        name: 'PRO',
        id: 'pro',
        subcategories: [],
      },
      {
        name: 'QUAXAR',
        id: 'quaxar',
        subcategories: [],
      },
      {
        name: 'REDSHIFT SPORTS',
        id: 'redshift-sports',
        subcategories: [],
      },
      {
        name: 'RFR',
        id: 'rfr',
        subcategories: [],
      },
      {
        name: 'RITCHEY',
        id: 'ritchey',
        subcategories: [],
      },
      {
        name: 'ROCKSHOX',
        id: 'rockshox',
        subcategories: [],
      },
      {
        name: 'ROVAL',
        id: 'roval',
        subcategories: [],
      },
      {
        name: 'SHIMANO',
        id: 'shimano',
        subcategories: [],
      },
      {
        name: 'SPECIALIZED',
        id: 'specialized',
        subcategories: [],
      },
      {
        name: 'SUNTOUR',
        id: 'suntour',
        subcategories: [],
      },
      {
        name: 'SYNCROS',
        id: 'syncros',
        subcategories: [],
      },
      {
        name: 'SYNTACE',
        id: 'syntace',
        subcategories: [],
      },
      {
        name: 'THOMSON',
        id: 'thomson',
        subcategories: [],
      },
      {
        name: 'TREK',
        id: 'trek',
        subcategories: [],
      },
      {
        name: 'WOLF TOOTH COMPONENTS',
        id: 'wolf-tooth-components',
        subcategories: [],
      },
      {
        name: 'XLC',
        id: 'xlc',
        subcategories: [],
      },
      {
        name: 'ZIPP',
        id: 'zipp',
        subcategories: [],
      },
    ],
    name: 'Seatpost',
    id: 'Seatpost',
  },
];

///////////////////////////////////////////////////////////////////////
// Configurations related to listing types and transaction processes //
///////////////////////////////////////////////////////////////////////

// A presets of supported listing configurations
//
// Note 1: The listingTypes come from listingTypes asset nowadays by default.
//         To use this built-in configuration, you need to change the overwrite from configHelper.js
//         (E.g. use mergeDefaultTypesAndFieldsForDebugging func)
// Note 2: transaction type is part of listing type. It defines what transaction process and units
//         are used when transaction is created against a specific listing.

/**
 * Configuration options for listing experience:
 * - listingType:         Unique string. This will be saved to listing's public data on
 *                        EditListingWizard.
 * - label                Label for the listing type. Used as microcopy for options to select
 *                        listing type in EditListingWizard.
 * - transactionType      Set of configurations how this listing type will behave when transaction is
 *                        created.
 *   - process              Transaction process.
 *                          The process must match one of the processes that this client app can handle
 *                          (check src/util/transactions/transaction.js) and the process must also exists in correct
 *                          marketplace environment.
 *   - alias                Valid alias for the aforementioned process. This will be saved to listing's
 *                          public data as transctionProcessAlias and transaction is initiated with this.
 *   - unitType             Unit type is mainly used as pricing unit. This will be saved to
 *                          transaction's protected data.
 *                          Recommendation: don't use same unit types in completely different processes
 *                          ('item' sold should not be priced the same as 'item' booked).
 * - stockType            This is relevant only to listings using default-purchase process.
 *                        If set to 'oneItem', stock management is not showed and the listing is
 *                        considered unique (stock = 1).
 *                        Possible values: 'oneItem' and 'multipleItems'.
 *                        Default: 'multipleItems'.
 * - defaultListingFields These are tied to transaction processes. Different processes have different flags.
 *                        E.g. default-inquiry can toggle price and location to true/false value to indicate,
 *                        whether price (or location) tab should be shown. If defaultListingFields.price is not
 *                        explicitly set to _false_, price will be shown.
 *                        If the location or pickup is not used, listing won't be returned with location search.
 *                        Use keyword search as main search type if location is not enforced.
 *                        The payoutDetails flag allows provider to bypass setting of payout details.
 *                        Note: customers can't order listings, if provider has not set payout details! Monitor
 *                        providers who have not set payout details and contact them to ensure that they add the details.
 */

export const listingTypes = [
  {
    listingType: 'daily-booking',
    label: 'Daily booking',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
  // // Here are some examples for other listingTypes
  // // TODO: SearchPage does not work well if both booking and product selling are used at the same time
  // {
  //   listingType: 'nightly-booking',
  //   label: 'Nightly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'night',
  //   },
  // },
  // {
  //   listingType: 'hourly-booking',
  //   label: 'Hourly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'hour',
  //   },
  // },
  // {
  //   listingType: 'product-selling',
  //   label: 'Sell bicycles',
  //   transactionType: {
  //     process: 'default-purchase',
  //     alias: 'default-purchase/release-1',
  //     unitType: 'item',
  //   },
  //   stockType: 'multipleItems',
  //   defaultListingFields: {
  //     shipping: true,
  //     pickup: true,
  //     payoutDetails: true,
  //   },
  // },
  // {
  //   listingType: 'inquiry',
  //   label: 'Inquiry',
  //   transactionType: {
  //     process: 'default-inquiry',
  //     alias: 'default-inquiry/release-1',
  //     unitType: 'inquiry',
  //   },
  //   defaultListingFields: {
  //     price: false,
  //     location: true,
  //   },
  // },
];

// SearchPage can enforce listing query to only those listings with valid listingType
// However, it only works if you have set 'enum' type search schema for the public data fields
//   - listingType
//
//  Similar setup could be expanded to 2 other extended data fields:
//   - transactionProcessAlias
//   - unitType
//
// Read More:
// https://www.sharetribe.com/docs/how-to/manage-search-schemas-with-flex-cli/#adding-listing-search-schemas
export const enforceValidListingType = false;
